export const keywordPages = [
  {
    slugDe: "persoenliche-assistentin-zuerich",
    slugEn: "personal-assistant-zurich",
    service: "persoenliche-assistenz",
    de: {
      metaTitle: "Persönliche Assistentin Zürich gesucht? | Swiss PA Services",
      metaDesc: "Persönliche Assistentin in Zürich gesucht? Diskrete Unterstützung für Unternehmer & Familien: Termine, Reisen, Korrespondenz, Haushalt.",
      h1: "Persönliche Assistentin in Zürich gesucht?",
      h1Accent: "Flexibel, diskret und ohne Festanstellung",
      intro: [
        "Sie suchen eine persönliche Assistentin in Zürich – aber keine Festanstellung mit Lohnnebenkosten, sondern jemanden, der sofort anpackt? Genau dafür sind wir da: Swiss PA Services entlastet Unternehmer, Führungskräfte und Familien in der Stadt Zürich und am Zürichsee.",
        "Ob Terminmanagement, Reiseplanung, Korrespondenz oder die Koordination Ihres Haushalts: Sie erhalten eine feste Ansprechsperson, die Zürich kennt – vom Seefeld bis zum Zürichberg – und auf Deutsch und Englisch arbeitet. Vor Ort oder remote.",
      ],
      bullets: [
        "Termin- & Kalendermanagement auf Deutsch & Englisch",
        "Reiseplanung, Reservationen & Korrespondenz",
        "Persönliche Erledigungen in der Stadt Zürich",
        "Koordination von Haushalt, Handwerkern & Dienstleistern",
        "Absolute Diskretion – auf Wunsch mit NDA",
        "Flexible Stundenpakete statt Festanstellung",
      ],
      faq: [
        {
          q: "Was kostet eine persönliche Assistentin in Zürich?",
          a: "Deutlich weniger als eine Festanstellung: Wir arbeiten mit Stundenpaketen und monatlichen Mandaten – Sie zahlen nur die tatsächliche Unterstützung, ohne Lohnnebenkosten. Nach einem kostenlosen Erstgespräch erhalten Sie eine transparente Offerte.",
        },
        {
          q: "Wie schnell kann die Zusammenarbeit starten?",
          a: "In der Regel innert weniger Tage. Nach einem ersten Gespräch erstellen wir Ihren persönlichen Betreuungsplan und beginnen sofort mit den ersten Aufgaben.",
        },
      ],
    },
    en: {
      metaTitle: "Looking for a Personal Assistant in Zurich?",
      metaDesc: "Looking for a personal assistant in Zurich? Discreet support for entrepreneurs & families: diary, travel, correspondence, household.",
      h1: "Looking for a personal assistant in Zurich?",
      h1Accent: "Flexible, discreet and without permanent employment",
      intro: [
        "You are looking for a personal assistant in Zurich – but not a permanent hire with payroll costs, rather someone who gets started right away? That is exactly what we do: Swiss PA Services supports entrepreneurs, executives and families in the city of Zurich and on Lake Zurich.",
        "Whether diary management, travel planning, correspondence or coordinating your household: you get one dedicated contact who knows Zurich – from Seefeld to Zürichberg – and works in German and English. On site or remotely.",
      ],
      bullets: [
        "Diary & calendar management in German & English",
        "Travel planning, reservations & correspondence",
        "Personal errands in the city of Zurich",
        "Coordination of household, contractors & providers",
        "Absolute discretion – NDA on request",
        "Flexible hour packages instead of employment",
      ],
      faq: [
        {
          q: "What does a personal assistant in Zurich cost?",
          a: "Significantly less than a permanent hire: we work with hour packages and monthly mandates – you only pay for actual support, no payroll costs. After a free initial consultation you receive a transparent quote.",
        },
        {
          q: "How quickly can we start?",
          a: "Usually within a few days. After a first conversation we create your personal support plan and immediately begin with the first tasks.",
        },
      ],
    },
  },
  {
    slugDe: "persoenliche-assistentin-zug",
    slugEn: "personal-assistant-zug",
    service: "persoenliche-assistenz",
    de: {
      metaTitle: "Persönliche Assistentin Zug gesucht? | Swiss PA Services",
      metaDesc: "Persönliche Assistentin in Zug gesucht? Entlastung für Unternehmer, Crypto-Valley-Gründer & Familien: Termine, Reisen, Behörden, Alltag.",
      h1: "Persönliche Assistentin in Zug gesucht?",
      h1Accent: "Ihre rechte Hand im Kanton Zug",
      intro: [
        "Zug arbeitet schnell – Unternehmer, Gründer und internationale Fachkräfte haben wenig Zeit für den Alltag. Wenn Sie eine persönliche Assistentin in Zug suchen, sind wir nur Minuten entfernt: unser Sitz ist an der Baarerstrasse 43, mitten in Zug.",
        "Wir übernehmen Termine, Korrespondenz, Reiseplanung, Behördengänge und die Organisation Ihres Privatalltags – persönlich vor Ort oder remote, auf Deutsch und Englisch. Viele unserer Kunden kommen aus dem Crypto Valley und internationalen Firmen.",
      ],
      bullets: [
        "Termin-, E-Mail- & Kalendermanagement",
        "Behördengänge & Erledigungen im Kanton Zug",
        "Reiseplanung & Restaurantreservationen",
        "Haushalts- & Dienstleisterkoordination",
        "Schnittstelle zu Family Office & Beratern",
        "Vor Ort in Zug oder remote – ohne Anstellung",
      ],
      faq: [
        {
          q: "Arbeiten Sie auch für internationale Kunden ohne Deutschkenntnisse?",
          a: "Ja, ein grosser Teil unserer Zuger Kunden ist international. Wir arbeiten auf Englisch und Deutsch und übernehmen auch die Kommunikation mit Behörden und Dienstleistern für Sie.",
        },
        {
          q: "Was kostet eine persönliche Assistentin in Zug?",
          a: "Wir arbeiten mit flexiblen Stundenpaketen und monatlichen Mandaten – günstiger als jede Festanstellung. Nach einem kostenlosen Erstgespräch erhalten Sie eine transparente Offerte.",
        },
      ],
    },
    en: {
      metaTitle: "Personal Assistant Zug | Swiss PA Services",
      metaDesc: "Personal assistant in Zug for entrepreneurs, Crypto Valley founders & families: diary, travel, authorities, daily life – based at Baarerstrasse 43.",
      h1: "Looking for a personal assistant in Zug?",
      h1Accent: "Your right hand in the canton of Zug",
      intro: [
        "Zug works fast – entrepreneurs, founders and international professionals have little time for everyday life. If you are looking for a personal assistant in Zug, we are only minutes away: our base is at Baarerstrasse 43, right in Zug.",
        "We take over appointments, correspondence, travel planning, authority errands and the organisation of your private life – in person or remotely, in German and English. Many of our clients come from the Crypto Valley and international companies.",
      ],
      bullets: [
        "Diary, email & calendar management",
        "Authority errands & tasks in the canton of Zug",
        "Travel planning & restaurant reservations",
        "Household & service provider coordination",
        "Interface to family office & advisers",
        "On site in Zug or remote – no employment",
      ],
      faq: [
        {
          q: "Do you also work for international clients without German skills?",
          a: "Yes, a large part of our Zug clients are international. We work in English and German and also handle communication with authorities and service providers for you.",
        },
        {
          q: "What does a personal assistant in Zug cost?",
          a: "We work with flexible hour packages and monthly mandates – cheaper than any permanent hire. After a free initial consultation you receive a transparent quote.",
        },
      ],
    },
  },
  {
    slugDe: "ferienhausverwaltung-schweiz",
    slugEn: "vacation-home-management-switzerland",
    service: "home-property-management",
    de: {
      metaTitle: "Ferienhausverwaltung Schweiz | Swiss PA Services",
      metaDesc: "Ferienhausverwaltung in der Schweiz ohne Vermietung: Home-Watch-Kontrollen, Handwerkerkoordination.",
      h1: "Ferienhausverwaltung in der Schweiz",
      h1Accent: "Private Betreuung statt Vermietungsagentur",
      intro: [
        "Die meisten Ferienhausverwaltungen in der Schweiz wollen eines: Ihre Immobilie vermieten. Wir sind bewusst anders: Swiss PA Services betreut Ihr Ferienhaus ausschliesslich für Sie – privat, diskret und ohne Fremdbelegung.",
        "Ob Chalet in den Alpen, Haus am Zürichsee oder Wohnung in der Zentralschweiz: Wir kontrollieren regelmässig, koordinieren Handwerker und Gärtner, verwalten Ihre Schlüssel und bereiten alles vor, bevor Sie anreisen. Sie kommen an und geniessen – wir kümmern uns um den Rest.",
      ],
      bullets: [
        "Regelmässige Home-Watch-Kontrollgänge mit Foto-Protokoll",
        "Schlüsselverwaltung & Zutrittsorganisation",
        "Koordination von Handwerkern, Gärtnern & Reinigung",
        "Einwintern, Frühlingsstart & Saisonvorbereitung",
        "Vorbereitung vor Ihrer Ankunft: Heizung, Vorräte, Wäsche",
        "Keine Vermietung – Ihr Ferienhaus bleibt privat",
      ],
      faq: [
        {
          q: "Vermieten Sie mein Ferienhaus auch?",
          a: "Nein – und das ist bewusst so. Wir sind keine Vermietungsagentur, sondern betreuen Ihre Immobilie ausschliesslich in Ihrem Interesse: Werterhalt, Sicherheit und Bereitschaft für Ihre Aufenthalte.",
        },
        {
          q: "In welchen Regionen betreuen Sie Ferienhäuser?",
          a: "Schwerpunkt ist die Zentralschweiz und der Zürichsee: Kantone Zug, Zürich, Schwyz, Luzern und die Höfe-Region. Andere Regionen auf Anfrage.",
        },
      ],
    },
    en: {
      metaTitle: "Vacation Home Management Switzerland | Swiss PA Services",
      metaDesc: "Vacation home management in Switzerland without rentals: home watch inspections, contractor coordination.",
      h1: "Vacation home management in Switzerland",
      h1Accent: "Private care instead of a rental agency",
      intro: [
        "Most vacation home managers in Switzerland want one thing: to rent out your property. We are deliberately different: Swiss PA Services looks after your holiday home exclusively for you – privately, discreetly and without third-party occupancy.",
        "Whether a chalet in the Alps, a house on Lake Zurich or an apartment in Central Switzerland: we inspect regularly, coordinate contractors and gardeners, manage your keys and prepare everything before you arrive. You arrive and relax – we handle the rest.",
      ],
      bullets: [
        "Regular home watch inspections with photo reports",
        "Key holding & access organisation",
        "Coordination of contractors, gardeners & cleaning",
        "Winterising, spring opening & seasonal preparation",
        "Preparation before arrival: heating, supplies, linen",
        "No rentals – your holiday home stays private",
      ],
      faq: [
        {
          q: "Do you also rent out my holiday home?",
          a: "No – and that is deliberate. We are not a rental agency; we look after your property exclusively in your interest: value preservation, security and readiness for your stays.",
        },
        {
          q: "In which regions do you manage holiday homes?",
          a: "Our focus is Central Switzerland and Lake Zurich: cantons of Zug, Zurich, Schwyz, Lucerne and the Höfe region. Other regions on request.",
        },
      ],
    },
  },
  {
    slugDe: "ferienhausverwaltung-zuerichsee",
    slugEn: "vacation-home-management-lake-zurich",
    service: "home-property-management",
    de: {
      metaTitle: "Ferienhausverwaltung Zürichsee | Swiss PA Services",
      metaDesc: "Ferienhausverwaltung am Zürichsee: Betreuung von Ferienhäusern und Zweitwohnsitzen in Küsnacht, Meilen, Herrliberg, Rapperswil & Umgebung.",
      h1: "Ferienhausverwaltung am Zürichsee",
      h1Accent: "Von Küsnacht bis Rapperswil – Ihr Haus in besten Händen",
      intro: [
        "Der Zürichsee ist eine der begehrtesten Lagen der Schweiz – und viele Häuser am See sind Zweit- oder Ferienwohnsitze, die wochenlang leer stehen. Unsere Ferienhausverwaltung am Zürichsee hält Ihre Liegenschaft sicher, gepflegt und jederzeit bereit.",
        "Wir betreuen Objekte an der Goldküste (Küsnacht, Zollikon, Meilen, Herrliberg) ebenso wie am linken Seeufer und in Rapperswil: regelmässige Kontrollgänge, Handwerkerkoordination und die komplette Vorbereitung vor Ihrer Ankunft.",
      ],
      bullets: [
        "Home-Watch-Kontrollen entlang des ganzen Zürichsees",
        "Betreuung von Ferienhäusern & Zweitwohnsitzen",
        "Schlüsselverwaltung & Notfallbereitschaft",
        "Garten-, Bootsschuppen- & Aussenbereichspflege",
        "Koordination von Reinigung & Hauspersonal",
        "Foto-Reporting nach jedem Kontrollgang",
      ],
      faq: [
        {
          q: "Betreuen Sie auch Liegenschaften mit Boot oder Steg?",
          a: "Ja. Gerade am See gehören Bootsschuppen, Steg und Aussenanlagen dazu. Wir kontrollieren und koordinieren auch diese Bereiche – inklusive saisonaler Vorbereitung.",
        },
        {
          q: "Wie oft kontrollieren Sie mein Haus?",
          a: "Nach Vereinbarung: wöchentlich oder vierzehntägig, bei Sturm- oder Frostwarnungen auch zusätzlich. Sie erhalten nach jedem Kontrollgang ein Foto-Protokoll.",
        },
      ],
    },
    en: {
      metaTitle: "Vacation Home Management Lake Zurich | Swiss PA Services",
      metaDesc: "Vacation home management on Lake Zurich: care of holiday homes and second residences in Küsnacht, Meilen, Herrliberg, Rapperswil & surroundings.",
      h1: "Vacation home management on Lake Zurich",
      h1Accent: "From Küsnacht to Rapperswil – your home in the best hands",
      intro: [
        "Lake Zurich is one of Switzerland's most desirable locations – and many houses on the lake are second or holiday homes that stand empty for weeks. Our vacation home management on Lake Zurich keeps your property safe, well-kept and always ready.",
        "We look after properties on the Gold Coast (Küsnacht, Zollikon, Meilen, Herrliberg) as well as on the left shore and in Rapperswil: regular inspections, contractor coordination and complete preparation before your arrival.",
      ],
      bullets: [
        "Home watch inspections along the entire lake",
        "Care of holiday homes & second residences",
        "Key holding & emergency response",
        "Garden, boathouse & outdoor area care",
        "Coordination of cleaning & household staff",
        "Photo report after every inspection",
      ],
      faq: [
        {
          q: "Do you also manage properties with a boat or jetty?",
          a: "Yes. On the lake, boathouses, jetties and outdoor areas are part of it. We inspect and coordinate these areas too – including seasonal preparation.",
        },
        {
          q: "How often do you inspect my house?",
          a: "By agreement: weekly or bi-weekly, and additionally during storm or frost warnings. You receive a photo report after every inspection.",
        },
      ],
    },
  },
  {
    slugDe: "virtuelle-assistenz-schweiz",
    slugEn: "virtual-assistant-switzerland",
    service: "persoenliche-assistenz",
    de: {
      metaTitle: "Virtuelle Assistenz Schweiz | Swiss PA Services",
      metaDesc: "Virtuelle Assistenz aus der Schweiz: E-Mail- & Kalendermanagement, Research, Dokumente und Kundenkommunikation.",
      h1: "Virtuelle Assistenz aus der Schweiz",
      h1Accent: "Schweizer Qualität, remote geliefert",
      intro: [
        "Eine virtuelle Assistenz entlastet Sie im Tagesgeschäft – ganz ohne Büroplatz und Anstellung. Im Gegensatz zu Offshore-Assistenten arbeiten wir in Ihrer Zeitzone, auf Deutsch und Englisch, und kennen Schweizer Gepflogenheiten, Behörden und Geschäftspraxis.",
        "Swiss PA Services unterstützt Unternehmer, KMU und Privatpersonen in der ganzen Schweiz remote: von E-Mail- und Kalendermanagement über Research und Dokumentenarbeit bis zur Kundenkommunikation.",
      ],
      bullets: [
        "E-Mail- & Kalendermanagement remote",
        "Research, Dokumente & Präsentationen",
        "Korrespondenz auf Deutsch & Englisch",
        "Reiseplanung & Reservationen",
        "Buchhaltungs-Vorbereitung & Belegorganisation",
        "Schweizer Zeitzone, Schweizer Qualität, nDSG-konform",
      ],
      faq: [
        {
          q: "Was kostet eine virtuelle Assistenz in der Schweiz?",
          a: "Wir arbeiten mit Stundenpaketen und monatlichen Mandaten – Sie zahlen nur produktive Arbeitszeit, ohne Anstellung und Fixkosten. Nach einem kostenlosen Erstgespräch erhalten Sie eine transparente Offerte.",
        },
        {
          q: "Wie funktioniert die Zusammenarbeit remote?",
          a: "Per E-Mail, Telefon, Video-Call und geteilten Tools (z.B. Kalender, Aufgabenlisten). Nach einer kurzen Einarbeitung läuft alles selbstverständlich – als hätten Sie eine Assistentin im Nachbarbüro.",
        },
      ],
    },
    en: {
      metaTitle: "Virtual Assistant Switzerland | Swiss PA Services",
      metaDesc: "Virtual assistant from Switzerland: email & diary management, research, documents and client communication.",
      h1: "Virtual assistant from Switzerland",
      h1Accent: "Swiss quality, delivered remotely",
      intro: [
        "A virtual assistant takes the load off your daily business – with no desk and no employment. Unlike offshore assistants, we work in your time zone, in German and English, and know Swiss customs, authorities and business practice.",
        "Swiss PA Services supports entrepreneurs, SMEs and private individuals across Switzerland remotely: from email and calendar management to research, document work and client communication.",
      ],
      bullets: [
        "Email & calendar management, fully remote",
        "Research, documents & presentations",
        "Correspondence in German & English",
        "Travel planning & reservations",
        "Bookkeeping preparation & receipt organisation",
        "Swiss time zone, Swiss quality, nDSG compliant",
      ],
      faq: [
        {
          q: "What does a virtual assistant in Switzerland cost?",
          a: "We work with hour packages and monthly mandates – you pay only for productive work time, no employment or fixed costs. After a free initial consultation you receive a transparent quote.",
        },
        {
          q: "How does remote cooperation work?",
          a: "Via email, phone, video calls and shared tools (e.g. calendars, task lists). After a short onboarding everything runs naturally – as if you had an assistant in the next office.",
        },
      ],
    },
  },
  {
    slugDe: "wohnungssuche-zuerich-hilfe",
    slugEn: "apartment-search-help-zurich",
    service: "relocation-services-schweiz",
    de: {
      metaTitle: "Wohnungssuche Zürich: Hilfe vom Profi | Swiss PA Services",
      metaDesc: "Hilfe bei der Wohnungssuche in Zürich: Off-Market-Zugang, perfektes Bewerbungsdossier und begleitete Besichtigungen – trotz Leerstandsquote unter 0,1%.",
      h1: "Hilfe bei der Wohnungssuche in Zürich",
      h1Accent: "Wir finden Ihre Wohnung – trotz leerem Markt",
      intro: [
        "Die Wohnungssuche in Zürich ist frustrierend: Leerstandsquote praktisch null, Dutzende Bewerbungen pro Inserat, Absagen ohne Antwort. Wer beruflich einsteht oder aus dem Ausland kommt, hat ohne lokale Hilfe kaum eine Chance.",
        "Unser Wohnungssuche-Service für Zürich dreht das Spiel: Wir hören von Objekten, bevor sie ausgeschrieben werden, erstellen Ihr Bewerbungsdossier professionell auf Deutsch und begleiten Sie zu Besichtigungen – bis der Mietvertrag unterschrieben ist.",
      ],
      bullets: [
        "Off-Market-Zugang über unser Zürcher Netzwerk",
        "Professionelles Bewerbungsdossier auf Deutsch",
        "Sofort-Alerts & blitzschnelle Bewerbungen",
        "Begleitete Besichtigungen – auch für Sie vor Ort",
        "Mietvertragsprüfung & Wohnungsübergabe",
        "Temporäre Wohnlösung für die Übergangszeit",
      ],
      faq: [
        {
          q: "Wie lange dauert die Wohnungssuche mit Ihrer Hilfe?",
          a: "Erfahrungsgemäss 2–6 Wochen, je nach Budget und Anforderungen. Durch unser Netzwerk und die professionelle Vorbereitung verkürzen wir die Suche deutlich gegenüber der Eigenrecherche.",
        },
        {
          q: "Was kostet der Wohnungssuche-Service?",
          a: "Das hängt vom Umfang ab – von der reinen Dossier-Erstellung bis zur Komplett-Suche mit Besichtigungen. Nach einem kostenlosen Erstgespräch erhalten Sie eine transparente Offerte.",
        },
      ],
    },
    en: {
      metaTitle: "Apartment Search Help Zurich | Swiss PA Services",
      metaDesc: "Help with the apartment search in Zurich: off-market access, a perfect application dossier and accompanied viewings – despite a vacancy rate below 0.1%.",
      h1: "Help with the apartment search in Zurich",
      h1Accent: "We find your home – despite an empty market",
      intro: [
        "Searching for an apartment in Zurich is frustrating: vacancy practically zero, dozens of applications per listing, rejections without response. If you work full-time or arrive from abroad, you stand little chance without local help.",
        "Our apartment search service for Zurich turns the game around: we hear about properties before they are listed, prepare your application dossier professionally in German and accompany you to viewings – until the lease is signed.",
      ],
      bullets: [
        "Off-market access through our Zurich network",
        "Professional application dossier in German",
        "Instant alerts & lightning-fast applications",
        "Accompanied viewings – on site for you",
        "Lease review & apartment handover",
        "Temporary housing for the transition period",
      ],
      faq: [
        {
          q: "How long does the apartment search take with your help?",
          a: "Typically 2–6 weeks, depending on budget and requirements. Through our network and professional preparation we shorten the search significantly compared to searching alone.",
        },
        {
          q: "What does the apartment search service cost?",
          a: "It depends on the scope – from dossier preparation only to a complete search with viewings. After a free initial consultation you receive a transparent quote.",
        },
      ],
    },
  },
  {
    slugDe: "executive-assistant-zuerich",
    slugEn: "executive-assistant-zurich",
    service: "executive-family-assistance",
    de: {
      metaTitle: "Executive Assistant Zürich | Swiss PA Services",
      metaDesc: "Executive Assistant in Zürich für CEOs, Verwaltungsräte und Unternehmer: Agenda, Reisen, Board-Support und Projektkoordination.",
      h1: "Executive Assistant in Zürich",
      h1Accent: "C-Level-Unterstützung, wann immer Sie sie brauchen",
      intro: [
        "Sie brauchen Executive-Assistant-Unterstützung auf höchstem Niveau – aber nicht in Vollzeit? Swiss PA Services bietet erfahrene C-Level-Assistenz für CEOs, Verwaltungsräte und Unternehmer in Zürich: auf Abruf, ad interim oder als laufendes Mandat.",
        "Von Agenda- und Reisemanagement über Board-Vorbereitung bis zur Koordination vertraulicher Projekte: Wir arbeiten auf Deutsch und Englisch, sind in Zürich vor Ort und handeln, bevor Sie fragen.",
      ],
      bullets: [
        "Agenda-, Reise- & Meetingmanagement auf C-Level",
        "Board- & Gremienunterstützung, Protokolle",
        "Vertrauliche Projektkoordination",
        "Korrespondenz auf Deutsch & Englisch",
        "Ad-interim-Vertretung Ihrer Assistenz",
        "Ohne Festanstellung – flexibel skalierbar",
      ],
      faq: [
        {
          q: "Springen Sie auch kurzfristig ad interim ein?",
          a: "Ja. Ob Ferienvertretung, Vakanz oder ein zeitkritisches Projekt – wir übernehmen erfahrene Executive-Unterstützung auch kurzfristig, damit bei Ihnen nichts liegen bleibt.",
        },
        {
          q: "Wie wird Vertraulichkeit sichergestellt?",
          a: "Diskretion ist die Basis unserer Arbeit. Auf Wunsch arbeiten wir mit Verschwiegenheitserklärungen (NDA), und sensible Informationen bleiben bei einer festen Ansprechsperson.",
        },
      ],
    },
    en: {
      metaTitle: "Executive Assistant Zurich | Swiss PA Services",
      metaDesc: "Executive assistant in Zurich for CEOs, board members and entrepreneurs: diary, travel, board support and project coordination.",
      h1: "Executive assistant in Zurich",
      h1Accent: "C-level support, whenever you need it",
      intro: [
        "You need executive assistant support at the highest level – but not full-time? Swiss PA Services offers experienced C-level assistance for CEOs, board members and entrepreneurs in Zurich: on demand, ad interim or as an ongoing mandate.",
        "From diary and travel management to board preparation and coordination of confidential projects: we work in German and English, are on site in Zurich and act before you ask.",
      ],
      bullets: [
        "C-level diary, travel & meeting management",
        "Board & committee support, minutes",
        "Confidential project coordination",
        "Correspondence in German & English",
        "Ad interim cover for your assistant",
        "No permanent hire – flexibly scalable",
      ],
      faq: [
        {
          q: "Can you step in ad interim at short notice?",
          a: "Yes. Whether holiday cover, a vacancy or a time-critical project – we provide experienced executive support even at short notice, so nothing falls behind.",
        },
        {
          q: "How is confidentiality ensured?",
          a: "Discretion is the foundation of our work. On request we work under NDAs, and sensitive information stays with one dedicated contact person.",
        },
      ],
    },
  },
  {
    slugDe: "familienassistenz-zuerich",
    slugEn: "family-assistant-zurich",
    service: "executive-family-assistance",
    de: {
      metaTitle: "Familienassistenz Zürich | Swiss PA Services",
      metaDesc: "Familienassistenz in Zürich: Organisation von Familienkalender, Schule, Terminen, Haushalt und Ferien.",
      h1: "Familienassistenz in Zürich",
      h1Accent: "Mehr Zeit für Ihre Familie – wir organisieren den Rest",
      intro: [
        "Zwischen Beruf, Schule, Arztterminen und Haushalt bleibt Familien oft zu wenig Zeit füreinander. Unsere Familienassistenz in Zürich übernimmt die Organisation Ihres Familienalltags – damit am Abend Zeit bleibt für das, was zählt.",
        "Wir sind keine Nanny-Agentur, sondern Ihre Familien-Organisation: Wir koordinieren Termine, Betreuung, Schule, Haushaltshilfen, Ferien und Geschenke – diskret und mit einer festen Ansprechsperson.",
      ],
      bullets: [
        "Familienkalender & Terminkoordination",
        "Schul-, Kita- & Betreuungsorganisation",
        "Arzttermine, Anmeldungen & Administrative",
        "Koordination von Haushaltshilfe & Handwerkern",
        "Ferienplanung, Geschenke & Familienevents",
        "Festansprechsperson auf Deutsch & Englisch",
      ],
      faq: [
        {
          q: "Was macht eine Familienassistenz genau?",
          a: "Wir organisieren, was Ihren Alltag verstopft: Termine, Anmeldungen, Koordination von Betreuung und Dienstleistern, Ferienplanung und alle kleinen Dinge, die Zeit fressen. Kinderbetreuung selbst vermitteln wir über geprüfte Partner.",
        },
        {
          q: "Für wen lohnt sich eine Familienassistenz?",
          a: "Für berufstätige Eltern, internationale Familien und alle, die im Zürcher Alltag mehr Struktur und weniger Stress wollen – vom wöchentlichen Fixpunkt bis zur Komplettorganisation.",
        },
      ],
    },
    en: {
      metaTitle: "Family Assistant Zurich | Swiss PA Services",
      metaDesc: "Family assistant in Zurich: organisation of family calendar, school, appointments, household and holidays.",
      h1: "Family assistant in Zurich",
      h1Accent: "More time for your family – we organise the rest",
      intro: [
        "Between work, school, doctor's appointments and household, families often have too little time for each other. Our family assistance in Zurich takes over the organisation of your family life – so the evening remains for what matters.",
        "We are not a nanny agency but your family organisation: we coordinate appointments, childcare, school, household help, holidays and gifts – discreetly and with one dedicated contact.",
      ],
      bullets: [
        "Family calendar & appointment coordination",
        "School, daycare & care organisation",
        "Doctor's appointments, registrations & admin",
        "Coordination of household help & contractors",
        "Holiday planning, gifts & family events",
        "Dedicated contact in German & English",
      ],
      faq: [
        {
          q: "What exactly does a family assistant do?",
          a: "We organise what clogs your daily life: appointments, registrations, coordination of care and service providers, holiday planning and all the little things that eat up time. Childcare itself we arrange through vetted partners.",
        },
        {
          q: "Who benefits from a family assistant?",
          a: "For working parents, international families and everyone who wants more structure and less stress in Zurich life – from a weekly fixed slot to complete organisation.",
        },
      ],
    },
  },
  {
    slugDe: "home-watch-zuerichsee",
    slugEn: "home-watch-lake-zurich",
    service: "home-property-management",
    de: {
      metaTitle: "Home Watch Zürichsee | Liegenschaftskontrollen bei Abwesenheit",
      metaDesc: "Home Watch am Zürichsee: regelmässige Kontrollgänge für Ihre Liegenschaft bei Abwesenheit – mit Foto-Protokoll.",
      h1: "Home Watch am Zürichsee",
      h1Accent: "Ihr Zuhause unter Kontrolle, wenn Sie nicht da sind",
      intro: [
        "Home Watch ist in den USA Standard – in der Schweiz kaum bekannt und genau deshalb Ihr Vorteil: Regelmässige, dokumentierte Kontrollgänge durch Ihre Liegenschaft, während Sie verreist sind. Wir sind einer der wenigen Anbieter für Home Watch am Zürichsee.",
        "Ob Wasserschaden, Heizungsausfall oder Einbruch: Was heute niemand bemerkt, wird in Wochen teuer. Unsere Kontrollgänge mit Foto-Protokoll erkennen Probleme sofort – und erfüllen die Sorgfaltspflicht, die viele Versicherungen verlangen.",
      ],
      bullets: [
        "Regelmässige Kontrollgänge innen & aussen",
        "Foto-Protokoll nach jedem Check auf Ihr Handy",
        "Wasser, Heizung, Strom, Fenster & Schlösser",
        "Post, Pakete, Lüften & Pflanzen",
        "Sofortige Schadensmeldung & Handwerkerkoordination",
        "Zürich, Goldküste, linksufrig & Rapperswil",
      ],
      faq: [
        {
          q: "Was kostet Home Watch am Zürichsee?",
          a: "Je nach Objekt und Rhythmus ab einer monatlichen Pauschale – ein Bruchteil dessen, was ein unentdeckter Wasserschaden kostet. Nach einer kostenlosen Erstbesichtigung erhalten Sie eine transparente Offerte.",
        },
        {
          q: "Wie oft sollte meine Liegenschaft kontrolliert werden?",
          a: "Empfohlen sind wöchentliche bis vierzehntägige Kontrollen. Viele Versicherungen erwarten regelmässige Kontrolle bei längerer Abwesenheit – wir erstellen den passenden Plan für Ihr Objekt.",
        },
      ],
    },
    en: {
      metaTitle: "Home Watch Lake Zurich | Swiss PA Services",
      metaDesc: "Home watch on Lake Zurich: regular property inspections during your absence – with photo reports, insurance compliant and emergency response.",
      h1: "Home watch on Lake Zurich",
      h1Accent: "Your home under control when you are away",
      intro: [
        "Home watch is standard in the USA – barely known in Switzerland, and that is exactly your advantage: regular, documented inspections of your property while you are away. We are one of the few home watch providers on Lake Zurich.",
        "Whether water damage, heating failure or burglary: what nobody notices today becomes expensive within weeks. Our inspections with photo reports detect problems immediately – and fulfil the duty of care many insurers require.",
      ],
      bullets: [
        "Regular inspections inside & outside",
        "Photo report to your phone after every check",
        "Water, heating, electricity, windows & locks",
        "Mail, parcels, airing & plants",
        "Immediate damage reporting & contractor coordination",
        "Zurich, Gold Coast, left shore & Rapperswil",
      ],
      faq: [
        {
          q: "What does home watch on Lake Zurich cost?",
          a: "Depending on property and rhythm, from a monthly flat rate – a fraction of what an undiscovered water damage costs. After a free initial visit you receive a transparent quote.",
        },
        {
          q: "How often should my property be inspected?",
          a: "Weekly to bi-weekly checks are recommended. Many insurers expect regular inspections during longer absences – we create the right plan for your property.",
        },
      ],
    },
  },
  {
    slugDe: "liegenschaftsbetreuung-zug",
    slugEn: "property-care-zug",
    service: "home-property-management",
    de: {
      metaTitle: "Liegenschaftsbetreuung Zug | Swiss PA Services",
      metaDesc: "Private Liegenschaftsbetreuung im Kanton Zug: Kontrollgänge, Unterhalt, Handwerkerkoordination und Schlüsselverwaltung für Eigentümer.",
      h1: "Liegenschaftsbetreuung im Kanton Zug",
      h1Accent: "Privat, diskret und nur Minuten entfernt",
      intro: [
        "Eine Liegenschaft im Kanton Zug ist eine Wertanlage – und Werte wollen gepflegt sein. Unsere private Liegenschaftsbetreuung hält Ihre Immobilie in Bestform, ob Sie darin wohnen oder nicht. Von unserem Sitz an der Baarerstrasse 43 sind wir innert Minuten vor Ort.",
        "Anders als grosse Verwaltungen betreuen wir keine Fremdportfolios: Wir kümmern uns um Ihre Liegenschaft, als wäre es unsere eigene – mit festem Ansprechpartner, Foto-Protokollen und einem geprüften Handwerkernetzwerk im Kanton Zug.",
      ],
      bullets: [
        "Regelmässige Kontrollgänge & Home Watch",
        "Unterhalts- & Werterhaltplanung",
        "Handwerker-, Gärtner- & Reinigungskoordination",
        "Schlüsselverwaltung & Zutrittsorganisation",
        "Betreuung bei Abwesenheit & Ferienbewachung",
        "Transparente Abrechnung & Reporting",
      ],
      faq: [
        {
          q: "Betreuen Sie auch Eigentumswohnungen?",
          a: "Ja. Wir betreuen Eigentumswohnungen, Einfamilienhäuser und Residenzen im ganzen Kanton Zug – Zug, Baar, Cham, Steinhausen, Risch und Umgebung.",
        },
        {
          q: "Wie unterscheiden Sie sich von einer Hausverwaltung?",
          a: "Klassische Verwaltungen verwalten Stockwerkeigentum und Mietobjekte. Wir betreuen private Eigentümer persönlich: kein Callcenter, keine Warteschleife – ein fester Ansprechpartner, der Ihre Liegenschaft kennt.",
        },
      ],
    },
    en: {
      metaTitle: "Property Care Zug | Private & Discreet | Swiss PA Services",
      metaDesc: "Private property care in the canton of Zug: inspections, maintenance, contractor coordination and key holding for owners – directly from Baarerstrasse 43.",
      h1: "Property care in the canton of Zug",
      h1Accent: "Private, discreet and only minutes away",
      intro: [
        "A property in the canton of Zug is an investment – and value needs care. Our private property care keeps your real estate in top shape, whether you live in it or not. From our base at Baarerstrasse 43 we are on site within minutes.",
        "Unlike large management companies, we do not manage third-party portfolios: we look after your property as if it were our own – with a dedicated contact, photo reports and a vetted contractor network in the canton of Zug.",
      ],
      bullets: [
        "Regular inspections & home watch",
        "Maintenance & value preservation planning",
        "Contractor, gardener & cleaning coordination",
        "Key holding & access organisation",
        "Absence care & vacation watch",
        "Transparent billing & reporting",
      ],
      faq: [
        {
          q: "Do you also look after condominiums?",
          a: "Yes. We look after condominiums, single-family homes and residences across the canton of Zug – Zug, Baar, Cham, Steinhausen, Risch and surroundings.",
        },
        {
          q: "How do you differ from a property management company?",
          a: "Classic managers handle condominiums and rental portfolios. We look after private owners personally: no call centre, no waiting loop – one dedicated contact who knows your property.",
        },
      ],
    },
  },
  {
    slugDe: "hausverwaltung-privat-zuerich",
    slugEn: "private-property-administration-zurich",
    service: "home-property-management",
    de: {
      metaTitle: "Private Hausverwaltung Zürich | Swiss PA Services",
      metaDesc: "Private Hausverwaltung in Zürich für Eigentümer: Unterhalt, Handwerkerkoordination, Administration und Liegenschaftsbetreuung ohne Callcenter.",
      h1: "Private Hausverwaltung in Zürich",
      h1Accent: "Ihre Liegenschaft in persönlichen Händen",
      intro: [
        "Klassische Hausverwaltungen in Zürich sind auf Mietobjekte und Stockwerkeigentum ausgerichtet – mit Callcenter, Warteschleifen und wechselnden Kontaktpersonen. Private Eigentümer brauchen etwas anderes: jemanden, der ihre Liegenschaft kennt und sich persönlich kümmert.",
        "Swiss PA Services ist Ihre private Hausverwaltung in Zürich: Wir übernehmen Unterhalt, Koordination und Administration Ihrer Immobilie – von der Stadtwohnung bis zur Residenz am Zürichsee. Ein fester Ansprechpartner, transparente Abrechnung, keine Warteschleife.",
      ],
      bullets: [
        "Liegenschaftsunterhalt & Werterhalt-Management",
        "Koordination von Handwerkern, Gärtnern & Reinigung",
        "Nebenkosten- & Liegenschaftsadministration",
        "Regelmässige Kontrollgänge mit Foto-Protokoll",
        "Schlüsselverwaltung & Zutrittsorganisation",
        "Fester Ansprechpartner statt Callcenter",
      ],
      faq: [
        {
          q: "Für wen ist eine private Hausverwaltung gedacht?",
          a: "Für private Eigentümer in Zürich, die ihre Liegenschaft professionell betreut wissen möchten, ohne sich um Handwerker, Abrechnungen und Termine zu kümmern – ob Sie darin wohnen oder nicht.",
        },
        {
          q: "Wie unterscheiden Sie sich von einer klassischen Hausverwaltung?",
          a: "Wir verwalten keine Mietportfolios, sondern betreuen private Eigentümer exklusiv und persönlich. Sie haben eine feste Ansprechsperson, die Ihre Liegenschaft kennt – und erreichen uns direkt, ohne Ticket-System.",
        },
      ],
    },
    en: {
      metaTitle: "Private Property Administration Zurich | Swiss PA Services",
      metaDesc: "Private property administration in Zurich for owners: maintenance, contractor coordination, administration and property care without call centres.",
      h1: "Private property administration in Zurich",
      h1Accent: "Your property in personal hands",
      intro: [
        "Classic property managers in Zurich are built for rental buildings and condominium associations – with call centres, waiting loops and rotating contacts. Private owners need something different: someone who knows their property and takes personal care of it.",
        "Swiss PA Services is your private property administrator in Zurich: we take over maintenance, coordination and administration of your property – from a city apartment to a residence on Lake Zurich. One dedicated contact, transparent billing, no waiting loop.",
      ],
      bullets: [
        "Property maintenance & value preservation",
        "Coordination of contractors, gardeners & cleaning",
        "Utility & property administration",
        "Regular inspections with photo reports",
        "Key holding & access organisation",
        "Dedicated contact instead of a call centre",
      ],
      faq: [
        {
          q: "Who is private property administration for?",
          a: "For private owners in Zurich who want their property professionally cared for without dealing with contractors, invoices and appointments – whether you live in it or not.",
        },
        {
          q: "How do you differ from a classic property manager?",
          a: "We do not manage rental portfolios – we look after private owners exclusively and personally. You have one dedicated contact who knows your property, and you reach us directly, without a ticket system.",
        },
      ],
    },
  },
  {
    slugDe: "umzugsbegleitung-zug",
    slugEn: "moving-support-zug",
    service: "relocation-services-schweiz",
    de: {
      metaTitle: "Umzugsbegleitung Zug | Stressfrei umziehen | Swiss PA Services",
      metaDesc: "Umzugsbegleitung im Kanton Zug: Wir organisieren alles rund um Ihren Umzug – Ab- & Anmeldungen, Wohnungsübergaben, Handwerker, Endreinigung.",
      h1: "Umzugsbegleitung im Kanton Zug",
      h1Accent: "Die Umzugsfirma zieht Ihre Möbel – wir organisieren alles andere",
      intro: [
        "Ein Umzug ist mehr als Möbel tragen: Abmeldung, Anmeldung, Wohnungsübergabe, Endreinigung, Handwerker für die neue Wohnung, Adressänderungen bei einem Dutzend Stellen. Genau dieser Rattenschwanz kostet Wochen – und genau den übernehmen wir.",
        "Unsere Umzugsbegleitung im Kanton Zug koordiniert alles rund um Ihren Umzug: Wir organisieren die geprüfte Umzugsfirma, stehen bei beiden Wohnungsübergaben dabei, koordinieren Reinigung und Handwerker und erledigen alle An- und Abmeldungen für Sie.",
      ],
      bullets: [
        "Organisation & Koordination der Umzugsfirma",
        "Wohnungsübergaben: Abgabe alt, Übernahme neu",
        "Endreinigung mit Abnahmegarantie organisiert",
        "Handwerker & Einbauten in der neuen Wohnung",
        "Alle An- & Abmeldungen (Gemeinde, Versicherungen, Abos)",
        "Internet, Strom & Alltags-Setup am neuen Ort",
      ],
      faq: [
        {
          q: "Was ist der Unterschied zur Umzugsfirma?",
          a: "Die Umzugsfirma transportiert Ihre Möbel. Wir organisieren alles drumherum: Wahl und Koordination der Firma, Übergaben, Reinigung, Handwerker, Anmeldungen – Sie müssen an nichts denken.",
        },
        {
          q: "Was kostet eine Umzugsbegleitung in Zug?",
          a: "Je nach Umfang – von der reinen Koordination bis zum Rundum-Paket inklusive Einrichtung der neuen Wohnung. Nach einem kostenlosen Erstgespräch erhalten Sie eine transparente Offerte.",
        },
      ],
    },
    en: {
      metaTitle: "Moving Support Zug | Move Without Stress | Swiss PA Services",
      metaDesc: "Moving support in the canton of Zug: we organise everything around your move – de-registration & registration, apartment handovers, contractors.",
      h1: "Moving support in the canton of Zug",
      h1Accent: "The movers carry your furniture – we organise everything else",
      intro: [
        "A move is more than carrying furniture: de-registration, registration, apartment handover, final cleaning, contractors for the new home, address changes with a dozen institutions. Exactly this tail of tasks costs weeks – and exactly that is what we take over.",
        "Our moving support in the canton of Zug coordinates everything around your move: we organise the vetted moving company, attend both apartment handovers, coordinate cleaning and contractors and handle all registrations for you.",
      ],
      bullets: [
        "Organisation & coordination of the moving company",
        "Apartment handovers: old & new",
        "Final cleaning with acceptance guarantee organised",
        "Contractors & installations in the new home",
        "All registrations (municipality, insurances, subscriptions)",
        "Internet, electricity & everyday setup at the new place",
      ],
      faq: [
        {
          q: "What is the difference to a moving company?",
          a: "The moving company transports your furniture. We organise everything around it: choosing and coordinating the company, handovers, cleaning, contractors, registrations – you don't have to think of anything.",
        },
        {
          q: "What does moving support in Zug cost?",
          a: "Depending on the scope – from pure coordination to a full package including setting up the new home. After a free initial consultation you receive a transparent quote.",
        },
      ],
    },
  },
  {
    slugDe: "office-management-extern",
    slugEn: "outsourced-office-management-switzerland",
    service: "persoenliche-assistenz",
    de: {
      metaTitle: "Externes Office Management für KMU Schweiz | Swiss PA Services",
      metaDesc: "Externes Office Management für KMU und Startups: Telefon, Post, Administration und Buchhaltungs-Vorbereitung.",
      h1: "Externes Office Management",
      h1Accent: "Ihr Backoffice – professionell, ohne Festanstellung",
      intro: [
        "Viele KMU und Startups sind zu klein für eine eigene Büroleitung – aber zu gross, um Administration nebenbei zu erledigen. Unser externes Office Management schliesst genau diese Lücke: professionelles Backoffice, flexibel nach Bedarf.",
        "Wir übernehmen Telefon- und E-Mail-Organisation, Postbearbeitung, Terminierung, Dokumentenmanagement und die Vorbereitung Ihrer Buchhaltung für den Treuhänder – remote oder regelmässig vor Ort in Zug und Zürich.",
      ],
      bullets: [
        "Telefon- & E-Mail-Organisation",
        "Postbearbeitung & Korrespondenz",
        "Terminierung & Meetingorganisation",
        "Dokumentenmanagement & Ablage",
        "Buchhaltungs-Vorbereitung für Ihren Treuhänder",
        "Remote schweizweit oder vor Ort in Zug & Zürich",
      ],
      faq: [
        {
          q: "Für welche Firmen lohnt sich externes Office Management?",
          a: "Für KMU, Startups, Arztpraxen, Anwälte und Berater mit 1–15 Mitarbeitenden: alle, die ein professionelles Backoffice brauchen, aber keine Vollzeitstelle rechtfertigen können.",
        },
        {
          q: "Wie flexibel ist das Modell?",
          a: "Komplett flexibel: von wenigen Stunden pro Woche bis zu mehreren Tagen. Sie zahlen nur die tatsächliche Arbeit – ohne Anstellung, Sozialabgaben oder Ferienvertretung.",
        },
      ],
    },
    en: {
      metaTitle: "Outsourced Office Management for Swiss SMEs",
      metaDesc: "Outsourced office management for SMEs and startups: phone, mail, administration and bookkeeping preparation.",
      h1: "Outsourced office management",
      h1Accent: "Your back office – professional, without a permanent hire",
      intro: [
        "Many SMEs and startups are too small for their own office manager – but too big to handle administration on the side. Our outsourced office management closes exactly this gap: a professional back office, flexible as needed.",
        "We take over phone and email organisation, mail processing, scheduling, document management and preparing your bookkeeping for the trustee – remotely or regularly on site in Zug and Zurich.",
      ],
      bullets: [
        "Phone & email organisation",
        "Mail processing & correspondence",
        "Scheduling & meeting organisation",
        "Document management & filing",
        "Bookkeeping preparation for your trustee",
        "Remote Switzerland-wide or on site in Zug & Zurich",
      ],
      faq: [
        {
          q: "Which companies benefit from outsourced office management?",
          a: "SMEs, startups, medical practices, lawyers and consultants with 1–15 employees: everyone who needs a professional back office but cannot justify a full-time position.",
        },
        {
          q: "How flexible is the model?",
          a: "Completely flexible: from a few hours per week to several days. You pay only for actual work – no employment, social contributions or holiday cover.",
        },
      ],
    },
  },
  {
    slugDe: "alltagshelfer-familie-zuerich",
    slugEn: "family-everyday-help-zurich",
    service: "executive-family-assistance",
    de: {
      metaTitle: "Alltagshelfer für Familien Zürich | Swiss PA Services",
      metaDesc: "Alltagshelfer für Familien in Zürich: Einkäufe, Botengänge, Pakete, Warten auf Handwerker und Organisation im Haushalt.",
      h1: "Alltagshelfer für Familien in Zürich",
      h1Accent: "Die kleinen Dinge, erledigt – zuverlässig und diskret",
      intro: [
        "Es sind die kleinen Dinge, die den Familienalltag sprengen: das Paket, das nur vormittags kommt, der Handwerker, auf den jemand warten muss, der Einkauf zwischen zwei Terminen. Unser Alltagshelfer-Service in Zürich erledigt genau das.",
        "Wir sind keine Putzvermittlung und keine Nanny-Agentur: Wir sind Ihre diskrete Alltagsorganisation – stundenweise buchbar, mit einer festen Vertrauensperson, die Ihre Familie und Ihre Abläufe kennt.",
      ],
      bullets: [
        "Einkäufe, Botengänge & Post- und Paketservice",
        "Warten auf Handwerker & Lieferungen",
        "Organisation von Wäsche, Reinigung & Vorräten",
        "Begleitung zu Terminen & Behörden",
        "Haus-Hüten während Ferien und Abwesenheit",
        "Festansprechsperson, stundenweise buchbar",
      ],
      faq: [
        {
          q: "Was macht ein Alltagshelfer genau?",
          a: "Alles Kleine, das Zeit frisst: Einkäufe, Botengänge, Pakete, Warten auf Handwerker, Organisation im Haushalt. Keine Kinderbetreuung und keine Grundreinigung – dafür vermitteln wir geprüfte Partner.",
        },
        {
          q: "Wie buche ich den Alltagshelfer?",
          a: "Ganz einfach stundenweise oder als wöchentlichen Fixpunkt. Viele Familien buchen einen festen Halbtag pro Woche – wir lernen Ihre Abläufe kennen und erledigen Dinge zunehmend von allein.",
        },
      ],
    },
    en: {
      metaTitle: "Everyday Help for Families Zurich | Swiss PA Services",
      metaDesc: "Everyday help for families in Zurich: shopping, errands, parcels, waiting for contractors and household organisation.",
      h1: "Everyday help for families in Zurich",
      h1Accent: "The little things, done – reliably and discreetly",
      intro: [
        "It is the little things that break family life: the parcel that only arrives in the morning, the contractor someone has to wait for, the shopping between two appointments. Our everyday help service in Zurich takes care of exactly that.",
        "We are neither a cleaning agency nor a nanny service: we are your discreet everyday organisation – bookable by the hour, with a dedicated trusted person who knows your family and your routines.",
      ],
      bullets: [
        "Shopping, errands & mail and parcel service",
        "Waiting for contractors & deliveries",
        "Organising laundry, cleaning & supplies",
        "Accompaniment to appointments & authorities",
        "House-sitting during holidays and absences",
        "Dedicated contact, bookable by the hour",
      ],
      faq: [
        {
          q: "What exactly does an everyday helper do?",
          a: "Everything small that eats time: shopping, errands, parcels, waiting for contractors, household organisation. No childcare and no deep cleaning – for that we arrange vetted partners.",
        },
        {
          q: "How do I book the everyday helper?",
          a: "Simply by the hour or as a weekly fixed slot. Many families book a fixed half-day per week – we learn your routines and increasingly handle things on our own.",
        },
      ],
    },
  },
  {
    slugDe: "chalet-betreuung-zentralschweiz",
    slugEn: "chalet-care-central-switzerland",
    service: "home-property-management",
    de: {
      metaTitle: "Chalet Betreuung Zentralschweiz | Swiss PA Services",
      metaDesc: "Chalet-Betreuung in der Zentralschweiz: ganzjährige Kontrolle und Pflege Ihres Chalets in Schwyz, Zug & Luzern.",
      h1: "Chalet-Betreuung in der Zentralschweiz",
      h1Accent: "Ihr Chalet – ganzjährig in besten Händen",
      intro: [
        "Ein Chalet in der Zentralschweiz ist Erholung – solange jemand danach schaut. Frost im Winter, Ungeziefer im Frühling, Stürme im Herbst: Leerstehende Chalets brauchen ganzjährige Aufmerksamkeit. Genau das ist unsere Chalet-Betreuung.",
        "Wir betreuen Chalets in den Kantonen Schwyz, Zug und Luzern – von der Mythenregion bis an den Vierwaldstättersee: regelmässige Kontrollgänge, saisonale Vorbereitung, Handwerkerkoordination und die Vorfreude-Garantie: Sie kommen an, und alles ist bereit.",
      ],
      bullets: [
        "Ganzjährige Home-Watch-Kontrollgänge",
        "Winterkontrollen: Heizung, Frost & Schneelast",
        "Saisonale Vorbereitung: Einwintern & Frühlingsstart",
        "Handwerker- & Gartenkoordination vor Ort",
        "Ankunfts-Service: Heizung an, Vorräte da, Betten frisch",
        "Foto-Protokoll nach jedem Kontrollgang",
      ],
      faq: [
        {
          q: "Betreuen Sie Chalets auch im Winter?",
          a: "Gerade im Winter ist die Betreuung am wichtigsten: Wir kontrollieren Heizung und Wasserleitungen, prüfen die Schneelast auf dem Dach und sorgen dafür, dass Frostschäden gar nicht erst entstehen.",
        },
        {
          q: "In welchen Regionen sind Sie aktiv?",
          a: "Unser Schwerpunkt ist die Zentralschweiz: Kanton Schwyz (Mythenregion, Einsiedeln, Lauerzersee), Kanton Zug und die Region Vierwaldstättersee. Andere Regionen auf Anfrage.",
        },
      ],
    },
    en: {
      metaTitle: "Chalet Care Central Switzerland | Swiss PA Services",
      metaDesc: "Chalet care in Central Switzerland: year-round inspection and care of your chalet in Schwyz, Zug & Lucerne.",
      h1: "Chalet care in Central Switzerland",
      h1Accent: "Your chalet – in the best hands, all year round",
      intro: [
        "A chalet in Central Switzerland is relaxation – as long as someone looks after it. Frost in winter, pests in spring, storms in autumn: empty chalets need year-round attention. That is exactly what our chalet care provides.",
        "We look after chalets in the cantons of Schwyz, Zug and Lucerne – from the Mythen region to Lake Lucerne: regular inspections, seasonal preparation, contractor coordination and the anticipation guarantee: you arrive, and everything is ready.",
      ],
      bullets: [
        "Year-round home watch inspections",
        "Winter checks: heating, frost & snow load",
        "Seasonal preparation: winterising & spring opening",
        "Local contractor & garden coordination",
        "Arrival service: heating on, supplies stocked, fresh beds",
        "Photo report after every inspection",
      ],
      faq: [
        {
          q: "Do you also look after chalets in winter?",
          a: "Winter is exactly when care matters most: we check heating and water pipes, inspect the snow load on the roof and make sure frost damage never happens in the first place.",
        },
        {
          q: "Which regions do you cover?",
          a: "Our focus is Central Switzerland: canton Schwyz (Mythen region, Einsiedeln, Lake Lauerz), canton Zug and the Lake Lucerne region. Other regions on request.",
        },
      ],
    },
  },
  {
    slugDe: "concierge-service-zuerich",
    slugEn: "concierge-service-zurich",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Concierge Service Zürich & Lifestyle Management",
      metaDesc: "Concierge Service und Lifestyle Management in Zürich: Restaurantreservationen, Eventtickets, Reiseplanung und laufende Lebensorganisation.",
      h1: "Concierge Service in Zürich",
      h1Accent: "Ihr Wunsch. Ein Anruf. Erledigt.",
      intro: [
        "Ob einzelner Wunsch oder laufende Betreuung: Als Private Concierge in Zürich kennen wir die Stadt persönlich – von der Bahnhofstrasse über den Kreis 4 bis zu den Adressen über dem See. Sie bekommen keine Plattform, sondern Menschen, die Zürich leben.",
        "Das ausgebuchte Restaurant an der Bahnhofstrasse, Last-Minute-Tickets für das Opernhaus, ein Tisch mit Seesicht am Samstagabend: In Zürich ist alles möglich – wenn man die richtigen Leute kennt. Unser Concierge Service in Zürich kennt sie.",
        "Anders als Hotel-Concierges oder Kreditkarten-Services arbeiten wir ausschliesslich für Sie: ohne Mitgliedschaft, ohne Mindestumsatz, mit einer festen Ansprechsperson, die Ihren Geschmack kennt und Ihre Wünsche vorwegnimmt.",
      ],
      bullets: [
        "Restaurant- & Hotelreservationen, auch last minute",
        "Tickets für Oper, Konzerte & Sportevents",
        "Reiseplanung & Luxusreisen ab Zürich",
        "Personal Shopping & Geschenkservice",
        "Event- & Anlassplanung für private Feiern",
        "Besondere Wünsche – diskret umgesetzt",
      ],
      faq: [
        {
          q: "Was macht ein Private Concierge in Zürich?",
          a: "Ein Private Concierge in Zürich erledigt das Private, für das Ihr Kalender keine Zeit hat: Reservationen, Tickets, Reisen, Anlässe und Besorgungen – diskret und ohne Mitgliedschaft. Anders als internationale Plattformen arbeiten wir lokal: Wir kennen die Restaurants, Veranstalter und Adressen in Zürich persönlich.",
        },
        {
          q: "Was kostet ein Concierge Service in Zürich?",
          a: "Keine Mitgliedschaft, keine Grundgebühr: Sie zahlen nur für die tatsächlich erledigten Aufgaben – je nach Umfang per Stundensatz oder als monatliches Kontingent. Nach einem kostenlosen Erstgespräch erhalten Sie eine transparente Offerte.",
        },
        {
          q: "Wie kurzfristig können Sie Wünsche umsetzen?",
          a: "Sehr kurzfristig. Dank unseres Netzwerks in Zürich realisieren wir auch Reservationen und Tickets am selben Tag. Je ausgefallener der Wunsch, desto mehr Vorlauf hilft – aber fragen Sie einfach: Wir finden fast immer eine Lösung.",
        },
        {
          q: "Bieten Sie auch Lifestyle Management in Zürich an?",
          a: "Ja. Der Concierge Service erledigt einzelne Wünsche auf Anfrage. Beim Lifestyle Management organisieren wir Ihren Zürcher Alltag laufend – Wochenplanung, Haushalt, Reisen, Reservationen – meist als monatliches Kontingent. Beides aus einer Hand, ohne Abo.",
        },
        {
          q: "Betreuen Sie auch Family Offices und UHNW-Kunden in Zürich?",
          a: "Ja, das ist ein Schwerpunkt: Wir arbeiten als diskrete Verlängerung von Family Offices – von der laufenden Lifestyle-Betreuung bis zu Residenzen und Anlässen. Eine feste Ansprechperson, NDA auf Wunsch, Abrechnung über das Family Office möglich.",
        },
      ],
    },
    en: {
      metaTitle: "Concierge Service Zurich & Lifestyle Management",
      metaDesc: "Concierge service and lifestyle management in Zurich: restaurant reservations, event tickets, travel planning and ongoing life organisation.",
      h1: "Concierge service in Zurich",
      h1Accent: "Your wish. One call. Done.",
      intro: [
        "Whether a single wish or ongoing support: as a private concierge in Zurich we know the city personally – from Bahnhofstrasse via Kreis 4 to the addresses above the lake. You get people who live Zurich, not a platform.",
        "The fully booked restaurant on Bahnhofstrasse, last-minute tickets to the opera, a lakeside table on Saturday night: in Zurich everything is possible – if you know the right people. Our concierge service in Zurich knows them.",
        "Unlike hotel concierges or credit card services, we work exclusively for you: no membership, no minimum spend, with a dedicated contact who knows your taste and anticipates your wishes.",
      ],
      bullets: [
        "Restaurant & hotel reservations, even last minute",
        "Tickets for opera, concerts & sports events",
        "Travel planning & luxury trips from Zurich",
        "Personal shopping & gift service",
        "Event & celebration planning for private occasions",
        "Special requests – handled discreetly",
      ],
      faq: [
        {
          q: "What does a private concierge in Zurich do?",
          a: "A private concierge in Zurich handles the private matters your calendar has no time for: reservations, tickets, travel, occasions and errands – discreet and without membership. Unlike international platforms we work locally: we know Zurich's restaurants, organisers and addresses personally.",
        },
        {
          q: "What does a concierge service in Zurich cost?",
          a: "No membership, no base fee: you pay only for tasks actually completed – by hourly rate or as a monthly allowance, depending on volume. After a free initial consultation you receive a transparent quote.",
        },
        {
          q: "How quickly can you handle requests?",
          a: "Very quickly. Thanks to our Zurich network we arrange even same-day reservations and tickets. The more unusual the wish, the more lead time helps – but just ask: we almost always find a solution.",
        },
        {
          q: "Do you also offer lifestyle management in Zurich?",
          a: "Yes. The concierge service handles individual wishes on request. With lifestyle management we organise your Zurich daily life continuously – weekly planning, household, travel, reservations – usually as a monthly allowance. Both from one source, without a subscription.",
        },
        {
          q: "Do you also serve family offices and UHNW clients in Zurich?",
          a: "Yes, that is a focus: we work as a discreet extension of family offices – from ongoing lifestyle support to residences and occasions. One dedicated contact, NDA on request, billing via the family office possible.",
        },
      ],
    },
  },
  {
    slugDe: "concierge-service-zug",
    slugEn: "concierge-service-zug",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Concierge Service Zug | Swiss PA Services",
      metaDesc: "Concierge Service in Zug für Unternehmer, Expats und Familien: Reservationen, Reisen, Events und Alltagswünsche.",
      h1: "Concierge Service in Zug",
      h1Accent: "Ihr persönlicher Concierge – mitten in Zug",
      intro: [
        "Zug ist klein – und genau deshalb zählt hier Diskretion doppelt. Als Private Concierge in Zug arbeiten wir von der Baarerstrasse 43 aus: zu Fuss bei Behörden und Dienstleistern, mit einem Netzwerk, das über Jahre gewachsen ist.",
        "Zug ist klein, aber anspruchsvoll: Die besten Adressen kennt man nur vor Ort. Unser Concierge Service in Zug sitzt an der Baarerstrasse 43 und kennt die Stadt, den See und die Region persönlich – vom Pop-up am Seeufer bis zum ruhigen Tisch im besten Restaurant.",
        "Wir betreuen Unternehmer, internationale Familien und Expats im Kanton Zug mit allem, was den Alltag angenehmer macht: Reservationen, Reiseplanung, Geschenke, Events und die Wünsche, für die sonst niemand Zeit hat.",
      ],
      bullets: [
        "Restaurant- & Hotelreservationen in Zug & Umgebung",
        "Reiseplanung & Ferienorganisation",
        "Private Events & Familienanlässe",
        "Geschenkservice & Personal Shopping",
        "Boot, See & Freizeit: Arrangements am Zugersee",
        "Diskretion & feste Ansprechsperson",
      ],
      faq: [
        {
          q: "Was macht ein Private Concierge in Zug?",
          a: "Ein Private Concierge in Zug organisiert Ihren privaten Alltag: Reservationen, Reisen, Anlässe, Besorgungen und die kleinen Dinge, die Zeit fressen. Wir sitzen mitten in Zug, kennen Stadt und See persönlich und arbeiten ohne Mitgliedschaft – auf Deutsch und Englisch.",
        },
        {
          q: "Arbeiten Sie auch für Expats in Zug auf Englisch?",
          a: "Ja, ein grosser Teil unserer Concierge-Kunden in Zug ist international. Wir arbeiten auf Englisch und Deutsch und kennen die Anliegen internationaler Familien – von der Restaurantempfehlung bis zur kompletten Wochenend-Organisation.",
        },
        {
          q: "Was unterscheidet Sie von einem Hotel-Concierge?",
          a: "Ein Hotel-Concierge arbeitet für sein Haus – wir nur für Sie. Ohne Mitgliedschaft und Mindestumsatz, mit einer festen Ansprechsperson, die Ihre Vorlieben über Monate und Jahre kennt.",
        },
      ],
    },
    en: {
      metaTitle: "Concierge Service Zug | Swiss PA Services",
      metaDesc: "Concierge service in Zug for entrepreneurs, expats and families: reservations, travel, events and everyday wishes.",
      h1: "Concierge service in Zug",
      h1Accent: "Your personal concierge – right in Zug",
      intro: [
        "Zug is small – which is exactly why discretion counts double here. As a private concierge in Zug we work from Baarerstrasse 43: within walking distance of authorities and service providers, with a network built over years.",
        "Zug is small but demanding: the best addresses are only known locally. Our concierge service in Zug is based at Baarerstrasse 43 and knows the city, the lake and the region personally – from the lakeside pop-up to the quiet table in the best restaurant.",
        "We support entrepreneurs, international families and expats in the canton of Zug with everything that makes life more enjoyable: reservations, travel planning, gifts, events and the wishes nobody else has time for.",
      ],
      bullets: [
        "Restaurant & hotel reservations in Zug & surroundings",
        "Travel planning & holiday organisation",
        "Private events & family celebrations",
        "Gift service & personal shopping",
        "Boat, lake & leisure: arrangements on Lake Zug",
        "Discretion & one dedicated contact",
      ],
      faq: [
        {
          q: "What does a private concierge in Zug do?",
          a: "A private concierge in Zug organises your private daily life: reservations, travel, occasions, errands and the little things that eat time. We are based right in Zug, know the city and lake personally and work without membership – in German and English.",
        },
        {
          q: "Do you also work in English for expats in Zug?",
          a: "Yes, a large part of our concierge clients in Zug are international. We work in English and German and know the needs of international families – from restaurant recommendations to complete weekend organisation.",
        },
        {
          q: "How do you differ from a hotel concierge?",
          a: "A hotel concierge works for their house – we work only for you. No membership, no minimum spend, with a dedicated contact who knows your preferences over months and years.",
        },
      ],
    },
  },
  {
    slugDe: "privater-concierge-schweiz",
    slugEn: "private-concierge-switzerland",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Privater Concierge Schweiz | Swiss PA Services",
      metaDesc: "Privater Concierge in der Schweiz: Ihr persönlicher Lifestyle-Manager für Reservationen, Reisen, Events und besondere Wünsche.",
      h1: "Privater Concierge in der Schweiz",
      h1Accent: "Lifestyle Management für Menschen mit wenig Zeit",
      intro: [
        "Ein privater Concierge ist mehr als ein Buchungsservice: Er ist der persönliche Manager Ihrer Lebensqualität. Während Kreditkarten-Concierges und Hotel-Services standardisiert arbeiten, kennt ein privater Concierge Sie – Ihren Geschmack, Ihre Standards, Ihre Tabus.",
        "Swiss PA Services bietet privaten Concierge-Service in der ganzen Schweiz: von Zug und Zürich bis Genf. Diskret, ohne Mitgliedschaft, mit der Zuverlässigkeit, die man in der Schweiz erwartet – und der Kreativität, die man sich wünscht.",
      ],
      bullets: [
        "Reservationen, die unmöglich scheinen",
        "Reise- & Luxusreiseplanung mit allen Details",
        "Private Events, Jubiläen & Überraschungen",
        "Personal Shopping, Geschenke & besondere Anlässe",
        "Zugang zu ausgebuchten Adressen & Erlebnissen",
        "Absolute Diskretion – auch mit NDA",
      ],
      faq: [
        {
          q: "Brauche ich eine Mitgliedschaft wie bei Kreditkarten-Concierges?",
          a: "Nein. Kein Abo, kein Mindestumsatz, keine Karte. Sie nutzen unseren Concierge-Service, wann immer Sie ihn brauchen – und zahlen nur für die tatsächliche Leistung.",
        },
        {
          q: "Welche Art von Wünschen übernehmen Sie?",
          a: "Alles Legale, das organisierbar ist: von der Last-Minute-Reservation über die Geburtstagsüberraschung bis zur kompletten Ferienplanung. Je ausgefallener, desto lieber – sagen Sie uns einfach, was Sie sich wünschen.",
        },
      ],
    },
    en: {
      metaTitle: "Private Concierge Switzerland | Swiss PA Services",
      metaDesc: "Private concierge in Switzerland: your personal lifestyle manager for reservations, travel, events and special requests.",
      h1: "Private concierge in Switzerland",
      h1Accent: "Lifestyle management for people with little time",
      intro: [
        "A private concierge is more than a booking service: they are the personal manager of your quality of life. While credit card concierges and hotel services work standardised, a private concierge knows you – your taste, your standards, your boundaries.",
        "Swiss PA Services offers private concierge service across Switzerland: from Zug and Zurich to Geneva. Discreet, without membership, with the reliability you expect in Switzerland – and the creativity you wish for.",
      ],
      bullets: [
        "Reservations that seem impossible",
        "Travel & luxury trip planning with every detail",
        "Private events, anniversaries & surprises",
        "Personal shopping, gifts & special occasions",
        "Access to fully booked addresses & experiences",
        "Absolute discretion – NDA available",
      ],
      faq: [
        {
          q: "Do I need a membership like with credit card concierges?",
          a: "No. No subscription, no minimum spend, no card. You use our concierge service whenever you need it – and pay only for the actual service.",
        },
        {
          q: "What kind of requests do you handle?",
          a: "Everything legal that can be organised: from last-minute reservations to birthday surprises to complete holiday planning. The more unusual, the better – just tell us what you wish for.",
        },
      ],
    },
  },
  {
    slugDe: "luxusreise-planen-lassen",
    slugEn: "luxury-travel-planning-switzerland",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Luxusreise planen lassen | Swiss PA Services",
      metaDesc: "Luxusreise planen lassen von Schweizer Experten: massgeschneiderte Reiserouten, beste Hotels, private Transfers und Erlebnisse.",
      h1: "Luxusreise planen lassen",
      h1Accent: "Sie packen ein – wir planen alles andere",
      intro: [
        "Eine perfekte Luxusreise beginnt Monate vorher: Hotels vergleichen, Transfers timen, Restaurants reservieren, Erlebnisse sichern. Wer wenig Zeit hat, verbringt mehr Stunden mit Planung als mit Vorfreude. Unser Reiseplanungs-Service dreht das um.",
        "Wir planen Ihre Reise massgeschneidert von der Schweiz aus: Reiseroute, Hotels, Flüge, private Transfers, Tische und Erlebnisse – alles abgestimmt auf Ihren Geschmack und Ihr Budget. Sie erhalten einen Reiseplan, in dem jedes Detail steht, und eine Ansprechsperson, die auch während der Reise erreichbar ist.",
      ],
      bullets: [
        "Massgeschneiderte Reiserouten nach Ihrem Geschmack",
        "Hotels, Flüge & private Transfers koordiniert",
        "Restaurant- & Erlebnisreservationen im Voraus",
        "Upgrades & Sonderwünsche bei Partnern",
        "Kompletter Reiseplan mit allen Details",
        "Erreichbar während Ihrer gesamten Reise",
      ],
      faq: [
        {
          q: "Was kostet es, eine Luxusreise planen zu lassen?",
          a: "Die Planung wird als Pauschale oder nach Aufwand berechnet – je nach Reisedauer und Komplexität. Viele Kunden sparen durch unsere Partnerkonditionen und Upgrades mehr, als die Planung kostet. Erstberatung ist kostenlos.",
        },
        {
          q: "Wie weit im Voraus sollte ich anfragen?",
          a: "Ideal sind 4–8 Wochen für komplette Reisen – dann bekommen wir die besten Zimmer und Tische. Aber auch Last-Minute-Reisen organisieren wir: Sagen Sie uns einfach Ziel und Zeitraum.",
        },
      ],
    },
    en: {
      metaTitle: "Luxury Travel Planning | Tailor-Made Trips | Swiss PA Services",
      metaDesc: "Have your luxury trip planned by Swiss experts: tailor-made itineraries, best hotels, private transfers and experiences.",
      h1: "Have your luxury trip planned",
      h1Accent: "You pack your bags – we plan everything else",
      intro: [
        "A perfect luxury trip starts months ahead: comparing hotels, timing transfers, reserving restaurants, securing experiences. Those with little time spend more hours planning than anticipating. Our travel planning service turns that around.",
        "We plan your trip tailor-made from Switzerland: itinerary, hotels, flights, private transfers, tables and experiences – all matched to your taste and budget. You receive an itinerary with every detail and a contact person reachable throughout your journey.",
      ],
      bullets: [
        "Tailor-made itineraries matched to your taste",
        "Hotels, flights & private transfers coordinated",
        "Restaurant & experience reservations in advance",
        "Upgrades & special wishes with partners",
        "Complete itinerary with every detail",
        "Reachable throughout your entire trip",
      ],
      faq: [
        {
          q: "What does it cost to have a luxury trip planned?",
          a: "Planning is billed as a flat rate or by effort – depending on trip length and complexity. Many clients save more through our partner rates and upgrades than the planning costs. Initial consultation is free.",
        },
        {
          q: "How far in advance should I enquire?",
          a: "Ideally 4–8 weeks for complete trips – then we get the best rooms and tables. But we also organise last-minute trips: just tell us destination and dates.",
        },
      ],
    },
  },
  {
    slugDe: "eventplanung-zuerich",
    slugEn: "event-planning-zurich",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Eventplanung Zürich | Swiss PA Services",
      metaDesc: "Eventplanung in Zürich für private Anlässe: Geburtstage, Jubiläen, Dinner und Überraschungen – Location, Catering, Gäste und jedes Detail organisiert.",
      h1: "Eventplanung in Zürich",
      h1Accent: "Unvergessliche Anlässe – ohne dass Sie etwas organisieren",
      intro: [
        "Der runde Geburtstag, das Jubiläum, das Überraschungs-Dinner: Private Events sollen Freude machen – nicht Arbeit. Unsere Eventplanung in Zürich übernimmt die komplette Organisation, während Sie Gast bei Ihrer eigenen Feier sind.",
        "Von der Location am Zürichsee über Catering, Musik, Dekoration bis zur Gästekoordination: Wir planen Ihren Anlass mit dem Anspruch, den Sie von uns kennen – diskret, persönlich und bis ins letzte Detail durchdacht.",
      ],
      bullets: [
        "Location-Scouting in Zürich & am Zürichsee",
        "Catering, Musik & Dekoration koordiniert",
        "Gästeeinladungen & RSVP-Management",
        "Überraschungen & besondere Momente inszeniert",
        "Dienstleister-Koordination am Veranstaltungstag",
        "Budgetkontrolle & transparente Abrechnung",
      ],
      faq: [
        {
          q: "Welche Anlässe planen Sie?",
          a: "Private Anlässe aller Art: Geburtstage, Jubiläen, Verlobungen, Familienfeste, Dinner-Partys und Firmenanlässe im kleinen Kreis – von 10 bis 100 Gästen, in Zürich und Umgebung.",
        },
        {
          q: "Wie weit im Voraus sollte man mit der Eventplanung starten?",
          a: "Ideal sind 6–10 Wochen Vorlauf für die besten Locations und Dienstleister. Kleinere Anlässe realisieren wir auch kurzfristiger – fragen Sie uns einfach mit Ihrem Wunschdatum an.",
        },
      ],
    },
    en: {
      metaTitle: "Event Planning Zurich | Swiss PA Services",
      metaDesc: "Event planning in Zurich for private occasions: birthdays, anniversaries, dinners and surprises – venue, catering, guests and every detail organised.",
      h1: "Event planning in Zurich",
      h1Accent: "Unforgettable occasions – without you organising a thing",
      intro: [
        "The milestone birthday, the anniversary, the surprise dinner: private events should bring joy – not work. Our event planning in Zurich takes over the complete organisation while you are a guest at your own celebration.",
        "From the venue on Lake Zurich to catering, music, decoration and guest coordination: we plan your occasion with the standards you know from us – discreet, personal and thought through to the last detail.",
      ],
      bullets: [
        "Venue scouting in Zurich & on Lake Zurich",
        "Catering, music & decoration coordinated",
        "Guest invitations & RSVP management",
        "Surprises & special moments staged",
        "Supplier coordination on the event day",
        "Budget control & transparent billing",
      ],
      faq: [
        {
          q: "Which occasions do you plan?",
          a: "Private occasions of all kinds: birthdays, anniversaries, engagements, family celebrations, dinner parties and small company events – from 10 to 100 guests, in Zurich and surroundings.",
        },
        {
          q: "How far ahead should event planning start?",
          a: "Ideally 6–10 weeks of lead time for the best venues and suppliers. Smaller occasions we also realise on shorter notice – just ask us with your desired date.",
        },
      ],
    },
  },
  {
    slugDe: "family-office-services-schweiz",
    slugEn: "family-office-services-switzerland",
    service: "executive-family-assistance",
    de: {
      metaTitle: "Family Office Services Schweiz | Swiss PA Services",
      metaDesc: "Family Office Services in der Schweiz: Lifestyle Concierge, Property Management und persönliche Assistenz für UHNW-Familien und Single Family.",
      h1: "Family Office Services in der Schweiz",
      h1Accent: "Concierge, Property & Assistenz für UHNW-Familien",
      intro: [
        "Family Offices verwalten Vermögen. Aber wer verwaltet den Alltag? Zwischen Residenzen, Reisen, Hauspersonal und Familienlogistik entsteht ein operativer Aufwand, für den klassische Vermögensverwalter nicht ausgerüstet sind. Genau hier setzen unsere Family Office Services an.",
        "Swiss PA Services ist der operative Arm für UHNW-Familien und Single Family Offices in der Schweiz: Lifestyle Concierge, Home & Property Management für mehrere Residenzen, Reise- und Eventmanagement sowie die Koordination von Hauspersonal – diskret, mehrsprachig und unter einer einzigen Ansprechperson gebündelt.",
      ],
      bullets: [
        "Lifestyle Concierge für UHNW-Familien & Principals",
        "Home & Property Management für mehrere Residenzen",
        "Reise-, Jet- & Eventmanagement",
        "Hauspersonal: Rekrutierung, Koordination & Administration",
        "Schnittstelle zu Trustees, Banken, Anwälten & Beratern",
        "Absolute Diskretion – NDA ist bei uns Standard",
      ],
      faq: [
        {
          q: "Arbeiten Sie direkt mit Family Offices zusammen?",
          a: "Ja. Wir sind regelmässig als operative Schnittstelle für Single und Multi Family Offices tätig und koordinieren Lifestyle-, Immobilien- und Alltagsthemen für deren Klienten – auf Wunsch komplett im Hintergrund, als diskrete Verlängerung Ihres Teams.",
        },
        {
          q: "Wie wird Diskretion bei UHNW-Mandaten gewährleistet?",
          a: "Verschwiegenheitserklärungen sind bei uns Standard, keine Ausnahme. Eine feste Ansprechperson, keine Weitergabe von Daten, kein Namensgebrauch – weder intern noch extern. Auf Wunsch kommunizieren wir über verschlüsselte Kanäle Ihrer Wahl.",
        },
      ],
    },
    en: {
      metaTitle: "Family Office Services Switzerland | Swiss PA Services",
      metaDesc: "Family office services in Switzerland: lifestyle concierge, property management and personal assistance for UHNW families and single family offices.",
      h1: "Family Office Services in Switzerland",
      h1Accent: "Concierge, property & assistance for UHNW families",
      intro: [
        "Family offices manage wealth. But who manages daily life? Between residences, travel, household staff and family logistics, an operational workload arises that classic wealth managers are not equipped for. This is exactly where our family office services come in.",
        "Swiss PA Services is the operational arm for UHNW families and single family offices in Switzerland: lifestyle concierge, home & property management across multiple residences, travel and event management, and coordination of household staff – discreet, multilingual and bundled under a single point of contact.",
      ],
      bullets: [
        "Lifestyle concierge for UHNW families & principals",
        "Home & property management across multiple residences",
        "Travel, jet & event management",
        "Household staff: recruitment, coordination & administration",
        "Interface to trustees, banks, lawyers & advisers",
        "Absolute discretion – NDAs are our standard",
      ],
      faq: [
        {
          q: "Do you work directly with family offices?",
          a: "Yes. We regularly act as the operational interface for single and multi family offices, coordinating lifestyle, property and everyday matters for their clients – completely in the background if desired, as a discreet extension of your team.",
        },
        {
          q: "How is discretion guaranteed for UHNW mandates?",
          a: "Non-disclosure agreements are our standard, not an exception. One dedicated contact person, no data sharing, no use of names – internally or externally. On request we communicate via encrypted channels of your choice.",
        },
      ],
    },
  },
  {
    slugDe: "ferienhausverwaltung-zug",
    slugEn: "vacation-home-management-zug",
    service: "home-property-management",
    de: {
      metaTitle: "Ferienhausverwaltung Zug | Swiss PA Services",
      metaDesc: "Ferienhausverwaltung im Kanton Zug: Betreuung von Ferienhäusern und Zweitwohnsitzen am Zugersee & Ägerisee – Home Watch, Unterhalt, Schlüsselservice.",
      h1: "Ferienhausverwaltung im Kanton Zug",
      h1Accent: "Ihr Zweitwohnsitz am Zugersee – bestens betreut",
      intro: [
        "Der Kanton Zug hat eine Besonderheit: Viele Eigentümer von Ferienhäusern und Zweitwohnsitzen am Zuger- und Ägerisee leben im Ausland oder in anderen Kantonen. Genau für diese Eigentümer ist unsere Ferienhausverwaltung in Zug gemacht – mit unserem Sitz an der Baarerstrasse 43 sind wir innert Minuten bei Ihrer Liegenschaft.",
        "Anders als Vermietungsagenturen bleibt Ihr Ferienhaus bei uns privat: Wir kontrollieren regelmässig, koordinieren Handwerker und Gärtner, verwalten Ihre Schlüssel und bereiten alles für Ihre Ankunft vor – mit Reporting auf Deutsch oder Englisch.",
      ],
      bullets: [
        "Home-Watch-Kontrollgänge im ganzen Kanton Zug",
        "Schlüsselverwaltung & Notfallbereitschaft (30 Min. vor Ort)",
        "Koordination von Handwerkern, Gärtnern & Reinigung",
        "Saisonale Kontrollen: Frost, Sturm & Schneelast",
        "An- & Abreise-Vorbereitung: Heizung, Vorräte, Wäsche",
        "Foto-Reporting auf Deutsch oder Englisch",
      ],
      faq: [
        {
          q: "Betreuen Sie auch Eigentumswohnungen in der Stadt Zug?",
          a: "Ja. Wir betreuen Ferienhäuser, Zweitwohnsitze und Eigentumswohnungen im ganzen Kanton – Zug, Baar, Cham, Walchwil, Oberägeri und Umgebung. Egal ob See- oder Berglage.",
        },
        {
          q: "Ich lebe im Ausland – wie funktioniert die Zusammenarbeit?",
          a: "Das ist unser Normalfall: Viele unserer Eigentümer leben im Ausland. Sie erhalten nach jedem Kontrollgang ein Foto-Protokoll auf Englisch oder Deutsch, und bei Problemen koordinieren wir alles – Sie müssen nie selbst anreisen.",
        },
      ],
    },
    en: {
      metaTitle: "Vacation Home Management Zug | Swiss PA Services",
      metaDesc: "Vacation home management in the canton of Zug: care of holiday homes and second residences on Lake Zug & Lake Ägeri.",
      h1: "Vacation home management in Zug",
      h1Accent: "Your second home on Lake Zug – perfectly cared for",
      intro: [
        "The canton of Zug has a peculiarity: many owners of holiday homes and second residences on Lake Zug and Lake Ägeri live abroad or in other cantons. Our vacation home management in Zug is made exactly for these owners – based at Baarerstrasse 43, we are at your property within minutes.",
        "Unlike rental agencies, your holiday home stays private with us: we inspect regularly, coordinate contractors and gardeners, manage your keys and prepare everything for your arrival – with reporting in English or German.",
      ],
      bullets: [
        "Home watch inspections across the canton of Zug",
        "Key holding & emergency response (on site in 30 min)",
        "Coordination of contractors, gardeners & cleaning",
        "Seasonal checks: frost, storms & snow load",
        "Arrival & departure preparation: heating, supplies, linen",
        "Photo reporting in English or German",
      ],
      faq: [
        {
          q: "Do you also look after apartments in the city of Zug?",
          a: "Yes. We look after holiday homes, second residences and condominiums across the canton – Zug, Baar, Cham, Walchwil, Oberägeri and surroundings. Lakeside or mountainside alike.",
        },
        {
          q: "I live abroad – how does the cooperation work?",
          a: "That is our normal case: many of our owners live abroad. You receive a photo report in English or German after every inspection, and if problems arise we coordinate everything – you never have to travel yourself.",
        },
      ],
    },
  },
  {
    slugDe: "ferienhausverwaltung-luzern",
    slugEn: "vacation-home-management-lucerne",
    service: "home-property-management",
    de: {
      metaTitle: "Ferienhausverwaltung Luzern | Swiss PA Services",
      metaDesc: "Ferienhausverwaltung in Luzern & am Vierwaldstättersee: Betreuung von Ferienhäusern und Zweitwohnsitzen in Weggis, Vitznau, Meggen und Kriens.",
      h1: "Ferienhausverwaltung in Luzern",
      h1Accent: "Am Vierwaldstättersee und in der ganzen Region",
      intro: [
        "Luzern und der Vierwaldstättersee gehören zu den schönsten Ferienregionen Europas – entsprechend viele Ferienhäuser und Zweitwohnsitze stehen hier wochenlang leer. Unsere Ferienhausverwaltung in Luzern sorgt dafür, dass Ihre Liegenschaft sicher bleibt und bei Ihrer Ankunft perfekt bereitsteht.",
        "Wir betreuen Objekte in der Stadt Luzern ebenso wie am See: Weggis, Vitznau, Meggen, Kriens und Horw. Regelmässige Kontrollgänge, geprüfte Zentralschweizer Handwerker und ein fester Ansprechpartner – ohne Vermietung, Ihr Ferienhaus bleibt Ihres.",
      ],
      bullets: [
        "Home-Watch-Kontrollgänge in Luzern & am See",
        "Betreuung in Weggis, Vitznau, Meggen, Kriens & Horw",
        "Saisonvorbereitung: Einwintern & Frühlingsstart",
        "Schlüsselverwaltung & Handwerkerkoordination",
        "Garten-, Bootssteg- & Aussenbereichspflege",
        "Ankunftsservice & Foto-Reporting",
      ],
      faq: [
        {
          q: "Betreuen Sie auch Objekte in Weggis und Vitznau?",
          a: "Ja, die See-Gemeinden gehören zu unserem Kerngebiet: Weggis, Vitznau, Meggen, Kriens, Horw und die Stadt Luzern. Wir kennen die lokalen Handwerker und Gegebenheiten persönlich.",
        },
        {
          q: "Was passiert, wenn während meiner Abwesenheit ein Schaden entsteht?",
          a: "Wir entdecken Schäden bei den regelmässigen Kontrollgängen früh, dokumentieren sie mit Fotos, koordinieren die Reparatur mit geprüften Handwerkern und halten Sie transparent auf dem Laufenden – Sie müssen nichts selbst organisieren.",
        },
      ],
    },
    en: {
      metaTitle: "Vacation Home Management Lucerne | Swiss PA Services",
      metaDesc: "Vacation home management in Lucerne & on Lake Lucerne: care of holiday homes and second residences in Weggis, Vitznau, Meggen and Kriens.",
      h1: "Vacation home management in Lucerne",
      h1Accent: "On Lake Lucerne and across the region",
      intro: [
        "Lucerne and Lake Lucerne are among Europe's most beautiful holiday regions – and accordingly, many holiday homes and second residences here stand empty for weeks. Our vacation home management in Lucerne makes sure your property stays safe and is perfectly ready when you arrive.",
        "We look after properties in the city of Lucerne as well as on the lake: Weggis, Vitznau, Meggen, Kriens and Horw. Regular inspections, vetted Central Swiss craftsmen and one dedicated contact – no rentals, your holiday home stays yours.",
      ],
      bullets: [
        "Home watch inspections in Lucerne & on the lake",
        "Care in Weggis, Vitznau, Meggen, Kriens & Horw",
        "Seasonal preparation: winterising & spring opening",
        "Key holding & contractor coordination",
        "Garden, jetty & outdoor area care",
        "Arrival service & photo reporting",
      ],
      faq: [
        {
          q: "Do you also manage properties in Weggis and Vitznau?",
          a: "Yes, the lakeside municipalities are part of our core area: Weggis, Vitznau, Meggen, Kriens, Horw and the city of Lucerne. We know the local craftsmen and conditions personally.",
        },
        {
          q: "What happens if damage occurs while I am away?",
          a: "We detect damage early during regular inspections, document it with photos, coordinate repairs with vetted craftsmen and keep you transparently informed – you don't have to organise anything yourself.",
        },
      ],
    },
  },
  {
    slugDe: "airbnb-verwaltung-schweiz",
    slugEn: "airbnb-management-switzerland",
    service: "home-property-management",
    de: {
      metaTitle: "Airbnb Verwaltung Schweiz | Swiss PA Services",
      metaDesc: "Airbnb-Verwaltung in der Schweiz: Komplette Betreuung Ihrer Ferienwohnung – Gästekommunikation, Check-in, Reinigung.",
      h1: "Airbnb-Verwaltung in der Schweiz",
      h1Accent: "Sie vermieten – wir kümmern uns um alles",
      intro: [
        "Eine Ferienwohnung auf Airbnb ist ein gutes Einkommen – aber auch ein Job: Gäste schreiben um Mitternacht, die Reinigung muss zwischen Check-out und Check-in klappen, Preise wollen ständig angepasst werden. Unsere Airbnb-Verwaltung übernimmt genau das für Sie.",
        "Ob eine Wohnung in Zürich oder ein Chalet in der Zentralschweiz: Wir betreuen Ihre Kurzzeitvermietung komplett – von der Inserat-Optimierung über die Gästebetreuung bis zur Abrechnung. Diskret, zuverlässig und mit dem Anspruch, den Ihre Gäste in 5-Sterne-Bewertungen zurückgeben.",
      ],
      bullets: [
        "Gästekommunikation – 7 Tage die Woche, DE/EN",
        "Check-in, Check-out & Schlüsselübergabe",
        "Reinigung & Wäsche zwischen den Aufenthalten",
        "Preis- & Kalenderoptimierung für maximale Auslastung",
        "Inserat-Optimierung: Texte, Fotos, Bewertungen",
        "Prüfung der Gemeinde-Vorschriften & Bewilligungen",
      ],
      faq: [
        {
          q: "Was kostet die Airbnb-Verwaltung?",
          a: "Üblich sind Modelle mit prozentualem Anteil an den Mieteinnahmen oder eine Pauschale pro Aufenthalt – je nach Objekt und Leistungsumfang. Nach einer kostenlosen Erstbesichtigung erhalten Sie eine transparente Offerte mit realistischer Ertragsschätzung.",
        },
        {
          q: "Ist Kurzzeitvermietung in meiner Gemeinde erlaubt?",
          a: "Das ist in der Schweiz von Gemeinde zu Gemeinde verschieden – teils braucht es Bewilligungen oder es gelten Tageslimits. Wir prüfen das Regelwerk für Ihre Liegenschaft und kümmern uns um die nötigen Anmeldungen, bevor das erste Inserat online geht.",
        },
      ],
    },
    en: {
      metaTitle: "Airbnb Management Switzerland | Swiss PA Services",
      metaDesc: "Airbnb management in Switzerland: complete care of your vacation rental – guest communication, check-in, cleaning, price optimisation and compliance.",
      h1: "Airbnb management in Switzerland",
      h1Accent: "You rent it out – we handle everything",
      intro: [
        "A vacation apartment on Airbnb is good income – but also a job: guests message at midnight, cleaning must happen between check-out and check-in, prices need constant adjusting. Our Airbnb management takes exactly that off your hands.",
        "Whether an apartment in Zurich or a chalet in Central Switzerland: we manage your short-term rental completely – from listing optimisation to guest care and accounting. Discreet, reliable and with the standard your guests return in 5-star reviews.",
      ],
      bullets: [
        "Guest communication – 7 days a week, DE/EN",
        "Check-in, check-out & key handover",
        "Cleaning & laundry between stays",
        "Price & calendar optimisation for maximum occupancy",
        "Listing optimisation: texts, photos, reviews",
        "Checking municipal rules & permits",
      ],
      faq: [
        {
          q: "What does Airbnb management cost?",
          a: "Common models are a percentage of rental income or a flat rate per stay – depending on property and scope. After a free initial visit you receive a transparent quote with a realistic revenue estimate.",
        },
        {
          q: "Is short-term rental allowed in my municipality?",
          a: "In Switzerland this differs from municipality to municipality – sometimes permits are needed or daily limits apply. We check the regulations for your property and handle the necessary registrations before the first listing goes online.",
        },
      ],
    },
  },
  {
    slugDe: "concierge-service-genf",
    slugEn: "concierge-service-geneva",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Concierge Service Genf & Lifestyle Management",
      metaDesc: "Concierge Service und Lifestyle Management in Genf: Reservationen, Events, Reiseplanung und laufende Alltagsorganisation am Genfersee.",
      h1: "Concierge Service in Genf",
      h1Accent: "Ihr Wunsch – in drei Sprachen erledigt",
      intro: [
        "Als Private Concierge in Genf koordinieren wir auf Französisch mit der Stadt – und berichten Ihnen auf Englisch oder Französisch. Von Cologny bis Carouge kennen wir die Adressen, die zählen.",
        "Genf ist eine Weltstadt im kleinen Format: Luxushotellerie am Quai du Mont-Blanc, Michelin-Restaurants, internationale Events. Unser Concierge Service in Genf öffnet Ihnen diese Adressen – auf Französisch, Englisch und Deutsch.",
        "Wir betreuen Diplomaten, internationale Familien und Unternehmer in Genf und rund um den Genfersee: von der Last-Minute-Reservation über private Events bis zur kompletten Wochenend-Organisation in Cologny oder Vandoeuvres.",
      ],
      bullets: [
        "Restaurant- & Hotelreservationen in Genf",
        "Tickets & Zugang zu Events und Vernissagen",
        "Reiseplanung ab Genf – See, Alpen & Côte d'Azur",
        "Private Events in Cologny, Champel & Vandoeuvres",
        "Personal Shopping in der Rue du Rhône",
        "Dreisprachig: FR, EN, DE – mit fester Ansprechsperson",
      ],
      faq: [
        {
          q: "Was macht ein Private Concierge in Genf?",
          a: "Ein Private Concierge in Genf erledigt Reservationen, Events, Reisen und besondere Wünsche – vor Ort auf Französisch koordiniert, mit Ihnen auf Englisch oder Französisch. Gerade für internationale Kunden ohne Französischkenntnisse ist das der entscheidende Vorteil.",
        },
        {
          q: "Arbeiten Sie in Genf auf Französisch?",
          a: "Ja. Vor Ort koordinieren wir auf Französisch mit Restaurants, Hotels und Dienstleistern – mit Ihnen kommunizieren wir auf Englisch oder Deutsch, ganz wie Sie möchten.",
        },
        {
          q: "Was kostet ein Concierge Service in Genf?",
          a: "Ohne Mitgliedschaft und Mindestumsatz: Sie zahlen nur für erledigte Aufgaben, per Stundensatz oder monatlichem Kontingent. Nach einem kostenlosen Erstgespräch erhalten Sie eine transparente Offerte.",
        },
        {
          q: "Was ist der Unterschied zwischen Concierge und Lifestyle Management in Genf?",
          a: "Der Concierge erledigt einzelne Wünsche – vom Tisch im Michelin-Restaurant bis zum Eventticket. Lifestyle Management ist die laufende Partnerschaft: Wir organisieren Ihren Genfer Alltag proaktiv, Woche für Woche. Beides mehrsprachig, ohne Mitgliedschaft.",
        },
      ],
    },
    en: {
      metaTitle: "Private Concierge Geneva | Swiss PA Services",
      metaDesc: "Private concierge and lifestyle management in Geneva: restaurant reservations, events, travel planning and ongoing daily-life organisation on Lake.",
      h1: "Concierge service in Geneva",
      h1Accent: "Your wish – handled in three languages",
      intro: [
        "As a private concierge in Geneva we coordinate in French with the city – and report to you in German or English. From Cologny to Carouge we know the addresses that count.",
        "Geneva is a world city in a small format: luxury hotels on Quai du Mont-Blanc, Michelin restaurants, international events. Our concierge service in Geneva opens these addresses for you – in French, English and German.",
        "We support diplomats, international families and entrepreneurs in Geneva and around Lake Geneva: from last-minute reservations to private events to complete weekend organisation in Cologny or Vandoeuvres.",
      ],
      bullets: [
        "Restaurant & hotel reservations in Geneva",
        "Tickets & access to events and vernissages",
        "Travel planning from Geneva – lake, Alps & Côte d'Azur",
        "Private events in Cologny, Champel & Vandoeuvres",
        "Personal shopping on Rue du Rhône",
        "Trilingual: FR, EN, DE – with one dedicated contact",
      ],
      faq: [
        {
          q: "What does a private concierge in Geneva do?",
          a: "A private concierge in Geneva handles reservations, events, travel and special wishes – coordinated in French on site, in German or English with you. Especially for international clients without French skills, that is the decisive advantage.",
        },
        {
          q: "Do you work in French in Geneva?",
          a: "Yes. On site we coordinate in French with restaurants, hotels and service providers – with you we communicate in English or French, as you prefer.",
        },
        {
          q: "What does a concierge service in Geneva cost?",
          a: "No membership, no minimum spend: you pay only for completed tasks, by hourly rate or monthly allowance. After a free initial consultation you receive a transparent quote.",
        },
        {
          q: "What is the difference between a concierge and lifestyle management in Geneva?",
          a: "A concierge handles individual wishes – from a table at a Michelin restaurant to event tickets. Lifestyle management is the ongoing partnership: we organise your Geneva daily life proactively, week by week. Both trilingual, without membership.",
        },
      ],
    },
  },
  {
    slugDe: "concierge-service-lugano",
    slugEn: "concierge-service-lugano",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Concierge Service Lugano & Lifestyle Management",
      metaDesc: "Concierge Service und Lifestyle Management in Lugano: Reservationen, Bootsausflüge, Events und laufende Organisation Ihrer Zeit am Lago.",
      h1: "Concierge Service in Lugano",
      h1Accent: "Dolce Vita, organisiert von Profis",
      intro: [
        "Als Private Concierge in Lugano verbinden wir Schweizer Präzision mit der Tessiner Art: vor Ort auf Italienisch koordiniert, mit Ihnen auf Deutsch oder Englisch – vom Grotto am Wasser bis zur Ferienresidenz.",
        "Lugano lebt von See, Sonne und Stil: Aperitivo am Lago, Dinner in Morcote, ein Tag auf dem Wasser. Unser Concierge Service in Lugano organisiert das Beste der Region – mit lokalem Netzwerk und diskreter Begleitung.",
        "Ob Sie in Lugano wohnen oder Ihre Ferienresidenz am See besuchen: Wir reservieren, planen und koordinieren – vom Bootsausflug über das private Dinner bis zu Tickets für Events wie das Estival Jazz. Auf Deutsch, Englisch und mit Tessiner Partnern auf Italienisch.",
      ],
      bullets: [
        "Restaurant- & Hotelreservationen in Lugano & Morcote",
        "Bootsausflüge & See-Arrangements auf dem Lago",
        "Event-Tickets: Estival Jazz, Blues to Bop & mehr",
        "Private Anlässe & Überraschungen am See",
        "Ausflüge: Monte Brè, San Salvatore & Comer See",
        "Mehrsprachig: DE, EN & italienisches Netzwerk",
      ],
      faq: [
        {
          q: "Was macht ein Private Concierge in Lugano?",
          a: "Ein Private Concierge in Lugano organisiert die Dolce Vita: Bootsausflüge auf dem Lago, Reservationen in Morcote, Event-Tickets und die komplette Vorbereitung Ihrer Aufenthalte – diskret, mehrsprachig, ohne Mitgliedschaft.",
        },
        {
          q: "Ich bin nur zeitweise in Lugano – lohnt sich ein Concierge?",
          a: "Gerade dann. Wir bereiten Ihren Aufenthalt komplett vor: Reservationen, Aktivitäten, Transport – Sie kommen an und geniessen. Viele unserer Kunden nutzen den Service genau für ihre Wochen am See.",
        },
        {
          q: "Organisieren Sie auch Bootsausflüge und See-Erlebnisse?",
          a: "Ja, das ist unsere Spezialität in Lugano: von der klassischen Seerundfahrt über private Bootscharter bis zum Picknick-Arrangement in einer Bucht – inklusive Reservation in den besten Grotti und Restaurants am Wasser.",
        },
        {
          q: "Bieten Sie auch Lifestyle Management in Lugano an?",
          a: "Ja – gerade für Ferienresidenz-Eigentümer: Während der Concierge einzelne Wünsche erledigt, übernehmen wir beim Lifestyle Management die laufende Organisation Ihrer Zeit am Lago, von der Ankunft bis zur Abreise. Alles vorbereitet, jede Woche.",
        },
      ],
    },
    en: {
      metaTitle: "Concierge Service Lugano | Swiss PA Services",
      metaDesc: "Concierge service and lifestyle management in Lugano: reservations, boat trips, events and ongoing organisation of your time on Lake Lugano.",
      h1: "Concierge service in Lugano",
      h1Accent: "Dolce vita, organised by professionals",
      intro: [
        "As a private concierge in Lugano we combine Swiss precision with the Ticino way: coordinated in Italian on site, in German or English with you – from the grotto on the water to the holiday residence.",
        "Lugano lives from lake, sun and style: aperitivo by the Lago, dinner in Morcote, a day on the water. Our concierge service in Lugano organises the best of the region – with a local network and discreet support.",
        "Whether you live in Lugano or visit your holiday residence on the lake: we reserve, plan and coordinate – from boat trips to private dinners to tickets for events like the Estival Jazz. In German, English and with Ticino partners in Italian.",
      ],
      bullets: [
        "Restaurant & hotel reservations in Lugano & Morcote",
        "Boat trips & lake arrangements on the Lago",
        "Event tickets: Estival Jazz, Blues to Bop & more",
        "Private occasions & surprises by the lake",
        "Excursions: Monte Brè, San Salvatore & Lake Como",
        "Multilingual: DE, EN & Italian network",
      ],
      faq: [
        {
          q: "What does a private concierge in Lugano do?",
          a: "A private concierge in Lugano organises the dolce vita: boat trips on the Lago, reservations in Morcote, event tickets and the complete preparation of your stays – discreet, multilingual, without membership.",
        },
        {
          q: "I am only in Lugano occasionally – is a concierge worth it?",
          a: "Especially then. We prepare your stay completely: reservations, activities, transport – you arrive and enjoy. Many of our clients use the service exactly for their weeks at the lake.",
        },
        {
          q: "Do you also organise boat trips and lake experiences?",
          a: "Yes, that is our speciality in Lugano: from classic lake cruises to private boat charters to picnic arrangements in a bay – including reservations at the best grottos and waterfront restaurants.",
        },
        {
          q: "Do you also offer lifestyle management in Lugano?",
          a: "Yes – especially for holiday residence owners: while the concierge handles individual wishes, with lifestyle management we take over the ongoing organisation of your time on the Lago, from arrival to departure. Everything prepared, every week.",
        },
      ],
    },
  },
  {
    slugDe: "ferienhausverwaltung-lugano",
    slugEn: "vacation-home-management-lugano",
    service: "home-property-management",
    de: {
      metaTitle: "Ferienhausverwaltung Lugano | Swiss PA Services",
      metaDesc: "Ferienhausverwaltung in Lugano: Betreuung von Ferienhäusern und Ferienwohnungen am Lago di Lugano.",
      h1: "Ferienhausverwaltung in Lugano",
      h1Accent: "Ihr Feriendomizil am Lago – immer bereit für Sie",
      intro: [
        "Ein Ferienhaus in Lugano ist Dolce Vita pur – solange bei der Ankunft nicht erst Staub gewischt, der Garten gerettet und die Heizung entlüftet werden muss. Unsere Ferienhausverwaltung in Lugano sorgt dafür, dass Ihre Ferien mit dem Schlüsseldreh beginnen, nicht mit Arbeit.",
        "Wir betreuen Ferienhäuser und Ferienwohnungen in Lugano, Paradiso, Morcote, Gandria und am ganzen See – privat und ohne Vermietung. Regelmässige Kontrollgänge, geprüfte Tessiner Handwerker und ein fester Ansprechpartner, der Ihnen auf Deutsch oder Englisch berichtet.",
      ],
      bullets: [
        "Regelmässige Home-Watch-Kontrollgänge mit Foto-Protokoll",
        "Schlüsselverwaltung & Zutrittsorganisation vor Ort",
        "Koordination italienischsprachiger Handwerker & Gärtner",
        "Garten-, Pool- & Terrassenpflege inklusive",
        "Ankunfts-Vorbereitung: Klima, Vorräte, frische Wäsche",
        "Schadensmeldung & Reparatur-Koordination in Ihrer Abwesenheit",
      ],
      faq: [
        {
          q: "Was unterscheidet die Ferienhausverwaltung vom Property Management?",
          a: "Die Ferienhausverwaltung ist auf saisonal genutzte Objekte zugeschnitten: Saisonvorbereitung, Ankunfts-Service und Abwesenheitskontrollen stehen im Zentrum. Das allgemeine Property Management in Lugano umfasst zusätzlich laufende Administration und Werterhalt-Themen für ganzjährig genutzte Liegenschaften.",
        },
        {
          q: "Ich komme nur wenige Wochen pro Jahr – lohnt sich das?",
          a: "Gerade dann. Leerstehende Ferienhäuser entwickeln die meisten Probleme in der Abwesenheit: Wasser, Schimmel, Ungeziefer, Sturmschäden. Unsere regelmässigen Kontrollen verhindern teure Überraschungen – und Ihre wenigen Ferienwochen bleiben Ferien.",
        },
      ],
    },
    en: {
      metaTitle: "Vacation Home Management Lugano | Swiss PA Services",
      metaDesc: "Vacation home management in Lugano: care of holiday homes and apartments on Lake Lugano – home watch, maintenance, key holding and arrival preparation.",
      h1: "Vacation home management in Lugano",
      h1Accent: "Your holiday home on the lake – always ready for you",
      intro: [
        "A holiday home in Lugano is pure dolce vita – as long as arrival doesn't start with dusting, rescuing the garden and bleeding the heating. Our vacation home management in Lugano makes sure your holiday begins with the turn of a key, not with work.",
        "We look after holiday homes and apartments in Lugano, Paradiso, Morcote, Gandria and around the entire lake – private and without rentals. Regular inspections, vetted Ticino craftsmen and one dedicated contact who reports to you in German or English.",
      ],
      bullets: [
        "Regular home watch inspections with photo reports",
        "Key holding & access organisation on site",
        "Coordination of Italian-speaking craftsmen & gardeners",
        "Garden, pool & terrace care included",
        "Arrival preparation: climate, supplies, fresh linen",
        "Damage reporting & repair coordination in your absence",
      ],
      faq: [
        {
          q: "What is the difference between vacation home management and property management?",
          a: "Vacation home management is tailored to seasonally used properties: seasonal preparation, arrival service and absence checks are at the centre. General property management in Lugano additionally covers ongoing administration and value preservation for year-round residences.",
        },
        {
          q: "I only come a few weeks per year – is it worth it?",
          a: "Especially then. Empty holiday homes develop most problems during absence: water, mould, pests, storm damage. Our regular checks prevent expensive surprises – and your few holiday weeks remain holidays.",
        },
      ],
    },
  },
  {
    slugDe: "property-management-zuerichsee",
    slugEn: "property-management-lake-zurich",
    service: "home-property-management",
    de: {
      metaTitle: "Property Management Zürichsee | Swiss PA Services",
      metaDesc: "Property Management am Zürichsee: Betreuung von Residenzen an der Goldküste und am linken Ufer.",
      h1: "Property Management am Zürichsee",
      h1Accent: "Von der Goldküste bis Rapperswil – Ihre Residenz in besten Händen",
      intro: [
        "Eine Residenz am Zürichsee ist mehr als eine Immobilie – sie ist ein Lebensmittelpunkt mit Seeblick, Garten und Anspruch. Damit das so bleibt, braucht es jemanden, der sich kümmert: unser Property Management am Zürichsee betreut Ihre Liegenschaft ganzjährig, ob Sie darin wohnen oder nicht.",
        "Wir betreuen Residenzen an der Goldküste (Küsnacht, Zollikon, Meilen, Herrliberg) ebenso wie am linken Ufer (Thalwil, Horgen, Wädenswil) bis nach Rapperswil: Home-Watch-Kontrollen, Hauspersonal, Handwerker, Garten und Steg – diskret und ohne Vermietung.",
      ],
      bullets: [
        "Home-Watch-Kontrollgänge am ganzen Zürichsee",
        "Hauspersonal- & Handwerkerkoordination",
        "Garten-, Pool- & Stegpflege inklusive",
        "Schlüsselverwaltung & Zutrittsorganisation",
        "An- und Abreise-Service für Eigentümer",
        "Werterhalt-Management & transparentes Reporting",
      ],
      faq: [
        {
          q: "Welche Orte am Zürichsee betreuen Sie?",
          a: "Den ganzen See: Goldküste (Zollikon, Küsnacht, Erlenbach, Meilen, Herrliberg), linkes Ufer (Thalwil, Horgen, Wädenswil, Richterswil) sowie Rapperswil-Jona und die Stadt Zürich selbst.",
        },
        {
          q: "Was kostet Property Management am Zürichsee?",
          a: "Je nach Liegenschaft und Leistungsumfang – typisch sind monatliche Betreuungspauschalen, die Kontrollgänge, Koordination und Reporting abdecken. Nach einer kostenlosen Erstbesichtigung erhalten Sie eine transparente Offerte.",
        },
      ],
    },
    en: {
      metaTitle: "Property Management Lake Zurich | Swiss PA Services",
      metaDesc: "Property management on Lake Zurich: care of residences on the Gold Coast and the left shore.",
      h1: "Property Management on Lake Zurich",
      h1Accent: "From the Gold Coast to Rapperswil – your residence in the best hands",
      intro: [
        "A residence on Lake Zurich is more than a property – it is a centre of life with a lake view, garden and high standards. To keep it that way, someone needs to take care: our property management on Lake Zurich looks after your estate all year round, whether you live in it or not.",
        "We look after residences on the Gold Coast (Küsnacht, Zollikon, Meilen, Herrliberg) as well as on the left shore (Thalwil, Horgen, Wädenswil) up to Rapperswil: home watch inspections, household staff, contractors, garden and jetty – discreet and without rentals.",
      ],
      bullets: [
        "Home watch inspections across Lake Zurich",
        "Household staff & contractor coordination",
        "Garden, pool & jetty care included",
        "Key holding & access organisation",
        "Arrival & departure service for owners",
        "Value preservation & transparent reporting",
      ],
      faq: [
        {
          q: "Which locations on Lake Zurich do you cover?",
          a: "The entire lake: Gold Coast (Zollikon, Küsnacht, Erlenbach, Meilen, Herrliberg), left shore (Thalwil, Horgen, Wädenswil, Richterswil) as well as Rapperswil-Jona and the city of Zurich itself.",
        },
        {
          q: "What does property management on Lake Zurich cost?",
          a: "Depending on the property and scope – typical are monthly care packages covering inspections, coordination and reporting. After a free initial visit you receive a transparent quote.",
        },
      ],
    },
  },
  {
    slugDe: "zweitwohnsitz-betreuung-zuerichsee",
    slugEn: "second-home-care-lake-zurich",
    service: "home-property-management",
    de: {
      metaTitle: "Zweitwohnsitz Betreuung Zürichsee | Swiss PA Services",
      metaDesc: "Zweitwohnsitz-Betreuung am Zürichsee: Abwesenheitskontrollen, Home Watch, Schlüsselverwaltung und Vorbereitung Ihrer Ankunft.",
      h1: "Zweitwohnsitz-Betreuung am Zürichsee",
      h1Accent: "Sie sind abwesend – Ihr Zweitwohnsitz ist es nie",
      intro: [
        "Viele Zweitwohnsitze am Zürichsee gehören Menschen, die im Ausland arbeiten oder in einer anderen Stadt leben. Wochenlang leer stehende Wohnungen und Häuser entwickeln genau dann Probleme: Wasser, Schimmel, Einbruch, volle Briefkästen. Unsere Zweitwohnsitz-Betreuung am Zürichsee verhindert genau das.",
        "Wir kontrollieren Ihre Liegenschaft regelmässig, organisieren Zutritt für Handwerker und Reinigung, leeren die Post und bereiten alles für Ihre nächste Ankunft vor – mit Foto-Protokoll nach jedem Kontrollgang, direkt auf Ihr Handy.",
      ],
      bullets: [
        "Regelmässige Abwesenheitskontrollen (Home Watch)",
        "Post- & Paketservice, Lüften, Pflanzen, Kühlschrank",
        "Zutrittsorganisation für Handwerker & Reinigung",
        "Schlüsselverwaltung & Notfallbereitschaft",
        "Vorbereitung vor Ihrer Ankunft: Heizung, Vorräte, Wäsche",
        "Foto-Protokoll nach jedem Kontrollgang",
      ],
      faq: [
        {
          q: "Wie oft sollte ein Zweitwohnsitz kontrolliert werden?",
          a: "Empfohlen sind wöchentliche bis vierzehntägige Kontrollen. Viele Versicherungen erwarten bei längerer Abwesenheit regelmässige Kontrollgänge (Sorgfaltspflicht) – unsere dokumentierten Protokolle erfüllen diese Anforderung.",
        },
        {
          q: "Was kostet die Zweitwohnsitz-Betreuung am Zürichsee?",
          a: "Nach Objektgrösse und Kontrollrhythmus als monatliche Pauschale – ein Bruchteil dessen, was ein unentdeckter Wasserschaden kostet. Nach einer kostenlosen Erstbesichtigung erhalten Sie eine transparente Offerte.",
        },
      ],
    },
    en: {
      metaTitle: "Second Home Care Lake Zurich | Swiss PA Services",
      metaDesc: "Second home care on Lake Zurich: absence inspections, home watch, key holding and preparation of your arrival – for owners who are not permanently on site.",
      h1: "Second home care on Lake Zurich",
      h1Accent: "You are away – your second home never is",
      intro: [
        "Many second homes on Lake Zurich belong to people who work abroad or live in another city. Apartments and houses standing empty for weeks develop exactly then problems: water, mould, burglary, overflowing letterboxes. Our second home care on Lake Zurich prevents exactly that.",
        "We inspect your property regularly, organise access for contractors and cleaning, handle the mail and prepare everything for your next arrival – with a photo report after every inspection, straight to your phone.",
      ],
      bullets: [
        "Regular absence inspections (home watch)",
        "Mail & parcel service, airing, plants, refrigerator",
        "Access organisation for contractors & cleaning",
        "Key holding & emergency response",
        "Preparation before your arrival: heating, supplies, linen",
        "Photo report after every inspection",
      ],
      faq: [
        {
          q: "How often should a second home be inspected?",
          a: "Weekly to bi-weekly checks are recommended. Many insurers expect regular inspections during longer absences (duty of care) – our documented reports fulfil this requirement.",
        },
        {
          q: "What does second home care on Lake Zurich cost?",
          a: "A monthly flat rate based on property size and inspection rhythm – a fraction of what an undiscovered water damage costs. After a free initial visit you receive a transparent quote.",
        },
      ],
    },
  },
  {
    slugDe: "home-watch-zug",
    slugEn: "home-watch-service-zug",
    service: "home-property-management",
    de: {
      metaTitle: "Home Watch Zug | Swiss PA Services",
      metaDesc: "Home Watch Service in Zug: regelmässige Kontrollgänge für Ihre Liegenschaft mit Foto-Protokoll – Wasser, Heizung, Sicherheit.",
      h1: "Home Watch Service in Zug",
      h1Accent: "Kontrollgänge mit Foto-Protokoll – direkt aus Zug",
      intro: [
        "Home Watch heisst: Jemand schaut regelmässig nach Ihrer Liegenschaft, während Sie weg sind – dokumentiert, zuverlässig, mit Protokoll. Unser Home Watch Service in Zug kommt von der Baarerstrasse 43 und ist innert 30 Minuten bei jedem Objekt im Kanton.",
        "Ob Hauptwohnsitz während Ihrer Reise oder Zweitwohnsitz am Zugersee: Wir kontrollieren Wasser, Heizung, Strom, Fenster und Schlösser, kümmern uns um Post und Pflanzen und melden jeden Befund sofort – auf Deutsch oder Englisch.",
      ],
      bullets: [
        "Kontrollgänge wöchentlich oder vierzehntägig",
        "Check: Wasser, Heizung, Strom & Haushaltsgeräte",
        "Fenster, Türen, Schlösser & Alarmanlage",
        "Post, Pakete, Lüften & Pflanzen",
        "Sofortige Schadensmeldung & Handwerkerkoordination",
        "Foto-Protokoll auf Deutsch oder Englisch",
      ],
      faq: [
        {
          q: "Wie schnell sind Sie im Notfall vor Ort?",
          a: "Da wir in Zug ansässig sind, erreichen wir jedes Objekt im Kanton in der Regel innert 30 Minuten – bei Wasserschaden, Sturm oder Alarmauslösung sind wir Ihr erster Ansprechpartner vor Ort.",
        },
        {
          q: "Was kostet Home Watch in Zug?",
          a: "Je nach Objekt und Rhythmus als monatliche Pauschale. Nach einer kostenlosen Erstbesichtigung erhalten Sie eine transparente Offerte – inklusive Kontrollplan, der typische Versicherungsauflagen erfüllt.",
        },
      ],
    },
    en: {
      metaTitle: "Home Watch Service Zug | Swiss PA Services",
      metaDesc: "Home watch service in Zug: regular property inspections with photo reports – water, heating, security.",
      h1: "Home Watch Service in Zug",
      h1Accent: "Inspections with photo reports – straight from Zug",
      intro: [
        "Home watch means: someone regularly checks on your property while you are away – documented, reliable, with a report. Our home watch service in Zug is based at Baarerstrasse 43 and reaches every property in the canton within 30 minutes.",
        "Whether your main residence during your travels or a second home on Lake Zug: we check water, heating, electricity, windows and locks, take care of mail and plants and report every finding immediately – in German or English.",
      ],
      bullets: [
        "Inspections weekly or bi-weekly",
        "Check: water, heating, electricity & appliances",
        "Windows, doors, locks & alarm system",
        "Mail, parcels, airing & plants",
        "Immediate damage reporting & contractor coordination",
        "Photo report in German or English",
      ],
      faq: [
        {
          q: "How quickly can you be on site in an emergency?",
          a: "As we are based in Zug, we usually reach any property in the canton within 30 minutes – for water damage, storms or alarm triggers we are your first responder on site.",
        },
        {
          q: "What does home watch in Zug cost?",
          a: "A monthly flat rate depending on property and rhythm. After a free initial visit you receive a transparent quote – including an inspection plan that meets typical insurance requirements.",
        },
      ],
    },
  },
  {
    slugDe: "privater-assistent-schweiz",
    slugEn: "private-assistant-switzerland",
    service: "persoenliche-assistenz",
    de: {
      metaTitle: "Privater Assistent Schweiz | Swiss PA Services",
      metaDesc: "Privater Assistent in der Schweiz: persönliche Unterstützung für Alltag, Business und Familie – diskret, flexibel buchbar, ohne Festanstellung.",
      h1: "Privater Assistent in der Schweiz",
      h1Accent: "Persönlich. Diskret. Auf Abruf.",
      intro: [
        "Ein privater Assistent ist Ihre persönliche Entlastung für alles, was Zeit frisst: Termine, Korrespondenz, Reisen, Besorgungen, Haushalt. Kein Standard-Service, sondern eine feste Vertrauensperson, die Ihre Gewohnheiten kennt und Dinge erledigt, bevor Sie daran denken.",
        "Swiss PA Services bietet private Assistenz in der ganzen Schweiz: vor Ort in Zug und Zürich, remote für alles andere. Auf Deutsch und Englisch, ohne Festanstellung – Sie buchen genau die Unterstützung, die Sie brauchen.",
      ],
      bullets: [
        "Alltags- & Terminorganisation",
        "Reiseplanung & Reservationen",
        "Korrespondenz auf Deutsch & Englisch",
        "Haushalts- & Dienstleisterkoordination",
        "Besorgungen, Botengänge & Erledigungen",
        "Vor Ort in Zug & Zürich – remote schweizweit",
      ],
      faq: [
        {
          q: "Was ist der Unterschied zwischen privatem Assistenten und Personal Assistant?",
          a: "Keiner – es sind zwei Begriffe für dieselbe Leistung. Ob Sie einen privaten Assistenten oder eine persönliche Assistenz suchen: Bei uns bekommen Sie eine feste Ansprechsperson für Ihren Alltag, flexibel buchbar und ohne Anstellung.",
        },
        {
          q: "Was kostet ein privater Assistent in der Schweiz?",
          a: "Wir arbeiten mit Stundenpaketen und monatlichen Mandaten – deutlich günstiger als eine Festanstellung, ohne Lohnnebenkosten. Nach einem kostenlosen Erstgespräch erhalten Sie eine transparente Offerte.",
        },
      ],
    },
    en: {
      metaTitle: "Private Assistant Switzerland | Swiss PA Services",
      metaDesc: "Private assistant in Switzerland: personal support for daily life, business and family – discreet, flexibly bookable, no permanent hire.",
      h1: "Private assistant in Switzerland",
      h1Accent: "Personal. Discreet. On demand.",
      intro: [
        "A private assistant is your personal relief for everything that eats time: appointments, correspondence, travel, errands, household. Not a standard service, but a dedicated trusted person who knows your habits and gets things done before you think of them.",
        "Swiss PA Services offers private assistance across Switzerland: on site in Zug and Zurich, remote for everything else. In German and English, without permanent employment – you book exactly the support you need.",
      ],
      bullets: [
        "Everyday & appointment organisation",
        "Travel planning & reservations",
        "Correspondence in German & English",
        "Household & service provider coordination",
        "Shopping, errands & tasks",
        "On site in Zug & Zurich – remote Switzerland-wide",
      ],
      faq: [
        {
          q: "What is the difference between a private assistant and a personal assistant?",
          a: "None – they are two terms for the same service. Whether you are looking for a private assistant or a personal assistant: with us you get a dedicated contact for your daily life, flexibly bookable and without employment.",
        },
        {
          q: "What does a private assistant in Switzerland cost?",
          a: "We work with hour packages and monthly mandates – significantly cheaper than a permanent hire, without payroll costs. After a free initial consultation you receive a transparent quote.",
        },
      ],
    },
  },
  {
    slugDe: "expat-services-zuerich",
    slugEn: "expat-services-zurich",
    service: "relocation-services-schweiz",
    de: {
      metaTitle: "Expat Services Zürich | Swiss PA Services",
      metaDesc: "Expat Services in Zürich: Von der Wohnungssuche über Behörden und Schulen bis zur Alltagsbetreuung.",
      h1: "Expat Services in Zürich",
      h1Accent: "Nicht nur ankommen – ankommen und leben",
      intro: [
        "Klassische Relocation endet mit dem Einzug. Das echte Expat-Leben beginnt danach: Steuererklärung, Kinderbetreuung, Arzt finden, Auto anmelden, Freunde finden. Unsere Expat Services in Zürich begleiten Sie weit über den Umzug hinaus – so lange Sie uns brauchen.",
        "Ob Sie gerade nach Zürich gezogen sind oder schon Jahre hier leben: Wir sind Ihre lokale Vertrauensperson für alles, was auf Englisch schwierig ist – vom Behördentermin bis zur Wohnungskündigung. Diskret, persönlich und mit festem Ansprechpartner.",
      ],
      bullets: [
        "Settling-in: Behörden, Banken, Versicherungen",
        "Wohnungssuche & Wohnungswechsel in Zürich",
        "Schul- & Kinderbetreuungsberatung",
        "Laufende Alltagsbetreuung auf Englisch & Deutsch",
        "Arzt-, Steuer- & Vertragsfragen koordiniert",
        "Departure Services bei Wegzug aus Zürich",
      ],
      faq: [
        {
          q: "Was ist der Unterschied zwischen Relocation und Expat Services?",
          a: "Relocation deckt den Umzug ab: Wohnung, Bewilligung, Anmeldung. Expat Services sind die laufende Betreuung danach – alles, was im Alltag anfällt, wenn Sie in Zürich leben: Behörden, Schule, Arzt, Verträge, Organisation. Viele Kunden bleiben monatelang oder jahrelang bei uns.",
        },
        {
          q: "Kann ich die Expat Services auch nutzen, wenn ich schon länger in Zürich bin?",
          a: "Absolut. Viele unserer Kunden leben seit Jahren in Zürich und nutzen uns für die Dinge, die auf Englisch mühsam sind: Steuererklärung koordinieren, Wohnungswechsel, Kündigungen, Handwerker-Termine. Buchen Sie uns stundenweise oder als monatliches Kontingent.",
        },
      ],
    },
    en: {
      metaTitle: "Expat Services Zurich | Swiss PA Services",
      metaDesc: "Expat services in Zurich: from home search to authorities and schools to everyday support – ongoing assistance for expats in Zurich, far beyond the move.",
      h1: "Expat Services in Zurich",
      h1Accent: "Not just arriving – arriving and living",
      intro: [
        "Classic relocation ends with moving in. Real expat life begins after: tax returns, childcare, finding a doctor, registering a car, making friends. Our expat services in Zurich support you far beyond the move – for as long as you need us.",
        "Whether you just moved to Zurich or have lived here for years: we are your local trusted person for everything that is difficult in English – from the authority appointment to the apartment handover. Discreet, personal and with a dedicated contact.",
      ],
      bullets: [
        "Settling-in: authorities, banks, insurances",
        "Home search & apartment changes in Zurich",
        "School & childcare advice",
        "Ongoing everyday support in English & German",
        "Doctor, tax & contract matters coordinated",
        "Departure services when leaving Zurich",
      ],
      faq: [
        {
          q: "What is the difference between relocation and expat services?",
          a: "Relocation covers the move: home, permit, registration. Expat services are the ongoing support afterwards – everything that comes up in daily life when you live in Zurich: authorities, school, doctor, contracts, organisation. Many clients stay with us for months or years.",
        },
        {
          q: "Can I use expat services if I have lived in Zurich for a while?",
          a: "Absolutely. Many of our clients have lived in Zurich for years and use us for the things that are tedious in English: coordinating tax returns, apartment changes, terminations, contractor appointments. Book us by the hour or as a monthly allowance.",
        },
      ],
    },
  },
  {
    slugDe: "expat-services-zug",
    slugEn: "expat-services-zug",
    service: "relocation-services-schweiz",
    de: {
      metaTitle: "Expat Services Zug | Swiss PA Services",
      metaDesc: "Expat Services in Zug: Wohnungssuche, Bewilligungen, internationale Schulen (ISZL) und laufende Alltagsbetreuung.",
      h1: "Expat Services in Zug",
      h1Accent: "Ihre lokale Vertrauensperson im Kanton Zug",
      intro: [
        "Zug ist eine der internationalsten Gemeinden der Schweiz – Crypto Valley, tiefe Steuern, höchste Lebensqualität. Aber der Alltag läuft auf Deutsch: Gemeinde, Vermieter, Krankenkasse, Schule. Unsere Expat Services in Zug sind Ihre Übersetzung in den Schweizer Alltag.",
        "Von der Baarerstrasse 43 betreuen wir Expats und internationale Familien im ganzen Kanton: Wohnungssuche in Zug, Baar und Cham, ISZL- und Schulberatung, Behörden, Steuern und alle kleinen Dinge, die das Leben in der Schweiz einfach machen – wenn man sie kennt.",
      ],
      bullets: [
        "Settling-in im Kanton Zug: Behörden & Bewilligungen",
        "Wohnungssuche in Zug, Baar, Cham & Risch",
        "Schulberatung: ISZL, Montana & öffentliche Schulen",
        "Steuer- & Versicherungsfragen koordiniert",
        "Laufende Alltagsbetreuung auf Englisch & Deutsch",
        "Departure Services bei Wegzug aus der Schweiz",
      ],
      faq: [
        {
          q: "Sie sind in Zug – was bedeutet das für mich?",
          a: "Dass wir alles persönlich kennen: die Einwohnerkontrolle, die Vermieter, die Wartelisten der Schulen. Wir gehen mit Ihnen zu Terminen, übersetzen live und erledigen Dinge vor Ort – kein Callcenter, kein Remote-Service aus dem Ausland.",
        },
        {
          q: "Unterstützen Sie auch meine Familie?",
          a: "Ja, Familien sind unser Schwerpunkt in Zug: Schulplatz finden, Kinderbetreuung organisieren, Ärzte, Sportvereine, Fahrausweis umschreiben – wir machen Ihre ganze Familie sesshaft, nicht nur Sie.",
        },
      ],
    },
    en: {
      metaTitle: "Expat Services Zug | Swiss PA Services",
      metaDesc: "Expat services in Zug: home search, permits, international schools (ISZL) and ongoing everyday support.",
      h1: "Expat Services in Zug",
      h1Accent: "Your local trusted person in the canton of Zug",
      intro: [
        "Zug is one of the most international communities in Switzerland – Crypto Valley, low taxes, top quality of life. But daily life runs in German: municipality, landlords, health insurance, school. Our expat services in Zug are your translation into Swiss everyday life.",
        "From Baarerstrasse 43 we support expats and international families across the canton: home search in Zug, Baar and Cham, ISZL and school advice, authorities, taxes and all the little things that make life in Switzerland easy – once you know them.",
      ],
      bullets: [
        "Settling-in in canton Zug: authorities & permits",
        "Home search in Zug, Baar, Cham & Risch",
        "School advice: ISZL, Montana & public schools",
        "Tax & insurance matters coordinated",
        "Ongoing everyday support in English & German",
        "Departure services when leaving Switzerland",
      ],
      faq: [
        {
          q: "You are based in Zug – what does that mean for me?",
          a: "That we know everything personally: the residents' office, the landlords, the school waiting lists. We accompany you to appointments, translate live and handle things on site – no call centre, no remote service from abroad.",
        },
        {
          q: "Do you also support my family?",
          a: "Yes, families are our focus in Zug: finding school places, organising childcare, doctors, sports clubs, converting driving licences – we settle your whole family, not just you.",
        },
      ],
    },
  },
  {
    slugDe: "ferienhausverwaltung-waadt",
    slugEn: "second-home-management-vaud",
    service: "home-property-management",
    de: {
      metaTitle: "Ferienhausverwaltung Waadt | Swiss PA Services",
      metaDesc: "Ferienhausverwaltung im Kanton Waadt: Betreuung von Zweitwohnsitzen in Lausanne, Montreux, Vevey & Lavaux – Home Watch, Unterhalt, Ankunfts-Service.",
      h1: "Ferienhausverwaltung in der Waadt",
      h1Accent: "Zweitwohnsitze am Genfersee – bestens betreut",
      intro: [
        "Die Waadt mit Lausanne, Montreux, Vevey und den Lavaux-Terrassen ist eine der beliebtesten Zweitwohnsitz-Regionen der Schweiz – bei Deutschschweizern wie bei internationalen Eigentümern. Wenn Sie nicht da sind, braucht Ihre Liegenschaft am Genfersee zuverlässige Betreuung.",
        "Wir koordinieren vor Ort mit geprüften, französischsprachigen Dienstleistern und Handwerkern: regelmässige Home-Watch-Kontrollen, Unterhalt, Schlüsselverwaltung und die komplette Vorbereitung vor Ihrer Ankunft. Berichtet wird auf Deutsch oder Englisch – vermietet wird nichts.",
      ],
      bullets: [
        "Home-Watch-Kontrollgänge in Lausanne, Montreux & Vevey",
        "Zweitwohnsitz-Betreuung in Lavaux & am Genfersee",
        "Schlüsselverwaltung & Zutrittsorganisation",
        "Koordination französischsprachiger Handwerker",
        "Saisonvorbereitung & Ankunfts-Service",
        "Foto-Reporting auf Deutsch oder Englisch",
      ],
      faq: [
        {
          q: "Sie sitzen in Zug – wie betreuen Sie Objekte in der Waadt?",
          a: "Über unser geprüftes Netzwerk vor Ort: Kontrollgänge und Handwerkerstermine führen lokale Partner durch, die wir koordinieren und kontrollieren. Sie haben nur einen Ansprechpartner – uns – und erhalten jedes Protokoll auf Deutsch oder Englisch.",
        },
        {
          q: "Ich spreche kein Französisch – ist das ein Problem?",
          a: "Nein. Genau dafür sind wir da: Wir übernehmen die komplette Kommunikation mit Behörden, Verwaltungen und Handwerkern auf Französisch und halten Sie auf Deutsch oder Englisch auf dem Laufenden.",
        },
      ],
    },
    en: {
      metaTitle: "Second Home Management Vaud | Swiss PA Services",
      metaDesc: "Second home management in the canton of Vaud: care of holiday homes in Lausanne, Montreux, Vevey & Lavaux – home watch, maintenance, arrival service.",
      h1: "Second home management in Vaud",
      h1Accent: "Your second home on Lake Geneva – perfectly cared for",
      intro: [
        "Vaud with Lausanne, Montreux, Vevey and the Lavaux terraces is one of Switzerland's most popular second home regions – for Swiss and international owners alike. When you are away, your Lake Geneva property needs reliable care.",
        "We coordinate on site with vetted French-speaking service providers and craftsmen: regular home watch inspections, maintenance, key holding and complete preparation before your arrival. Reporting in German or English – and no rentals, your home stays yours.",
      ],
      bullets: [
        "Home watch inspections in Lausanne, Montreux & Vevey",
        "Second home care in Lavaux & on Lake Geneva",
        "Key holding & access organisation",
        "Coordination of French-speaking craftsmen",
        "Seasonal preparation & arrival service",
        "Photo reporting in German or English",
      ],
      faq: [
        {
          q: "You are based in Zug – how do you manage properties in Vaud?",
          a: "Through our vetted local network: inspections and contractor appointments are carried out by local partners whom we coordinate and supervise. You have only one point of contact – us – and receive every report in German or English.",
        },
        {
          q: "I don't speak French – is that a problem?",
          a: "No. That is exactly what we are here for: we handle all communication with authorities, property managers and craftsmen in French and keep you updated in German or English.",
        },
      ],
    },
  },
  {
    slugDe: "luxus-concierge-schweiz",
    slugEn: "luxury-concierge-service-switzerland",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Luxus Concierge Schweiz | Swiss PA Services",
      metaDesc: "Luxus Concierge in der Schweiz: Zugang zu ausgebuchten Adressen, private Events, Jet- & Reise-Koordination und exklusive Erlebnisse.",
      h1: "Luxus Concierge in der Schweiz",
      h1Accent: "Zugang zum scheinbar Unmöglichen",
      intro: [
        "Luxus ist nicht das, was man kaufen kann – sondern das, was man bekommt, wenn alle Türen offen sind. Unser Luxus Concierge in der Schweiz öffnet sie: ausgebuchte Restaurants, private Events, Reisen, die es nicht im Katalog gibt, und Erlebnisse, die man nicht googeln kann.",
        "Wir betreuen UHNW-Kunden, Unternehmer und internationale Familien, die das Besondere erwarten – diskret, mit fester Ansprechperson und NDA-Standard. Keine Mitgliedschaft, kein Katalog: Jeder Wunsch wird individuell realisiert.",
      ],
      bullets: [
        "Zugang zu ausgebuchten Restaurants, Hotels & Events",
        "Private Jet-, Yacht- & Chauffeur-Koordination",
        "Massgeschneiderte Luxusreisen mit jedem Detail",
        "Exklusive Erlebnisse & private Anlässe",
        "Personal Shopping & rare Beschaffungen",
        "UHNW-Diskretion: NDA-Standard, eine Ansprechperson",
      ],
      faq: [
        {
          q: "Was unterscheidet einen Luxus Concierge vom privaten Concierge?",
          a: "Der private Concierge entlastet Ihren Alltag. Der Luxus Concierge realisiert das Aussergewöhnliche: Zugänge, Erlebnisse und Reisen auf höchstem Niveau – von der privatisierten Berghütte bis zum Tisch, der offiziell ausgebucht ist. Bei uns bekommen Sie beides aus einer Hand.",
        },
        {
          q: "Wie läuft die Zusammenarbeit ab?",
          a: "Ein Gespräch genügt: Sie schildern Ihren Wunsch, wir liefern Optionen mit transparentem Preis, und nach Ihrer Freigabe realisieren wir alles diskret im Hintergrund. Keine Mitgliedschaft, kein Mindestumsatz – abgerechnet wird nur die tatsächliche Leistung.",
        },
        {
          q: "Gibt es feste Service-Modelle oder Pläne?",
          a: "Drei Modelle, keine Mitgliedschaft: einzelne Wünsche per Stundensatz, ein monatliches Kontingent für regelmässige Anliegen – oder ein laufendes Private-Client-Mandat mit fester Ansprechperson und garantierter Verfügbarkeit. Nach dem kostenlosen Erstgespräch erhalten Sie eine transparente Offerte für das passende Modell.",
        },
      ],
    },
    en: {
      metaTitle: "Luxury Concierge Service Switzerland | Swiss PA Services",
      metaDesc: "Luxury concierge service in Switzerland: access to fully booked addresses, private events, jet & travel coordination and exclusive experiences.",
      h1: "Luxury Concierge in Switzerland",
      h1Accent: "Access to the seemingly impossible",
      intro: [
        "Luxury is not what money can buy – it is what you get when every door opens. Our luxury concierge in Switzerland opens them: fully booked restaurants, private events, journeys that exist in no catalogue, and experiences you cannot google.",
        "We serve UHNW clients, entrepreneurs and international families who expect the exceptional – discreetly, with a dedicated contact and NDA standard. No membership, no catalogue: every wish is realised individually.",
      ],
      bullets: [
        "Access to fully booked restaurants, hotels & events",
        "Private jet, yacht & chauffeur coordination",
        "Tailor-made luxury travel with every detail",
        "Exclusive experiences & private occasions",
        "Personal shopping & rare sourcing",
        "UHNW discretion: NDA standard, one contact",
      ],
      faq: [
        {
          q: "What distinguishes a luxury concierge from a private concierge?",
          a: "The private concierge unburdens your daily life. The luxury concierge realises the extraordinary: access, experiences and travel at the highest level – from the privatised mountain lodge to the table that is officially fully booked. With us you get both from one source.",
        },
        {
          q: "How does the cooperation work?",
          a: "One conversation is enough: you describe your wish, we deliver options with transparent pricing, and after your approval we realise everything discreetly in the background. No membership, no minimum spend – only actual work is billed.",
        },
        {
          q: "Are there fixed service models or plans?",
          a: "Three models, no membership: individual wishes by hourly rate, a monthly allowance for regular needs – or an ongoing private client mandate with a dedicated contact and guaranteed availability. After the free initial consultation you receive a transparent quote for the right model.",
        },
      ],
    },
  },
  {
    slugDe: "concierge-service-luzern",
    slugEn: "concierge-service-lucerne",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Concierge Service Luzern & Lifestyle Management",
      metaDesc: "Concierge Service und Lifestyle Management in Luzern: Reservationen, KKL-Events, Reiseplanung und laufende Lebensorganisation am Vierwaldstättersee.",
      h1: "Concierge Service in Luzern",
      h1Accent: "Ihre Wünsche – am Vierwaldstättersee erledigt",
      intro: [
        "Als Private Concierge in Luzern sind wir die Verlängerung Ihres Haushalts – ob Sie ganzjährig hier leben oder in Ihrem Zweitwohnsitz am See. Reservationen, KKL-Abende, Ausflüge: alles vorbereitet, bevor Sie ankommen.",
        "Luzern ist klein, fein und vielseitig: Konzerte im KKL, Dinner über dem See, Ausflüge auf Rigi und Pilatus. Unser Concierge Service in Luzern organisiert das Beste der Leuchtenstadt – für Einheimische, Expats und Eigentümer von Zweitwohnsitzen am See.",
        "Von der Last-Minute-Reservation im ausgebuchten Restaurant bis zur kompletten Wochenend-Organisation: eine feste Ansprechsperson, die Luzern kennt, auf Deutsch und Englisch – und ohne Mitgliedschaft.",
      ],
      bullets: [
        "Restaurant- & Hotelreservationen in Luzern & am See",
        "Tickets für KKL, Konzerte & Festivals",
        "Ausflüge organisiert: Rigi, Pilatus & Seerundfahrten",
        "Reiseplanung & Ferienorganisation",
        "Private Anlässe & Überraschungen in Luzern",
        "Diskret & persönlich – ohne Mitgliedschaft",
      ],
      faq: [
        {
          q: "Was macht ein Private Concierge in Luzern?",
          a: "Ein Private Concierge in Luzern organisiert das Beste der Leuchtenstadt: KKL-Tickets, Restaurantreservationen, Ausflüge auf Rigi und Pilatus und private Anlässe – persönlich, diskret und ohne Mitgliedschaft, auf Deutsch und Englisch.",
        },
        {
          q: "Was kostet ein Concierge Service in Luzern?",
          a: "Ohne Mitgliedschaft und Grundgebühr: Sie zahlen nur für tatsächlich erledigte Wünsche – per Stundensatz oder monatlichem Kontingent. Nach einem kostenlosen Erstgespräch erhalten Sie eine transparente Offerte.",
        },
        {
          q: "Ich bin nur zeitweise in Luzern – lohnt sich das?",
          a: "Gerade für Zweitwohnsitz-Eigentümer lohnt es sich: Wir bereiten Ihren Aufenthalt komplett vor – Reservationen, Aktivitäten, Erledigungen – damit Ihre Zeit am See wirklich Erholung ist.",
        },
        {
          q: "Was ist der Unterschied zwischen Concierge und Lifestyle Management in Luzern?",
          a: "Der Concierge erledigt einzelne Wünsche – die Reservation, das KKL-Ticket, der Ausflug. Lifestyle Management ist die laufende Organisation Ihres Luzerner Alltags: Wochenplanung, Haushalt, Termine, Reisen – Woche für Woche, ohne dass Sie fragen müssen.",
        },
      ],
    },
    en: {
      metaTitle: "Concierge Service Lucerne | Swiss PA Services",
      metaDesc: "Concierge service and lifestyle management in Lucerne: reservations, KKL events, travel planning and ongoing life organisation on Lake Lucerne.",
      h1: "Concierge service in Lucerne",
      h1Accent: "Your wishes – handled on Lake Lucerne",
      intro: [
        "As a private concierge in Lucerne we are an extension of your household – whether you live here year-round or at your second home on the lake. Reservations, KKL evenings, excursions: everything prepared before you arrive.",
        "Lucerne is small, refined and versatile: concerts at the KKL, dinners above the lake, excursions to Rigi and Pilatus. Our concierge service in Lucerne organises the best of the city of lights – for locals, expats and second home owners on the lake.",
        "From the last-minute reservation at the fully booked restaurant to complete weekend organisation: one dedicated contact who knows Lucerne, in German and English – and without membership.",
      ],
      bullets: [
        "Restaurant & hotel reservations in Lucerne & on the lake",
        "Tickets for KKL, concerts & festivals",
        "Excursions organised: Rigi, Pilatus & lake cruises",
        "Travel planning & holiday organisation",
        "Private occasions & surprises in Lucerne",
        "Discreet & personal – no membership",
      ],
      faq: [
        {
          q: "What does a private concierge in Lucerne do?",
          a: "A private concierge in Lucerne organises the best of the city of lights: KKL tickets, restaurant reservations, excursions to Rigi and Pilatus and private occasions – personal, discreet and without membership, in German and English.",
        },
        {
          q: "What does a concierge service in Lucerne cost?",
          a: "No membership, no base fee: you pay only for wishes actually handled – by hourly rate or monthly allowance. After a free initial consultation you receive a transparent quote.",
        },
        {
          q: "I am only occasionally in Lucerne – is it worth it?",
          a: "Especially for second home owners it pays off: we prepare your stay completely – reservations, activities, errands – so your time at the lake is truly relaxation.",
        },
        {
          q: "What is the difference between a concierge and lifestyle management in Lucerne?",
          a: "A concierge handles individual wishes – the reservation, the KKL ticket, the excursion. Lifestyle management is the ongoing organisation of your Lucerne daily life: weekly planning, household, appointments, travel – week by week, without you having to ask.",
        },
      ],
    },
  },
  {
    slugDe: "lifestyle-management-zug",
    slugEn: "lifestyle-management-zug",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Lifestyle Management Zug | Swiss PA Services",
      metaDesc: "Lifestyle Management in Zug: Laufende Organisation Ihres Privatlebens – Wochenplanung, Haushalt, Reisen, Reservationen und besondere Wünsche.",
      h1: "Lifestyle Management in Zug",
      h1Accent: "Ihr Privatleben – professionell organisiert",
      intro: [
        "Lifestyle Management ist mehr als ein Concierge: Statt einzelner Wünsche übernehmen wir die laufende Organisation Ihres Privatlebens in Zug – Woche für Woche, leise im Hintergrund. Ihr Kalender ordnet sich, Ihr Haushalt läuft, Ihre Ferien planen sich von selbst.",
        "Von der Baarerstrasse 43 betreuen wir Unternehmer, Familien und internationale Kunden im Kanton Zug: persönlich, diskret und mit einer festen Ansprechsperson, die Ihre Vorlieben kennt – ohne Mitgliedschaft und ohne Abo.",
      ],
      bullets: [
        "Laufende Wochen- & Familienplanung",
        "Haushaltsorganisation & Personalkoordination",
        "Reisen & Ferien komplett geplant",
        "Reservationen, Events & Tickets",
        "Geschenke, Anlässe & besondere Wünsche",
        "Ein Ansprechpartner für alle Dienstleister",
      ],
      faq: [
        {
          q: "Was ist der Unterschied zwischen Lifestyle Management und Concierge?",
          a: "Der Concierge erledigt einzelne Wünsche auf Anfrage. Lifestyle Management ist die laufende Partnerschaft: Wir organisieren Ihren Alltag proaktiv und kontinuierlich – Sie müssen nicht mehr fragen, weil wir bereits wissen, was ansteht.",
        },
        {
          q: "Was kostet Lifestyle Management in Zug?",
          a: "Meist als monatliches Kontingent, abgestimmt auf Ihren Alltag – deutlich günstiger als eine Festanstellung. Nach einem kostenlosen Erstgespräch erhalten Sie eine transparente Offerte.",
        },
      ],
    },
    en: {
      metaTitle: "Lifestyle Management Zug | Swiss PA Services",
      metaDesc: "Lifestyle management in Zug: ongoing organisation of your private life – weekly planning, household, travel, reservations and special wishes.",
      h1: "Lifestyle Management in Zug",
      h1Accent: "Your private life – professionally organised",
      intro: [
        "Lifestyle management is more than a concierge: instead of single wishes, we take over the ongoing organisation of your private life in Zug – week by week, quietly in the background. Your calendar falls into place, your household runs, your holidays plan themselves.",
        "From Baarerstrasse 43 we support entrepreneurs, families and international clients in the canton of Zug: personal, discreet and with a dedicated contact who knows your preferences – without membership and without subscription.",
      ],
      bullets: [
        "Ongoing weekly & family planning",
        "Household organisation & staff coordination",
        "Travel & holidays fully planned",
        "Reservations, events & tickets",
        "Gifts, occasions & special wishes",
        "One contact for all service providers",
      ],
      faq: [
        {
          q: "What is the difference between lifestyle management and a concierge?",
          a: "A concierge handles individual wishes on request. Lifestyle management is the ongoing partnership: we organise your daily life proactively and continuously – you no longer have to ask, because we already know what is coming up.",
        },
        {
          q: "What does lifestyle management in Zug cost?",
          a: "Usually as a monthly allowance, matched to your daily life – significantly cheaper than a permanent hire. After a free initial consultation you receive a transparent quote.",
        },
      ],
    },
  },
  {
    slugDe: "lifestyle-management-schweiz",
    slugEn: "lifestyle-management-switzerland",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Lifestyle Management Schweiz | Swiss PA Services",
      metaDesc: "Lifestyle Management in der Schweiz: Ihre persönliche Lebensorganisation – Wochenplanung, Reisen, Haushalt und besondere Wünsche.",
      h1: "Lifestyle Management in der Schweiz",
      h1Accent: "Mehr leben, weniger organisieren",
      intro: [
        "Lifestyle Management ist die persönliche Lebensorganisation für Menschen mit vollem Kalender: ein fester Partner, der Ihren Alltag plant, koordiniert und vereinfacht – von der Wochenplanung über Reisen bis zu besonderen Anlässen.",
        "Swiss PA Services bietet Lifestyle Management in der ganzen Schweiz: Zug, Zürich, Genf, Luzern und Lugano. Anders als internationale Luxus-Agenturen arbeiten wir persönlich vor Ort, ohne teure Mitgliedschaft – mit transparenten Preisen und Schweizer Zuverlässigkeit.",
      ],
      bullets: [
        "Persönliche Lebensorganisation Woche für Woche",
        "Reise- & Ferienplanung mit allen Details",
        "Haushalt, Personal & Dienstleister koordiniert",
        "Events, Reservationen & besondere Anlässe",
        "Schweizweit: Zug, Zürich, Genf, Luzern & Lugano",
        "Transparente Preise – ohne Abo und Mitgliedschaft",
      ],
      faq: [
        {
          q: "Was kostet Lifestyle Management in der Schweiz?",
          a: "Internationale Luxus-Agenturen verlangen oft fünfstellige Jahresmitgliedschaften. Wir arbeiten anders: monatliche Kontingente oder Stundenpakete, transparent abgerechnet – Sie zahlen nur für tatsächliche Unterstützung. Kostenlose Erstberatung, Antwort innert 24 Stunden.",
        },
        {
          q: "Für wen lohnt sich Lifestyle Management?",
          a: "Für Unternehmer, Führungskräfte und Familien, deren Zeit kostbarer ist als unsere Unterstützung: Wenn Ihr Kalender voll ist und Ihr Privatleben trotzdem laufen soll, ist Lifestyle Management die effizienteste Lösung.",
        },
      ],
    },
    en: {
      metaTitle: "Lifestyle Management Switzerland | Swiss PA Services",
      metaDesc: "Lifestyle management in Switzerland: your personal life organisation – weekly planning, travel, household and special wishes.",
      h1: "Lifestyle Management in Switzerland",
      h1Accent: "Live more, organise less",
      intro: [
        "Lifestyle management is personal life organisation for people with full calendars: a dedicated partner who plans, coordinates and simplifies your daily life – from weekly planning to travel to special occasions.",
        "Swiss PA Services offers lifestyle management across Switzerland: Zug, Zurich, Geneva, Lucerne and Lugano. Unlike international luxury agencies, we work personally on site, without expensive memberships – with transparent pricing and Swiss reliability.",
      ],
      bullets: [
        "Personal life organisation, week by week",
        "Travel & holiday planning with every detail",
        "Household, staff & service providers coordinated",
        "Events, reservations & special occasions",
        "Nationwide: Zug, Zurich, Geneva, Lucerne & Lugano",
        "Transparent pricing – no subscription or membership",
      ],
      faq: [
        {
          q: "What does lifestyle management cost in Switzerland?",
          a: "International luxury agencies often charge five-figure annual memberships. We work differently: monthly allowances or hour packages, transparently billed – you pay only for actual support. Free initial consultation, reply within 24 hours.",
        },
        {
          q: "Who benefits from lifestyle management?",
          a: "Entrepreneurs, executives and families whose time is more valuable than our support: if your calendar is full and your private life should still run smoothly, lifestyle management is the most efficient solution.",
        },
      ],
    },
  },
  {
    slugDe: "relocation-agentur-luzern",
    slugEn: "relocation-agency-lucerne",
    service: "relocation-services-schweiz",
    de: {
      metaTitle: "Relocation Agentur Luzern | Swiss PA Services",
      metaDesc: "Ihre Relocation Agentur für Luzern: persönliche Umzugsbegleitung statt Callcenter – Wohnungssuche, Bewilligungen, Anmeldung & Settling-in.",
      h1: "Ihre Relocation Agentur für Luzern",
      h1Accent: "Persönlich begleitet statt anonym abgewickelt",
      intro: [
        "Wer nach Luzern zieht, hat die Wahl: den Umzug allein organisieren – oder eine Relocation Agentur damit beauftragen. Der Unterschied zeigt sich schnell: Während Sie Wochen mit Inseraten, Bewerbungen und Behörden verbringen, erledigt eine gute Agentur das in Tagen – mit lokalem Netzwerk und Erfahrung aus Dutzenden Umzügen.",
        "Als Relocation Agentur mit Sitz in Zug – nur 30 Minuten von Luzern entfernt – sind wir keine anonyme Plattform, sondern Ihre persönliche Umzugsbegleitung: eine feste Ansprechperson, die den Luzerner Wohnungsmarkt, die Gemeinden und die Behördenwege im Kanton Luzern kennt.",
      ],
      bullets: [
        "Feste Ansprechperson statt Callcenter",
        "Lokale Marktkenntnis: Luzern, Kriens, Emmen & See-Gemeinden",
        "Wohnungssuche mit Zugang zu nichtöffentlichen Angeboten",
        "Komplette Behördenabwicklung im Kanton Luzern",
        "Settling-in: Schule, Versicherung, Bank, Alltag",
        "Transparente Offerte – keine versteckten Kosten",
      ],
      faq: [
        {
          q: "Was macht eine Relocation Agentur genau?",
          a: "Eine Relocation Agentur übernimmt den kompletten Umzug in eine neue Stadt oder ins Ausland: Wohnungssuche, Mietvertrag, Anmeldung, Bewilligungen, Versicherungen und Schulplatz. Sie haben eine Ansprechperson für alles – statt zehn verschiedener Stellen. Wir begleiten Sie persönlich zu Besichtigungen und Behördenterminen.",
        },
        {
          q: "Sie sitzen in Zug – sind Sie für Luzern lokal genug?",
          a: "Ja: Luzern ist von unserem Sitz an der Baarerstrasse 43 nur 30 Minuten entfernt – wir sind regelmässig vor Ort, kennen Vermieter, Verwaltungen und Gemeinden persönlich und begleiten Sie zu jedem Termin. Kein Remote-Service, kein Callcenter.",
        },
      ],
    },
    en: {
      metaTitle: "Relocation Agency Lucerne | Swiss PA Services",
      metaDesc: "Your relocation agency for Lucerne: personal move support instead of a call centre – home search, permits, registration & settling-in.",
      h1: "Your relocation agency for Lucerne",
      h1Accent: "Personally guided instead of anonymously processed",
      intro: [
        "Moving to Lucerne, you have a choice: organise the move yourself – or hire a relocation agency. The difference shows quickly: while you spend weeks on listings, applications and authorities, a good agency handles it in days – with a local network and experience from dozens of moves.",
        "As a relocation agency based in Zug – just 30 minutes from Lucerne – we are not an anonymous platform but your personal move partner: one dedicated contact who knows the Lucerne housing market, the municipalities and the authority processes of the canton.",
      ],
      bullets: [
        "One dedicated contact instead of a call centre",
        "Local market knowledge: Lucerne, Kriens, Emmen & lakeside towns",
        "Home search with access to off-market listings",
        "Complete authority handling in the canton of Lucerne",
        "Settling-in: school, insurance, banking, daily life",
        "Transparent quote – no hidden costs",
      ],
      faq: [
        {
          q: "What exactly does a relocation agency do?",
          a: "A relocation agency handles your complete move to a new city or country: home search, lease, registration, permits, insurance and school places. You have one contact for everything – instead of ten different offices. We personally accompany you to viewings and authority appointments.",
        },
        {
          q: "You are based in Zug – are you local enough for Lucerne?",
          a: "Yes: Lucerne is only 30 minutes from our base at Baarerstrasse 43 – we are regularly on site, know landlords, property managers and municipalities personally, and accompany you to every appointment. No remote service, no call centre.",
        },
      ],
    },
  },
  {
    slugDe: "relocation-agentur-zug",
    slugEn: "relocation-agency-zug",
    service: "relocation-services-schweiz",
    de: {
      metaTitle: "Relocation Agentur Zug | Swiss PA Services",
      metaDesc: "Relocation Agentur mit Sitz in Zug: Wohnungssuche in Zug, Baar & Cham, Begleitung zur Einwohnerkontrolle, Bewilligungen und Firmen-Relocations.",
      h1: "Ihre Relocation Agentur in Zug",
      h1Accent: "Mitten in Zug – zu Fuss bei Behörde & Vermieter",
      intro: [
        "Die meisten Relocation Agenturen für Zug sitzen in Zürich – oder gleich im Ausland. Wir sitzen mitten in Zug, an der Baarerstrasse 43: Die Einwohnerkontrolle erreichen wir zu Fuss, die Vermieter in Zug, Baar und Cham kennen wir persönlich, und beim Migrationsamt kennen wir jeden Ablauf.",
        "Ob einzelner Expat, Familie oder Firma aus dem Crypto Valley mit zehn neuen Mitarbeitenden: Als lokale Relocation Agentur in Zug übernehmen wir Wohnungssuche, Bewilligungen, Schulberatung und Settling-in – mit einer festen Ansprechperson, auf Deutsch und Englisch.",
      ],
      bullets: [
        "Agentur mit Sitz in Zug – Baarerstrasse 43",
        "Wohnungssuche in Zug, Baar, Cham & Risch",
        "Persönliche Begleitung zu Behördenterminen",
        "Firmen-Relocations für Crypto Valley & Konzerne",
        "Schulberatung: ISZL, Montana & öffentliche Schulen",
        "Settling-in & Alltagssupport auf EN und DE",
      ],
      faq: [
        {
          q: "Gibt es eine Relocation Agentur mit Sitz in Zug?",
          a: "Ja – wir. Swiss PA Services hat seinen Hauptsitz an der Baarerstrasse 43 in Zug. Das heisst für Sie: Wir sind bei Besichtigungen und Behördenterminen in Minuten vor Ort, kennen Gemeinden und Vermieter persönlich und arbeiten nicht remote aus einer anderen Stadt.",
        },
        {
          q: "Übernehmen Sie auch Relocations für ganze Firmen?",
          a: "Ja, wir betreuen Unternehmen aus dem Crypto Valley und internationale Firmen bei der Ansiedlung ihrer Mitarbeitenden – vom einzelnen Key Hire bis zu mehreren Familien parallel, inklusive Reporting an HR. Nach einem kostenlosen Erstgespräch erhalten Sie eine transparente Offerte.",
        },
      ],
    },
    en: {
      metaTitle: "Relocation Agency Zug | Swiss PA Services",
      metaDesc: "Relocation agency based in Zug: home search in Zug, Baar & Cham, accompanied resident registration, permits and corporate relocations.",
      h1: "Your relocation agency in Zug",
      h1Accent: "Right in Zug – walking distance to authorities & landlords",
      intro: [
        "Most relocation agencies serving Zug are based in Zurich – or abroad. We are right in Zug, at Baarerstrasse 43: we reach the residents' office on foot, know the landlords in Zug, Baar and Cham personally, and know every process at the migration office.",
        "Whether a single expat, a family or a Crypto Valley company with ten new hires: as a local relocation agency in Zug we handle home search, permits, school advice and settling-in – with one dedicated contact, in German and English.",
      ],
      bullets: [
        "Agency based in Zug – Baarerstrasse 43",
        "Home search in Zug, Baar, Cham & Risch",
        "Personal accompaniment to authority appointments",
        "Corporate relocations for Crypto Valley & corporates",
        "School advice: ISZL, Montana & public schools",
        "Settling-in & everyday support in EN and DE",
      ],
      faq: [
        {
          q: "Is there a relocation agency actually based in Zug?",
          a: "Yes – us. Swiss PA Services is headquartered at Baarerstrasse 43 in Zug. For you that means: we are on site within minutes for viewings and authority appointments, know municipalities and landlords personally, and do not work remotely from another city.",
        },
        {
          q: "Do you also handle relocations for entire companies?",
          a: "Yes, we support Crypto Valley companies and international firms relocating their employees – from a single key hire to several families in parallel, including reporting to HR. After a free initial consultation you receive a transparent quote.",
        },
      ],
    },
  },
  {
    slugDe: "relocation-agentur-zuerich",
    slugEn: "relocation-agency-zurich",
    service: "relocation-services-schweiz",
    de: {
      metaTitle: "Relocation Agentur Zürich | Swiss PA Services",
      metaDesc: "Relocation Agentur für Zürich: Wohnungssuche mit Zugang zu nichtöffentlichen Angeboten, professionelles Bewerbungsdossier, Anmeldung & Settling-in.",
      h1: "Ihre Relocation Agentur für Zürich",
      h1Accent: "Wohnungen, die nie online stehen",
      intro: [
        "In Zürich stehen auf jede inserierte Wohnung Dutzende Bewerbungen – und die besten Objekte kommen nie auf Flatfox oder Homegate. Eine Relocation Agentur in Zürich macht genau hier den Unterschied: Sie kennt die Verwaltungen, erfährt von Wohnungen vor der Publikation und weiss, wie ein Dossier aussehen muss, das gewinnt.",
        "Wir begleiten Expats, Führungskräfte und Familien beim Umzug nach Zürich: Wohnungssuche über unser Netzwerk, begleitete Besichtigungen, Vertragsprüfung, Anmeldung beim Stadthaus und komplettes Settling-in – ein Ansprechpartner für alles.",
        "Dabei unterscheiden wir uns bewusst von Online-Plattformen: Bei uns gibt es keine Warteschlange und kein Ticket-System. Sie rufen an oder schreiben – und sprechen mit der Person, die Ihre Wohnungssuche in Zürich persönlich führt.",
      ],
      bullets: [
        "Zugang zu nichtöffentlichen Wohnungsangeboten",
        "Professionelles Bewerbungsdossier, das gewinnt",
        "Begleitete Besichtigungen in ganz Zürich",
        "Mietvertragsprüfung vor Unterschrift",
        "Anmeldung, Bewilligungen & Krankenkasse",
        "Schul- & Kindergartenberatung für Familien",
      ],
      faq: [
        {
          q: "Relocation Agentur oder selbst auf Flatfox suchen?",
          a: "Auf den Portalen bewerben sich in Zürich oft 50 bis 100 Parteien pro Wohnung – ohne Deutschkenntnisse, Schweizer Referenzen und perfektes Dossier bleiben Sie aussen vor. Eine Agentur kennt die Verwaltungen persönlich, erfährt von Objekten vor der Publikation und stellt Ihr Dossier so auf, dass es ausgewählt wird.",
        },
        {
          q: "Wie findet eine Agentur Wohnungen, die nicht inseriert sind?",
          a: "Über Beziehungen: Hausverwaltungen, Eigentümer und Makler melden uns freiwerdende Objekte, bevor sie online gehen – weil sie wissen, dass unsere Kunden geprüft und solvent sind. Dieser Zugang ist der eigentliche Wert einer Relocation Agentur in Zürich.",
        },
        {
          q: "Wie lange dauert die Wohnungssuche in Zürich realistisch?",
          a: "Mit Netzwerk und professionellem Dossier finden unsere Kunden meist innert zwei bis sechs Wochen eine Wohnung – allein auf den Portalen dauert es oft Monate. Zur Hochsaison im Spätsommer empfehlen wir, so früh wie möglich zu starten.",
        },
      ],
    },
    en: {
      metaTitle: "Relocation Agency Zurich | Swiss PA Services",
      metaDesc: "Relocation agency for Zurich: home search with access to off-market listings, a professional application dossier, registration & settling-in.",
      h1: "Your relocation agency for Zurich",
      h1Accent: "Homes that never go online",
      intro: [
        "In Zurich, every advertised flat attracts dozens of applications – and the best properties never appear on Flatfox or Homegate. A relocation agency in Zurich makes exactly this difference: it knows the property managers, hears about flats before publication and knows what a winning dossier looks like.",
        "We guide expats, executives and families moving to Zurich: home search through our network, accompanied viewings, lease review, registration at the Stadthaus and complete settling-in – one contact for everything.",
        "We deliberately differ from online platforms: with us there is no queue and no ticket system. You call or write – and speak with the person who personally leads your home search in Zurich.",
      ],
      bullets: [
        "Access to off-market property listings",
        "A professional application dossier that wins",
        "Accompanied viewings across Zurich",
        "Lease review before you sign",
        "Registration, permits & health insurance",
        "School & kindergarten advice for families",
      ],
      faq: [
        {
          q: "Relocation agency or searching Flatfox yourself?",
          a: "On the portals, 50 to 100 parties often apply per flat in Zurich – without German skills, Swiss references and a perfect dossier you are left out. An agency knows the property managers personally, hears about properties before publication and builds your dossier to be selected.",
        },
        {
          q: "How does an agency find flats that are never advertised?",
          a: "Through relationships: property managers, owners and brokers tell us about upcoming vacancies before they go online – because they know our clients are vetted and solvent. This access is the real value of a relocation agency in Zurich.",
        },
        {
          q: "How long does the home search in Zurich realistically take?",
          a: "With a network and a professional dossier, our clients usually find a home within two to six weeks – on the portals alone it often takes months. In the high season in late summer we recommend starting as early as possible.",
        },
      ],
    },
  },
  {
    slugDe: "relocation-agentur-genf",
    slugEn: "relocation-agency-geneva",
    service: "relocation-services-schweiz",
    de: {
      metaTitle: "Relocation Agentur Genf | Swiss PA Services",
      metaDesc: "Relocation Agentur für Genf: Wohnungssuche trotz 0,3% Leerstand, OCP-Anmeldung, Bewilligungen und Schulberatung.",
      h1: "Ihre Relocation Agentur für Genf",
      h1Accent: "Dreisprachig durch die Genfer Behörden",
      intro: [
        "Genf empfängt jedes Jahr Tausende Zuzüger: Diplomaten, Mitarbeitende von UNO, CERN und Hunderten NGOs – bei rund 0,3 Prozent Leerstand. Eine Relocation Agentur in Genf braucht deshalb zwei Dinge: Zugang zum Wohnungsmarkt und perfekte Behördenkenntnis auf Französisch.",
        "Wir begleiten internationale Zuzüger und ihre Familien durch den ganzen Prozess: Wohnungssuche in Genf, Cologny und Carouge, Anmeldung beim OCP, Bewilligungen, Schulberatung für internationale Schulen – und mit Ihnen sprechen wir Englisch oder Deutsch.",
      ],
      bullets: [
        "Erfahrung mit UNO-, CERN- & NGO-Zuzügern",
        "Wohnungssuche in Genf, Cologny & Carouge",
        "OCP-Anmeldung & Bewilligungen abgewickelt",
        "Französisch-Kommunikation mit Behörden & Vermietern",
        "Beratung zu internationalen Schulen in Genf",
        "Settling-in: Bank, Versicherung, Alltag",
      ],
      faq: [
        {
          q: "Haben Sie Erfahrung mit Relocations für internationale Organisationen?",
          a: "Ja, ein grosser Teil unserer Genfer Kunden kommt von UNO, CERN, NGOs und multinationalen Firmen. Wir kennen die spezifischen Anforderungen: Legitimationskarten, Sonderregelungen bei Bewilligungen und die Fristen der internationalen Schulen.",
        },
        {
          q: "Ich spreche kein Französisch – ist das ein Problem in Genf?",
          a: "Ohne Unterstützung: ja. Mietverträge, das OCP und die meisten Verwaltungen laufen auf Französisch. Genau dafür sind wir da: Wir führen die gesamte Kommunikation auf Französisch und halten Sie auf Englisch oder Deutsch auf dem Laufenden.",
        },
      ],
    },
    en: {
      metaTitle: "Relocation Agency Geneva | Swiss PA Services",
      metaDesc: "Relocation agency for Geneva: home search despite 0.3% vacancy, OCP registration, permits and school advice.",
      h1: "Your relocation agency for Geneva",
      h1Accent: "Trilingual guidance through Geneva's authorities",
      intro: [
        "Geneva welcomes thousands of arrivals every year: diplomats, employees of the UN, CERN and hundreds of NGOs – with around 0.3 percent vacancy. A relocation agency in Geneva therefore needs two things: access to the housing market and flawless authority knowledge in French.",
        "We guide international arrivals and their families through the entire process: home search in Geneva, Cologny and Carouge, registration with the OCP, permits, advice on international schools – and with you we speak English or French.",
      ],
      bullets: [
        "Experience with UN, CERN & NGO arrivals",
        "Home search in Geneva, Cologny & Carouge",
        "OCP registration & permits handled",
        "French communication with authorities & landlords",
        "Advice on international schools in Geneva",
        "Settling-in: banking, insurance, daily life",
      ],
      faq: [
        {
          q: "Do you have experience with relocations for international organisations?",
          a: "Yes, a large share of our Geneva clients come from the UN, CERN, NGOs and multinational companies. We know the specific requirements: legitimation cards, special permit rules and the deadlines of international schools.",
        },
        {
          q: "I don't speak French – is that a problem in Geneva?",
          a: "Without support: yes. Leases, the OCP and most administrations run in French. That is exactly what we are here for: we handle all communication in French and keep you updated in English or French.",
        },
      ],
    },
  },
  {
    slugDe: "relocation-agentur-lugano",
    slugEn: "relocation-agency-lugano",
    service: "relocation-services-schweiz",
    de: {
      metaTitle: "Relocation Agentur Lugano | Swiss PA Services",
      metaDesc: "Relocation Agentur für Lugano: Wohnungssuche am Lago, Bewilligungen, Anmeldung und Schulberatung – ohne Sprachbarriere, mit Tessiner Netzwerk.",
      h1: "Ihre Relocation Agentur für Lugano",
      h1Accent: "Ins Tessin – ohne Sprachbarriere",
      intro: [
        "Der Umzug nach Lugano ist ein Umzug in eine andere Welt: italienische Sprache, eigene Behördenwege, ein Wohnungsmarkt, der mündlich funktioniert. Eine Relocation Agentur für Lugano muss beides können – Schweizer Prozesse und Tessiner Praxis.",
        "Wir begleiten Expats, Unternehmer und Familien beim Umzug ins Tessin: Wohnungssuche in Lugano, Paradiso und am Lago, Anmeldung bei der Gemeinde, Bewilligungen beim kantonalen Migrationsamt, Schulberatung – und die gesamte Kommunikation mit Behörden und Vermietern auf Italienisch.",
      ],
      bullets: [
        "Wohnungssuche in Lugano, Paradiso & am Lago",
        "Italienisch-Kommunikation mit Behörden & Vermietern",
        "Bewilligungen beim kantonalen Migrationsamt",
        "Gemeinde-Anmeldung & Alltags-Setup",
        "Schulberatung inkl. internationaler Optionen",
        "Spezialfälle: Grenzgänger & Italien-Bezug",
      ],
      faq: [
        {
          q: "Ich spreche kein Italien – übernehmen Sie die Kommunikation?",
          a: "Ja, komplett: Mietvertrag, Gemeinde, Migrationsamt, Versicherungen – alles läuft im Tessin auf Italienisch. Wir führen diese Gespräche für Sie und berichten Ihnen auf Deutsch oder Englisch. Sie unterschreiben erst, wenn alles übersetzt und erklärt ist.",
        },
        {
          q: "Was ist bei einem Umzug von Italien ins Tessin zu beachten?",
          a: "Vieles: Zollformalitäten für Umzugsgut, die richtige Bewilligungskategorie, Krankenversicherungspflicht ab Tag eins und steuerliche Fragen bei Grenzgängern. Wir kennen die Italien-Spezifika und koordinieren beide Seiten der Grenze.",
        },
      ],
    },
    en: {
      metaTitle: "Relocation Agency Lugano | Swiss PA Services",
      metaDesc: "Relocation agency for Lugano: home search on the Lago, permits, registration and school advice – without language barriers, with a Ticino network.",
      h1: "Your relocation agency for Lugano",
      h1Accent: "Into Ticino – without the language barrier",
      intro: [
        "Moving to Lugano is moving to a different world: Italian language, its own authority processes, a housing market that works by word of mouth. A relocation agency for Lugano must master both – Swiss processes and Ticino practice.",
        "We guide expats, entrepreneurs and families moving to Ticino: home search in Lugano, Paradiso and on the Lago, municipal registration, permits at the cantonal migration office, school advice – and all communication with authorities and landlords in Italian.",
      ],
      bullets: [
        "Home search in Lugano, Paradiso & on the Lago",
        "Italian communication with authorities & landlords",
        "Permits at the cantonal migration office",
        "Municipal registration & everyday setup",
        "School advice incl. international options",
        "Special cases: cross-border commuters & Italy ties",
      ],
      faq: [
        {
          q: "I don't speak Italian – do you handle the communication?",
          a: "Yes, completely: lease, municipality, migration office, insurance – everything in Ticino runs in Italian. We conduct these conversations for you and report back in German or English. You sign only once everything is translated and explained.",
        },
        {
          q: "What should I consider when moving from Italy to Ticino?",
          a: "A lot: customs formalities for household goods, the right permit category, mandatory health insurance from day one and tax questions for cross-border commuters. We know the Italy specifics and coordinate both sides of the border.",
        },
      ],
    },
  },
  {
    slugDe: "ferienhausverwaltung-gstaad",
    slugEn: "vacation-home-management-gstaad",
    service: "home-property-management",
    de: {
      metaTitle: "Ferienhausverwaltung Gstaad | Swiss PA Services",
      metaDesc: "Ferienhausverwaltung in Gstaad & Saanenland: Home Watch, Schlüsselservice und Handwerker-Koordination für Chalets in Gstaad, Saanen & Schönried.",
      h1: "Ferienhausverwaltung in Gstaad",
      h1Accent: "Ihr Chalet im Saanenland – bestens betreut",
      intro: [
        "Gstaad steht für diskrete Weltklasse: Chalets von internationalen Eigentümern, die oft nur wenige Wochen im Jahr hier sind. Zwischen Ihren Aufenthalten braucht Ihre Liegenschaft im Saanenland zuverlässige Augen und Hände vor Ort.",
        "Wir betreuen Chalets und Residenzen in Gstaad, Saanen, Schönried und Gsteig: regelmässige Home-Watch-Kontrollen, Schlüsselverwaltung, Handwerker-Koordination und die komplette Vorbereitung vor Ihrer Ankunft. Die Region ist zweisprachig – unsere Protokolle erhalten Sie auf Deutsch oder Englisch, vor Ort koordinieren wir auf Deutsch und Französisch.",
      ],
      bullets: [
        "Home-Watch-Kontrollen in Gstaad, Saanen & Schönried",
        "Schlüsselverwaltung & Zutrittsorganisation",
        "Handwerker- & Gärtnerkoordination im Saanenland",
        "Saisonvorbereitung: Skisaison & Sommer",
        "Ankunfts-Service: Heizung, Einkauf, Blumen",
        "Foto-Protokolle auf Deutsch oder Englisch",
      ],
      faq: [
        {
          q: "Sie sitzen in Zug – wie betreuen Sie Chalets in Gstaad?",
          a: "Über unser geprüftes Netzwerk im Saanenland: Kontrollgänge und Handwerkerstermine führen lokale Partner durch, die wir koordinieren und kontrollieren. Sie haben nur einen Ansprechpartner – uns – und erhalten jedes Protokoll mit Fotos auf Deutsch oder Englisch.",
        },
        {
          q: "Vermieten Sie mein Chalet auch?",
          a: "Nein, und das ist bewusst so: Wir sind keine Vermietungsagentur, sondern ausschliesslich für Sie als Eigentümer da – Betreuung, Unterhalt und Vorbereitung Ihres Chalets. Ihr Zuhause bleibt Ihr Zuhause.",
        },
      ],
    },
    en: {
      metaTitle: "Vacation Home Management Gstaad | Swiss PA Services",
      metaDesc: "Vacation home management in Gstaad & Saanenland: home watch, key holding and contractor coordination for chalets in Gstaad, Saanen & Schönried.",
      h1: "Vacation home management in Gstaad",
      h1Accent: "Your Saanenland chalet – perfectly cared for",
      intro: [
        "Gstaad stands for discreet world class: chalets owned by international owners who are often here only a few weeks a year. Between your stays, your Saanenland property needs reliable eyes and hands on site.",
        "We care for chalets and residences in Gstaad, Saanen, Schönried and Gsteig: regular home watch inspections, key holding, contractor coordination and complete preparation before your arrival. The region is bilingual – you receive our reports in German or English, on site we coordinate in German and French.",
      ],
      bullets: [
        "Home watch inspections in Gstaad, Saanen & Schönried",
        "Key holding & access organisation",
        "Contractor & gardener coordination in Saanenland",
        "Seasonal preparation: ski season & summer",
        "Arrival service: heating, groceries, flowers",
        "Photo reports in German or English",
      ],
      faq: [
        {
          q: "You are based in Zug – how do you care for chalets in Gstaad?",
          a: "Through our vetted network in Saanenland: inspections and contractor appointments are carried out by local partners whom we coordinate and supervise. You have only one point of contact – us – and receive every report with photos in German or English.",
        },
        {
          q: "Do you also rent out my chalet?",
          a: "No, and that is deliberate: we are not a rental agency but work exclusively for you as the owner – care, maintenance and preparation of your chalet. Your home stays your home.",
        },
      ],
    },
  },
  {
    slugDe: "ferienhausverwaltung-st-moritz",
    slugEn: "vacation-home-management-st-moritz",
    service: "home-property-management",
    de: {
      metaTitle: "Ferienhausverwaltung St. Moritz | Engadin | Swiss PA Services",
      metaDesc: "Ferienhausverwaltung in St. Moritz & im Engadin: Home Watch, saisonale Öffnung und Schliessung, Handwerker-Koordination.",
      h1: "Ferienhausverwaltung in St. Moritz",
      h1Accent: "Ihre Engadiner Liegenschaft in besten Händen",
      intro: [
        "St. Moritz ist die Adresse auf 1'800 Metern: Engadiner Häuser, moderne Residenzen, ein Winter, der es in sich hat. Wenn Sie nicht da sind, entscheidet die Betreuung vor Ort über den Zustand Ihrer Liegenschaft – von der Heizung bis zum Dach.",
        "Wir betreuen Liegenschaften in St. Moritz, Celerina, Pontresina und Sils: Home-Watch-Kontrollen, saisonales Öffnen und Schliessen, Koordination von Handwerkern und die Vorbereitung zu Saisonhöhepunkten wie White Turf oder Polo on Snow. Berichtet wird auf Deutsch oder Englisch.",
      ],
      bullets: [
        "Home-Watch in St. Moritz, Celerina & Pontresina",
        "Saisonales Öffnen & Schliessen der Liegenschaft",
        "Winter-Checks: Heizung, Frost, Dach & Schnee",
        "Handwerker- & Gartenpflege-Koordination im Engadin",
        "Ankunfts-Service zu Events & Saisonhöhepunkten",
        "Foto-Protokolle auf Deutsch oder Englisch",
      ],
      faq: [
        {
          q: "Was passiert mit meinem Haus im strengen Engadiner Winter?",
          a: "Genau dafür sind wir da: Wir kontrollieren Heizung und Rohre gegen Frostschäden, lassen Dach und Zugänge von Schnee räumen und dokumentieren jeden Kontrollgang mit Fotos. Bei Auffälligkeiten handeln wir sofort und informieren Sie, bevor aus kleinen Problemen teure werden.",
        },
        {
          q: "Öffnen und schliessen Sie das Haus saisonal?",
          a: "Ja, das ist einer unserer meistgebuchten Services im Engadin: Vor Ihrer Ankunft heizen wir ein, lüften, füllen auf Wunsch den Kühlschrank und bereiten alles vor – nach Ihrer Abreise sichern wir die Liegenschaft fachgerecht bis zur nächsten Saison.",
        },
      ],
    },
    en: {
      metaTitle: "Vacation Home Management St. Moritz | Swiss PA Services",
      metaDesc: "Vacation home management in St. Moritz & the Engadin: home watch, seasonal opening and closing, contractor coordination.",
      h1: "Vacation home management in St. Moritz",
      h1Accent: "Your Engadin property in the best hands",
      intro: [
        "St. Moritz is the address at 1,800 metres: Engadin houses, modern residences, and a winter that means business. When you are away, on-site care decides the condition of your property – from the heating to the roof.",
        "We care for properties in St. Moritz, Celerina, Pontresina and Sils: home watch inspections, seasonal opening and closing, contractor coordination and preparation for season highlights like White Turf or Snow Polo. Reporting in German or English.",
      ],
      bullets: [
        "Home watch in St. Moritz, Celerina & Pontresina",
        "Seasonal opening & closing of your property",
        "Winter checks: heating, frost, roof & snow",
        "Contractor & garden care coordination in the Engadin",
        "Arrival service for events & season highlights",
        "Photo reports in German or English",
      ],
      faq: [
        {
          q: "What happens to my house during the harsh Engadin winter?",
          a: "That is exactly what we are here for: we check heating and pipes against frost damage, have roofs and access ways cleared of snow and document every inspection with photos. If we spot anything, we act immediately and inform you before small issues become expensive ones.",
        },
        {
          q: "Do you open and close the house seasonally?",
          a: "Yes, it is one of our most-booked services in the Engadin: before your arrival we heat up, air out, fill the fridge on request and prepare everything – after your departure we secure the property properly until next season.",
        },
      ],
    },
  },
  {
    slugDe: "ferienhausverwaltung-verbier",
    slugEn: "vacation-home-management-verbier",
    service: "home-property-management",
    de: {
      metaTitle: "Ferienhausverwaltung Verbier | Swiss PA Services",
      metaDesc: "Ferienhausverwaltung in Verbier: Home Watch, Schlüsselservice und Chalet-Betreuung für internationale Eigentümer im Wallis.",
      h1: "Ferienhausverwaltung in Verbier",
      h1Accent: "Ihr Chalet an der Freeride-Adresse der Schweiz",
      intro: [
        "Verbier zieht internationale Eigentümer an wie kaum ein zweiter Alpenort: Chalets mit Blick auf die Viertausender, viele Besitzer aus Grossbritannien, Skandinavien und Benelux – und eine Verwaltung, die auf Französisch läuft.",
        "Wir betreuen Chalets und Apartments in Verbier, Nendaz und dem Val de Bagnes: regelmässige Home-Watch-Kontrollen, Schlüsselverwaltung, Handwerker-Koordination auf Französisch und die komplette Vorbereitung vor Ihrer Ankunft – in der Skisaison wie im Sommer.",
      ],
      bullets: [
        "Home-Watch-Kontrollen in Verbier & Val de Bagnes",
        "Schlüsselverwaltung & Zutrittsorganisation",
        "Handwerker-Koordination auf Französisch",
        "Saisonvorbereitung: Ski & Sommer",
        "Ankunfts-Service nach Ihren Wünschen",
        "Berichte auf Deutsch oder Englisch",
      ],
      faq: [
        {
          q: "Ich spreche kein Französisch – ist das ein Problem in Verbier?",
          a: "Für Sie nicht: Wir führen die gesamte Kommunikation mit der Gemeinde, Verwaltungen und Handwerkern auf Französisch und berichten Ihnen auf Englisch oder Deutsch. Sie unterschreiben nichts, das Sie nicht verstanden haben.",
        },
        {
          q: "Wie oft kontrollieren Sie mein Chalet?",
          a: "Nach Vereinbarung: wöchentlich, zweiwöchentlich oder monatlich – plus Sonderschauen nach Stürmen oder starkem Schneefall. Jeden Kontrollgang dokumentieren wir mit Fotos und einem kurzen Protokoll.",
        },
      ],
    },
    en: {
      metaTitle: "Vacation Home Management Verbier | Swiss PA Services",
      metaDesc: "Vacation home management in Verbier: home watch, key holding and chalet care for international owners in Valais.",
      h1: "Vacation home management in Verbier",
      h1Accent: "Your chalet at Switzerland's freeride address",
      intro: [
        "Verbier attracts international owners like few other Alpine resorts: chalets overlooking the four-thousanders, many owners from Britain, Scandinavia and the Benelux – and an administration that runs in French.",
        "We care for chalets and apartments in Verbier, Nendaz and the Val de Bagnes: regular home watch inspections, key holding, contractor coordination in French and complete preparation before your arrival – in ski season and summer alike.",
      ],
      bullets: [
        "Home watch inspections in Verbier & Val de Bagnes",
        "Key holding & access organisation",
        "Contractor coordination in French",
        "Seasonal preparation: ski & summer",
        "Arrival service tailored to your wishes",
        "Reports in German or English",
      ],
      faq: [
        {
          q: "I don't speak French – is that a problem in Verbier?",
          a: "Not for you: we handle all communication with the municipality, property managers and craftsmen in French and report to you in English or German. You never sign anything you have not understood.",
        },
        {
          q: "How often do you check my chalet?",
          a: "As agreed: weekly, bi-weekly or monthly – plus special inspections after storms or heavy snowfall. Every inspection is documented with photos and a short report.",
        },
      ],
    },
  },
  {
    slugDe: "ferienhausverwaltung-zermatt",
    slugEn: "vacation-home-management-zermatt",
    service: "home-property-management",
    de: {
      metaTitle: "Ferienhausverwaltung Zermatt | Swiss PA Services",
      metaDesc: "Ferienhausverwaltung in Zermatt: Home Watch und Chalet-Betreuung im autofreien Zermatt – Logistik per Bahn und Elektroauto, Ganzjahres-Betreuung.",
      h1: "Ferienhausverwaltung in Zermatt",
      h1Accent: "Autofrei, aber nie unerreichbar",
      intro: [
        "Zermatt ist einzigartig: autofrei, ganzjährig Saison, das Matterhorn vor dem Fenster. Für Eigentümer heisst das: Jeder Handwerkertermin, jede Kontrolle und jede Ankunft braucht Logistik – per Bahn und Elektroauto statt einfach mit dem Lieferwagen.",
        "Wir betreuen Chalets und Residenzen in Zermatt und Umgebung: regelmässige Home-Watch-Kontrollen, Schlüsselverwaltung, Koordination von Handwerkern und die Vorbereitung Ihrer Ankunft – vom beheizten Chalet bis zur Gepäcklogistik ab Bahnhof Täsch.",
      ],
      bullets: [
        "Home-Watch-Kontrollen im autofreien Zermatt",
        "Logistik per Bahn & Elektrofahrzeug organisiert",
        "Schlüsselverwaltung & Zutrittsorganisation",
        "Handwerker- & Dienstleisterkoordination",
        "Ganzjahres-Betreuung: Ski, Wandern, Sommer",
        "Foto-Protokolle auf Deutsch oder Englisch",
      ],
      faq: [
        {
          q: "Zermatt ist autofrei – wie funktionieren Kontrollen und Handwerkertermine?",
          a: "Genau das ist unsere Stärke: Wir organisieren alles über die Bahn ab Täsch und die Elektrofahrzeuge vor Ort. Für Sie ändert sich nichts – Sie erhalten einfach jedes Protokoll mit Fotos, ohne sich um die Logistik kümmern zu müssen.",
        },
        {
          q: "Mein Chalet wird zeitweise vermietet – betreuen Sie es trotzdem?",
          a: "Ja: Die Vermietung bleibt bei Ihnen oder Ihrer Agentur – wir übernehmen die Eigentümerseite: Kontrollgänge, Unterhalt, Handwerker-Koordination und die Kommunikation mit Ihrer Vermietungsagentur, damit nichts liegen bleibt.",
        },
      ],
    },
    en: {
      metaTitle: "Vacation Home Management Zermatt | Swiss PA Services",
      metaDesc: "Vacation home management in Zermatt: home watch and chalet care in car-free Zermatt – logistics by train and electric vehicle, year-round care.",
      h1: "Vacation home management in Zermatt",
      h1Accent: "Car-free, but never out of reach",
      intro: [
        "Zermatt is unique: car-free, year-round season, the Matterhorn outside your window. For owners that means: every contractor appointment, every inspection and every arrival needs logistics – by train and electric vehicle instead of simply by van.",
        "We care for chalets and residences in Zermatt and the surrounding area: regular home watch inspections, key holding, contractor coordination and preparation of your arrival – from the heated chalet to luggage logistics from Täsch station.",
      ],
      bullets: [
        "Home watch inspections in car-free Zermatt",
        "Logistics by train & electric vehicle organised",
        "Key holding & access organisation",
        "Contractor & service provider coordination",
        "Year-round care: ski, hiking, summer",
        "Photo reports in German or English",
      ],
      faq: [
        {
          q: "Zermatt is car-free – how do inspections and contractor appointments work?",
          a: "That is exactly our strength: we organise everything via the train from Täsch and the electric vehicles on site. Nothing changes for you – you simply receive every report with photos, without having to worry about logistics.",
        },
        {
          q: "My chalet is rented out at times – do you still care for it?",
          a: "Yes: the rental stays with you or your agency – we handle the owner's side: inspections, maintenance, contractor coordination and communication with your rental agency, so nothing is left undone.",
        },
      ],
    },
  },
  {
    slugDe: "ferienhausverwaltung-andermatt",
    slugEn: "vacation-home-management-andermatt",
    service: "home-property-management",
    de: {
      metaTitle: "Ferienhausverwaltung Andermatt | Swiss PA Services",
      metaDesc: "Ferienhausverwaltung in Andermatt: Betreuung von Resort-Wohnungen und Chalets in Andermatt Swiss Alps.",
      h1: "Ferienhausverwaltung in Andermatt",
      h1Accent: "Ihre Residence im neuen Alpen-Resort",
      intro: [
        "Andermatt hat sich zur jüngsten Luxus-Adresse der Alpen entwickelt: Andermatt Swiss Alps mit Residenzen, Hotels und Golfplatz zieht internationale Eigentümer an – viele kaufen hier ihre erste Liegenschaft in der Schweiz.",
        "Ob Residence im Resort oder Chalet im Urserntal: Wir betreuen Ihre Liegenschaft mit Home-Watch-Kontrollen, Schlüsselverwaltung, Handwerker-Koordination und Ankunfts-Service. Von unserem Sitz in Zug sind wir in gut einer Stunde vor Ort – näher als jede Zürcher Agentur.",
      ],
      bullets: [
        "Betreuung von Resort-Residenzen & Chalets",
        "Home-Watch-Kontrollen im Urserntal",
        "Schlüsselverwaltung & Zutrittsorganisation",
        "Handwerker- & Hauswart-Koordination",
        "Ankunfts-Service: beheizt, befüllt, vorbereitet",
        "Ab Zug in gut einer Stunde vor Ort",
      ],
      faq: [
        {
          q: "Ich besitze eine Wohnung im Andermatt Resort – betreuen Sie auch Residenzen?",
          a: "Ja, Resort-Residenzen sind sogar ein Schwerpunkt: Wir koordinieren mit der Resort-Verwaltung, kontrollieren Ihre Wohnung zwischen Ihren Aufenthalten und bereiten alles vor Ihrer Ankunft vor – Sie kommen an und schalten ab.",
        },
        {
          q: "Wie schnell sind Sie im Notfall vor Ort?",
          a: "Andermatt ist von unserem Sitz an der Baarerstrasse 43 in Zug in gut einer Stunde erreichbar – dazu arbeiten wir mit geprüften Partnern im Urserntal, die bei dringenden Fällen sofort reagieren können.",
        },
      ],
    },
    en: {
      metaTitle: "Vacation Home Management Andermatt | Swiss PA Services",
      metaDesc: "Vacation home management in Andermatt: care of resort apartments and chalets at Andermatt Swiss Alps.",
      h1: "Vacation home management in Andermatt",
      h1Accent: "Your residence in the Alps' newest resort",
      intro: [
        "Andermatt has developed into the Alps' newest luxury address: Andermatt Swiss Alps with residences, hotels and a golf course attracts international owners – many buying their first property in Switzerland here.",
        "Whether a residence in the resort or a chalet in the Ursern valley: we care for your property with home watch inspections, key holding, contractor coordination and arrival service. From our base in Zug we are on site in just over an hour – closer than any Zurich agency.",
      ],
      bullets: [
        "Care of resort residences & chalets",
        "Home watch inspections in the Ursern valley",
        "Key holding & access organisation",
        "Contractor & caretaker coordination",
        "Arrival service: heated, stocked, prepared",
        "On site from Zug in just over an hour",
      ],
      faq: [
        {
          q: "I own an apartment in the Andermatt resort – do you also care for residences?",
          a: "Yes, resort residences are even a focus: we coordinate with the resort management, check your apartment between your stays and prepare everything before your arrival – you arrive and switch off.",
        },
        {
          q: "How quickly can you be on site in an emergency?",
          a: "Andermatt is just over an hour from our base at Baarerstrasse 43 in Zug – in addition, we work with vetted partners in the Ursern valley who can respond immediately in urgent cases.",
        },
      ],
    },
  },
  {
    slugDe: "privater-concierge-gstaad",
    slugEn: "private-concierge-gstaad",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Privater Concierge Gstaad | Swiss PA Services",
      metaDesc: "Privater Concierge in Gstaad: Reservationen, Events und besondere Wünsche im Saanenland – Menuhin Festival, Polo, Ski-Logistik.",
      h1: "Privater Concierge in Gstaad",
      h1Accent: "Diskretion auf Weltklasseniveau",
      intro: [
        "Gstaad funktioniert nach eigenen Regeln: Die besten Tische gehen über Beziehungen, die schönsten Chalets stehen nie online, und Diskretion wird höher gewichtet als jeder Preis. Ein privater Concierge in Gstaad braucht genau das – Zugang und Verschwiegenheit.",
        "Wir betreuen Chalet-Besitzer, Hotelgäste und Saison-Residenten im Saanenland: Restaurant- und Hotelreservationen, Zugang zu Events wie dem Menuhin Festival oder dem Polo Gold Cup, Ski-Logistik mit Privatlehrern und die komplette Organisation Ihrer Zeit in Gstaad – diskret und ohne Mitgliedschaft.",
      ],
      bullets: [
        "Reservationen in Gstaads Top-Restaurants",
        "Eventzugänge: Menuhin Festival, Polo Gold Cup & mehr",
        "Ski-Logistik: Privatlehrer, Pässe, Ausrüstung",
        "Personal Shopping auf der Gstaader Promenade",
        "Private Anlässe im Chalet organisiert",
        "Diskret, ohne Mitgliedschaft – DE & EN",
      ],
      faq: [
        {
          q: "Ich bin nur wenige Wochen pro Jahr in Gstaad – lohnt sich ein Concierge?",
          a: "Gerade dann: Ihre Saisonwochen sind zu wertvoll für Organisation. Wir bereiten alles vor – Reservationen, Aktivitäten, Anlässe – damit Sie vom ersten Tag an geniessen. Zwischen Ihren Aufenthalten behalten wir auf Wunsch auch Ihre Liegenschaft im Blick.",
        },
        {
          q: "Was unterscheidet Sie vom Hotel-Concierge?",
          a: "Der Hotel-Concierge arbeitet für sein Haus und seine Gäste – wir arbeiten nur für Sie: auch ausserhalb des Hotels, auch für Chalet-Besitzer, auch über Jahre hinweg. Eine feste Ansprechperson, die Ihren Geschmack kennt, statt wechselnder Schichtdienst.",
        },
      ],
    },
    en: {
      metaTitle: "Private Concierge Gstaad | Swiss PA Services",
      metaDesc: "Private concierge in Gstaad: reservations, events and special wishes in Saanenland – Menuhin Festival, polo, ski logistics. Discreet, no membership, DE/EN.",
      h1: "Private concierge in Gstaad",
      h1Accent: "Discretion at world-class level",
      intro: [
        "Gstaad works by its own rules: the best tables go through relationships, the most beautiful chalets never appear online, and discretion is valued above any price. A private concierge in Gstaad needs exactly that – access and confidentiality.",
        "We support chalet owners, hotel guests and seasonal residents in Saanenland: restaurant and hotel reservations, access to events like the Menuhin Festival or the Hublot Polo Gold Cup, ski logistics with private instructors and the complete organisation of your time in Gstaad – discreet and without membership.",
      ],
      bullets: [
        "Reservations at Gstaad's top restaurants",
        "Event access: Menuhin Festival, Polo Gold Cup & more",
        "Ski logistics: private instructors, passes, equipment",
        "Personal shopping on the Gstaad promenade",
        "Private occasions organised at your chalet",
        "Discreet, no membership – DE & EN",
      ],
      faq: [
        {
          q: "I am only in Gstaad a few weeks a year – is a concierge worth it?",
          a: "Especially then: your season weeks are too valuable for organising. We prepare everything – reservations, activities, occasions – so you enjoy from day one. Between your stays we can also keep an eye on your property.",
        },
        {
          q: "What distinguishes you from a hotel concierge?",
          a: "The hotel concierge works for their house and its guests – we work only for you: also outside the hotel, also for chalet owners, also over years. One dedicated contact who knows your taste, instead of rotating shift service.",
        },
      ],
    },
  },
  {
    slugDe: "privater-concierge-st-moritz",
    slugEn: "private-concierge-st-moritz",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Privater Concierge St. Moritz | Swiss PA Services",
      metaDesc: "Privater Concierge in St. Moritz: White Turf, Snow Polo, Top-Restaurants und besondere Wünsche im Engadin.",
      h1: "Privater Concierge in St. Moritz",
      h1Accent: "Top of the World – perfekt organisiert",
      intro: [
        "St. Moritz ist Bühne: White Turf auf dem zugefrorenen See, Snow Polo, Gourmet-Festival – und dazwischen ein Engadin, das Ruhe atmet. Ein privater Concierge in St. Moritz organisiert beides: den Zugang zum Geschehen und die Momente abseits davon.",
        "Wir betreuen Eigentümer und Gäste in St. Moritz, Celerina und Pontresina: Reservationen in den Top-Restaurants, Tickets und Zugänge zu den Events der Saison, Ski-Logistik in der Corviglia-Region und private Anlässe – diskret, ohne Mitgliedschaft, auf Deutsch und Englisch.",
      ],
      bullets: [
        "Tickets & Zugänge: White Turf, Snow Polo, Gourmet-Festival",
        "Reservationen in den Top-Restaurants des Engadins",
        "Ski-Logistik: Corviglia, Privatlehrer, Ausrüstung",
        "Hotel- & Chalet-Arrangements in St. Moritz & Umgebung",
        "Private Anlässe und Überraschungen",
        "Diskret, ohne Mitgliedschaft – DE & EN",
      ],
      faq: [
        {
          q: "Organisieren Sie Tickets für White Turf und Snow Polo?",
          a: "Ja – von Tribünenplätzen bis zu VIP-Arrangements, je nach Verfügbarkeit und Vorlauf. Die grossen Engadiner Events sind früh ausgebucht: Je früher Sie Bescheid geben, desto mehr ist möglich. Kurzfristige Anfragen versuchen wir trotzdem immer.",
        },
        {
          q: "Wie kurzfristig können Sie Wünsche umsetzen?",
          a: "In der Hochsaison zählt jede Stunde: Reservationen und Arrangements realisieren wir oft noch am selben Tag – je exklusiver der Wunsch, desto mehr Vorlauf hilft. Fragen Sie einfach an: Wir sagen ehrlich, was geht – und was nicht.",
        },
      ],
    },
    en: {
      metaTitle: "Private Concierge St. Moritz | Swiss PA Services",
      metaDesc: "Private concierge in St. Moritz: White Turf, Snow Polo, top restaurants and special wishes in the Engadin – discreetly organised, no membership, DE/EN.",
      h1: "Private concierge in St. Moritz",
      h1Accent: "Top of the World – perfectly organised",
      intro: [
        "St. Moritz is a stage: White Turf on the frozen lake, Snow Polo, gourmet festival – and in between an Engadin that breathes calm. A private concierge in St. Moritz organises both: access to the action and the moments away from it.",
        "We support owners and guests in St. Moritz, Celerina and Pontresina: reservations at the top restaurants, tickets and access to the season's events, ski logistics in the Corviglia region and private occasions – discreet, without membership, in German and English.",
      ],
      bullets: [
        "Tickets & access: White Turf, Snow Polo, gourmet festival",
        "Reservations at the Engadin's top restaurants",
        "Ski logistics: Corviglia, private instructors, equipment",
        "Hotel & chalet arrangements in St. Moritz & surroundings",
        "Private occasions and surprises",
        "Discreet, no membership – DE & EN",
      ],
      faq: [
        {
          q: "Do you organise tickets for White Turf and Snow Polo?",
          a: "Yes – from grandstand seats to VIP arrangements, depending on availability and lead time. The big Engadin events sell out early: the earlier you tell us, the more is possible. We always try last-minute requests anyway.",
        },
        {
          q: "How quickly can you handle requests?",
          a: "In high season every hour counts: we often arrange reservations and requests the same day – the more exclusive the wish, the more lead time helps. Just ask: we honestly say what is possible – and what is not.",
        },
      ],
    },
  },
  {
    slugDe: "privater-concierge-verbier",
    slugEn: "private-concierge-verbier",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Privater Concierge Verbier | Swiss PA Services",
      metaDesc: "Privater Concierge in Verbier: Ski-Guides, Reservationen, Après-Ski und besondere Wünsche im Wallis – für internationale Gäste, ohne Mitgliedschaft, DE/EN.",
      h1: "Privater Concierge in Verbier",
      h1Accent: "Freeride, Lifestyle, alles organisiert",
      intro: [
        "Verbier ist die Adresse für alle, die es sportlich und entspannt zugleich mögen: legendäre Freeride-Hänge am Mont Fort, Après-Ski mit internationalem Publikum, Chalets über dem Val de Bagnes. Ein privater Concierge macht daraus mühelose Ferien.",
        "Wir betreuen internationale Gäste und Chalet-Besitzer in Verbier und Nendaz: Ski-Guides und Privatlehrer, Reservationen in den Berg- und Dorfrestaurants, Eventzugänge und die komplette Organisation Ihres Aufenthalts – koordiniert auf Französisch vor Ort, berichtet auf Englisch oder Deutsch.",
      ],
      bullets: [
        "Ski-Guides, Freeride-Touren & Privatlehrer",
        "Reservationen: Bergrestaurants & Dorf-Adressen",
        "Après-Ski- und Event-Arrangements",
        "Chalet-Services: Köche, Transfers, Ausrüstung",
        "Heliskiing & Erlebnisse organisiert",
        "Vor Ort FR – mit Ihnen EN oder DE",
      ],
      faq: [
        {
          q: "Organisieren Sie Ski-Guides und Heliskiing?",
          a: "Ja, über geprüfte Bergführer und Partner vor Ort: von der privaten Freeride-Tour am Mont Fort bis zum Heliskiing-Arrangement – immer mit Fokus auf Sicherheit und passendem Niveau. In der Hochsaison empfehlen wir, Guides früh zu reservieren.",
        },
        {
          q: "Ich spreche kein Französisch – funktioniert das trotzdem?",
          a: "Vollständig: Wir koordinieren alles vor Ort auf Französisch – Restaurants, Liftgesellschaften, Dienstleister – und kommunizieren mit Ihnen auf Englisch oder Deutsch. Sie bekommen nur das Ergebnis, nicht die Organisation.",
        },
      ],
    },
    en: {
      metaTitle: "Private Concierge Verbier | Swiss PA Services",
      metaDesc: "Private concierge in Verbier: ski guides, reservations, après-ski and special wishes in Valais – for international guests, no membership, DE/EN.",
      h1: "Private concierge in Verbier",
      h1Accent: "Freeride, lifestyle, everything organised",
      intro: [
        "Verbier is the address for those who like it sporty and relaxed at once: legendary freeride faces on Mont Fort, après-ski with an international crowd, chalets above the Val de Bagnes. A private concierge turns it into effortless holidays.",
        "We support international guests and chalet owners in Verbier and Nendaz: ski guides and private instructors, reservations at mountain and village restaurants, event access and the complete organisation of your stay – coordinated in French on site, reported in English or German.",
      ],
      bullets: [
        "Ski guides, freeride tours & private instructors",
        "Reservations: mountain & village restaurants",
        "Après-ski and event arrangements",
        "Chalet services: chefs, transfers, equipment",
        "Heliskiing & experiences organised",
        "On site FR – with you EN or DE",
      ],
      faq: [
        {
          q: "Do you organise ski guides and heliskiing?",
          a: "Yes, through vetted mountain guides and local partners: from the private freeride tour on Mont Fort to the heliskiing arrangement – always with a focus on safety and the right level. In high season we recommend booking guides early.",
        },
        {
          q: "I don't speak French – does it still work?",
          a: "Completely: we coordinate everything on site in French – restaurants, lift companies, service providers – and communicate with you in English or German. You get only the result, not the organisation.",
        },
      ],
    },
  },
  {
    slugDe: "privater-concierge-zermatt",
    slugEn: "private-concierge-zermatt",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Privater Concierge Zermatt | Swiss PA Services",
      metaDesc: "Privater Concierge in Zermatt: Top-Restaurants, Ski-Logistik im autofreien Dorf, Transfers ab Täsch und besondere Wünsche.",
      h1: "Privater Concierge in Zermatt",
      h1Accent: "Autofrei. Anspruchsvoll. Organisiert.",
      intro: [
        "Zermatt hat die höchste Dichte an Top-Restaurants der Alpen – und ein Dorf ohne Autos, in dem jede Logistik Planung braucht. Ein privater Concierge in Zermatt meistert beides: den Tisch im ausgebuchten Gourmet-Tempel und den Transfer, der funktioniert.",
        "Wir betreuen Gäste und Chalet-Besitzer ganzjährig: Reservationen in Zermatts Gourmet-Restaurants, Ski-Logistik am Matterhorn, Gepäck-Transfers ab Bahnhof Täsch, private Berg-Erlebnisse und Anlässe – diskret und ohne Mitgliedschaft, auf Deutsch und Englisch.",
      ],
      bullets: [
        "Reservationen in Zermatts Gourmet-Restaurants",
        "Transfers & Gepäcklogistik ab Täsch organisiert",
        "Ski-Logistik: Pässe, Privatlehrer, Sunrise-Abfahrten",
        "Berg-Erlebnisse: Gornergrat, Glacier Paradise & mehr",
        "Chalet-Services und private Anlässe",
        "Ganzjährig verfügbar – DE & EN",
      ],
      faq: [
        {
          q: "Zermatt ist autofrei – wie organisieren Sie Transport und Gepäck?",
          a: "Das ist unser Alltag: Wir koordinieren Bahn ab Täsch, Elektro-Taxis im Dorf und die Gepäcklogistik bis ins Chalet – Sie steigen in Zürich oder Genf in den Zug und steigen in Zermatt in Ihre Ferien ein, ohne einen Koffer zu tragen.",
        },
        {
          q: "Bekommen Sie wirklich noch kurzfristig einen Restauranttisch?",
          a: "In Zermatt gehen die besten Adressen Wochen vorweg über Beziehungen – genau darin liegt unsere Arbeit. Früh fragen hilft, aber auch kurzfristig finden wir fast immer eine Lösung: entweder den Wunschtisch oder eine Alternative, die mindestens so gut ist.",
        },
      ],
    },
    en: {
      metaTitle: "Private Concierge Zermatt | Swiss PA Services",
      metaDesc: "Private concierge in Zermatt: top restaurants, ski logistics in the car-free village, transfers from Täsch and special wishes – year-round, no membership.",
      h1: "Private concierge in Zermatt",
      h1Accent: "Car-free. Demanding. Organised.",
      intro: [
        "Zermatt has the highest density of top restaurants in the Alps – and a village without cars where every bit of logistics needs planning. A private concierge in Zermatt masters both: the table at the fully booked gourmet temple and the transfer that works.",
        "We support guests and chalet owners year-round: reservations at Zermatt's gourmet restaurants, ski logistics at the Matterhorn, luggage transfers from Täsch station, private mountain experiences and occasions – discreet and without membership, in German and English.",
      ],
      bullets: [
        "Reservations at Zermatt's gourmet restaurants",
        "Transfers & luggage logistics from Täsch organised",
        "Ski logistics: passes, private instructors, sunrise runs",
        "Mountain experiences: Gornergrat, Glacier Paradise & more",
        "Chalet services and private occasions",
        "Available year-round – DE & EN",
      ],
      faq: [
        {
          q: "Zermatt is car-free – how do you organise transport and luggage?",
          a: "That is our daily business: we coordinate the train from Täsch, electric taxis in the village and luggage logistics to the chalet – you board the train in Zurich or Geneva and step into your holiday in Zermatt, without carrying a suitcase.",
        },
        {
          q: "Can you really still get a restaurant table at short notice?",
          a: "In Zermatt the best addresses are booked weeks ahead through relationships – that is exactly our work. Asking early helps, but even at short notice we almost always find a solution: either the desired table or an alternative at least as good.",
        },
      ],
    },
  },
  {
    slugDe: "privater-concierge-andermatt",
    slugEn: "private-concierge-andermatt",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Privater Concierge Andermatt | Swiss PA Services",
      metaDesc: "Privater Concierge in Andermatt: Reservationen, Golf, Konzerte und Ski-Logistik im Resort und Urserntal – nah ab Zug, ohne Mitgliedschaft, DE/EN.",
      h1: "Privater Concierge in Andermatt",
      h1Accent: "Das neue Alpen-Resort, mühelos genossen",
      intro: [
        "Andermatt ist die jüngste Luxus-Adresse der Alpen: Resort-Residenzen, The Chedi, Golfplatz, Konzerthalle – eingebettet ins ursprüngliche Urserntal. Ein privater Concierge verbindet beides: die Welt des Resorts und die der Region.",
        "Wir betreuen Eigentümer und Gäste in Andermatt: Reservationen in den Resort-Restaurants und Berg-Gasthöfen, Golf-Arrangements, Tickets für die Konzerthalle, Ski-Logistik am Gemsstock und private Anlässe. Von unserem Sitz in Zug sind wir in gut einer Stunde vor Ort.",
      ],
      bullets: [
        "Reservationen: Resort-Restaurants & Urserntaler Adressen",
        "Golf-Abschlagzeiten & Arrangements organisiert",
        "Konzert-Tickets für die Andermatt Konzerthalle",
        "Ski-Logistik: Gemsstock, Privatlehrer, Pässe",
        "Chalet-Services und private Anlässe",
        "Ab Zug in gut einer Stunde vor Ort – DE & EN",
      ],
      faq: [
        {
          q: "Sind Sie auch innerhalb des Andermatt Resorts tätig?",
          a: "Ja: Wir koordinieren mit der Resort-Verwaltung und den Hotelteams – und ergänzen sie, wo es um Ihr Privates geht: Anlässe in Ihrer Residence, Ausflüge ins Urserntal, Organisation jenseits des Hotelangebots. Eine Ansprechperson für Resort und Region.",
        },
        {
          q: "Organisieren Sie Golf und Konzerte?",
          a: "Beides gehört zu unseren meistgebuchten Services in Andermatt: Abschlagzeiten auf dem Championship-Platz inklusive Unterkunft und Transfers, dazu Karten für die Konzerthalle – von der Kammermusik bis zu internationalen Orchestern.",
        },
      ],
    },
    en: {
      metaTitle: "Private Concierge Andermatt | Swiss PA Services",
      metaDesc: "Private concierge in Andermatt: reservations, golf, concerts and ski logistics in the resort and Ursern valley – close from Zug, no membership, DE/EN.",
      h1: "Private concierge in Andermatt",
      h1Accent: "The Alps' newest resort, enjoyed effortlessly",
      intro: [
        "Andermatt is the Alps' newest luxury address: resort residences, The Chedi, golf course, concert hall – embedded in the pristine Ursern valley. A private concierge connects both: the world of the resort and that of the region.",
        "We support owners and guests in Andermatt: reservations at the resort restaurants and mountain inns, golf arrangements, tickets for the concert hall, ski logistics at the Gemsstock and private occasions. From our base in Zug we are on site in just over an hour.",
      ],
      bullets: [
        "Reservations: resort restaurants & Ursern valley addresses",
        "Golf tee times & arrangements organised",
        "Concert tickets for the Andermatt Concert Hall",
        "Ski logistics: Gemsstock, private instructors, passes",
        "Chalet services and private occasions",
        "On site from Zug in just over an hour – DE & EN",
      ],
      faq: [
        {
          q: "Do you also work inside the Andermatt resort?",
          a: "Yes: we coordinate with the resort management and hotel teams – and complement them where your private life is concerned: occasions in your residence, excursions into the Ursern valley, organisation beyond the hotel offer. One contact for resort and region.",
        },
        {
          q: "Do you organise golf and concerts?",
          a: "Both are among our most-booked services in Andermatt: tee times on the championship course including accommodation and transfers, plus tickets for the concert hall – from chamber music to international orchestras.",
        },
      ],
    },
  },
  {
    slugDe: "luxus-concierge-gstaad",
    slugEn: "luxury-concierge-gstaad",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Luxus Concierge Gstaad | Swiss PA Services",
      metaDesc: "Luxus Concierge in Gstaad: Zugang zum Ausgebuchten und Unmöglichen – Chalets, Events, private Arrangements im Saanenland.",
      h1: "Luxus Concierge in Gstaad",
      h1Accent: "Zugang statt Warteliste",
      intro: [
        "Gstaad ist der Ort, an dem Geld allein nicht reicht: Die begehrtesten Chalets, die Tische in der Hochsaison, die Plätze bei Polo und Menuhin Festival – alles geht über Beziehungen, die über Jahre aufgebaut werden. Ein Luxus Concierge in Gstaad liefert genau diesen Zugang.",
        "Wir betreuen eine kleine Zahl von Kunden im Saanenland mit höchsten Ansprüchen: ausgebuchte Hotels und Privatchalets, Zugang zu gesellschaftlichen Anlässen, komplette Anlässe im eigenen Chalet mit Köchen und Service – orchestriert von einer festen Ansprechperson, auf Wunsch unter NDA.",
      ],
      bullets: [
        "Zugang zu ausgebuchten Hotels & Privatchalets",
        "Gesellschaftliche Anlässe: Polo, Menuhin Festival & mehr",
        "Private Events im Chalet: Köche, Service, Inszenierung",
        "Jet- & Heli-Logistik, Fahrer, Sicherheit koordiniert",
        "Beschaffung des scheinbar Unerhältlichen",
        "Feste Ansprechperson, NDA-Standard, DE & EN",
      ],
      faq: [
        {
          q: "Was unterscheidet einen Luxus Concierge vom klassischen Concierge?",
          a: "Der klassische Concierge erledigt Wünsche effizient – der Luxus Concierge öffnet Türen, die es offiziell nicht gibt: die ausgebuchte Suite über Neujahr, der Tisch, der seit Monaten voll ist, der Anlass, an den man nicht eingeladen wird. Das Fundament sind Jahre lokaler Beziehungen im Saanenland.",
        },
        {
          q: "Wie diskret arbeiten Sie?",
          a: "Absolut: eine feste Ansprechperson, keine Verteilerlisten, keine Fotos, keine Namen – auf Wunsch mit NDA. In Gstaad kennt man sich; umso wichtiger, dass über unsere Kunden nichts bekannt wird. Diskretion ist bei uns keine Leistung, sondern Voraussetzung.",
        },
      ],
    },
    en: {
      metaTitle: "Luxury Concierge Gstaad | Swiss PA Services",
      metaDesc: "Luxury concierge in Gstaad: access to the fully booked and impossible – chalets, events, private arrangements in Saanenland.",
      h1: "Luxury concierge in Gstaad",
      h1Accent: "Access instead of waiting lists",
      intro: [
        "Gstaad is the place where money alone is not enough: the most sought-after chalets, the tables in high season, the seats at polo and the Menuhin Festival – everything goes through relationships built over years. A luxury concierge in Gstaad delivers exactly this access.",
        "We support a small number of clients in Saanenland with the highest standards: fully booked hotels and private chalets, access to social occasions, complete events at your own chalet with chefs and service – orchestrated by one dedicated contact, under NDA on request.",
      ],
      bullets: [
        "Access to fully booked hotels & private chalets",
        "Social occasions: polo, Menuhin Festival & more",
        "Private events at your chalet: chefs, service, staging",
        "Jet & helicopter logistics, drivers, security coordinated",
        "Sourcing the seemingly unobtainable",
        "Dedicated contact, NDA standard, DE & EN",
      ],
      faq: [
        {
          q: "What distinguishes a luxury concierge from a classic concierge?",
          a: "A classic concierge handles wishes efficiently – a luxury concierge opens doors that officially do not exist: the sold-out suite over New Year, the table fully booked for months, the occasion one is not invited to. The foundation is years of local relationships in Saanenland.",
        },
        {
          q: "How discreetly do you work?",
          a: "Absolutely: one dedicated contact, no mailing lists, no photos, no names – with NDA on request. In Gstaad everyone knows each other; all the more important that nothing about our clients becomes known. Discretion is not a service for us, but a prerequisite.",
        },
      ],
    },
  },
  {
    slugDe: "luxus-concierge-st-moritz",
    slugEn: "luxury-concierge-st-moritz",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Luxus Concierge St. Moritz | Swiss PA Services",
      metaDesc: "Luxus Concierge in St. Moritz: Zugang zu White Turf, Snow Polo und den Top-Adressen des Engadins – Jet-Anreise, private Anlässe, absolute Diskretion.",
      h1: "Luxus Concierge in St. Moritz",
      h1Accent: "Wo die Welt zusammenkommt – sind Sie dabei",
      intro: [
        "St. Moritz ist seit über 150 Jahren die Winterbühne der Welt: White Turf auf dem gefrorenen See, Snow Polo, Gourmet-Festival – und eine Hochsaison, in der ohne Zugang nichts geht. Ein Luxus Concierge in St. Moritz besorgt, was nicht buchbar ist.",
        "Wir betreuen Kunden mit höchsten Ansprüchen im Engadin: Anreise per Privatjet über Engadin Airport, ausgebuchte Suiten und Privatchalets, VIP-Arrangements bei den grossen Events und private Anlässe auf Weltklasseniveau – orchestriert von einer festen Ansprechperson, absolut diskret.",
      ],
      bullets: [
        "Jet-Anreise via Engadin Airport koordiniert",
        "White Turf, Snow Polo & Gourmet-Festival: VIP-Arrangements",
        "Ausgebuchte Suiten & Privatchalets im Engadin",
        "Private Anlässe: Köche, Service, Inszenierung",
        "Heli-Transfers, Fahrer und Sicherheit",
        "Absolute Diskretion, NDA-Standard, DE & EN",
      ],
      faq: [
        {
          q: "Anreise per Privatjet – koordinieren Sie den Engadin Airport?",
          a: "Ja, komplett: Slots, Handling, Transfer ins Hotel oder Chalet, auf Wunsch Heli-Shuttle. Samedan ist Europas höchstgelegener Flughafen – wir kennen die Abläufe und die Betreiber und sorgen dafür, dass An- und Abreise unsichtbar funktionieren.",
        },
        {
          q: "Können Sie auch organisieren, was offiziell ausverkauft ist?",
          a: "Das ist der Kern unserer Arbeit in St. Moritz: Beziehungen über Jahre zu Hotels, Veranstaltern und Eigentümern. Wir versprechen nie das Unmögliche – aber wir fragen dort an, wo andere gar nicht erst anrufen. Ehrlich im Vorlauf, hartnäckig in der Umsetzung.",
        },
      ],
    },
    en: {
      metaTitle: "Luxury Concierge St. Moritz | Swiss PA Services",
      metaDesc: "Luxury concierge in St. Moritz: access to White Turf, Snow Polo and the Engadin's top addresses – jet arrival, private occasions, absolute discretion.",
      h1: "Luxury concierge in St. Moritz",
      h1Accent: "Where the world comes together – you belong",
      intro: [
        "St. Moritz has been the world's winter stage for over 150 years: White Turf on the frozen lake, Snow Polo, gourmet festival – and a high season in which nothing works without access. A luxury concierge in St. Moritz procures what cannot be booked.",
        "We support clients with the highest standards in the Engadin: arrival by private jet via Engadin Airport, fully booked suites and private chalets, VIP arrangements at the major events and private occasions at world-class level – orchestrated by one dedicated contact, absolutely discreet.",
      ],
      bullets: [
        "Jet arrival via Engadin Airport coordinated",
        "White Turf, Snow Polo & gourmet festival: VIP arrangements",
        "Fully booked suites & private chalets in the Engadin",
        "Private occasions: chefs, service, staging",
        "Helicopter transfers, drivers and security",
        "Absolute discretion, NDA standard, DE & EN",
      ],
      faq: [
        {
          q: "Arrival by private jet – do you coordinate Engadin Airport?",
          a: "Yes, completely: slots, handling, transfer to hotel or chalet, helicopter shuttle on request. Samedan is Europe's highest airport – we know the processes and the operators and make sure arrival and departure work invisibly.",
        },
        {
          q: "Can you also organise what is officially sold out?",
          a: "That is the core of our work in St. Moritz: relationships over years with hotels, organisers and owners. We never promise the impossible – but we ask where others do not even call. Honest in the lead-up, persistent in execution.",
        },
      ],
    },
  },
  {
    slugDe: "airbnb-verwaltung-nendaz",
    slugEn: "airbnb-concierge-nendaz",
    service: "home-property-management",
    de: {
      metaTitle: "Airbnb Verwaltung Nendaz | Swiss PA Services",
      metaDesc: "Airbnb-Verwaltung in Nendaz: Gästekommunikation, Check-in, Reinigung und Preisoptimierung für Ihre Ferienwohnung im Val de Nendaz.",
      h1: "Airbnb-Verwaltung in Nendaz",
      h1Accent: "Ihre Ferienwohnung in den 4 Vallées – voll betreut",
      intro: [
        "Nendaz liegt im Herzen der 4 Vallées – Skigebiet im Winter, Wanderparadies im Sommer. Viele Eigentümer hier wohnen weit weg: Genf, Zürich, Grossbritannien. Eine Ferienwohnung auf Airbnb bringt Einnahmen, aber die Arbeit bleibt vor Ort – und die läuft auf Französisch.",
        "Wir übernehmen Ihre Kurzzeitvermietung in Nendaz, Veysonnaz und Siviez komplett: Gästekommunikation, Check-ins, Reinigung zwischen den Aufenthalten und die Preisgestaltung für Ski- und Sommersaison. Sie sehen nur die Abrechnung – und die Bewertungen.",
      ],
      bullets: [
        "Gästekommunikation 7 Tage die Woche – FR/DE/EN",
        "Check-in, Check-out & Schlüsselübergabe vor Ort",
        "Reinigung & Wäsche zwischen den Aufenthalten",
        "Preis- & Kalenderoptimierung für Ski- und Sommersaison",
        "Inserat-Optimierung: Texte, Fotos, Bewertungen",
        "Regeln & Anmeldungen der Gemeinde Nendaz geprüft",
      ],
      faq: [
        {
          q: "Sie sitzen in Zug – wer ist in Nendaz vor Ort?",
          a: "Unser geprüftes Netzwerk im Val de Nendaz: Check-ins, Reinigung und kleine Reparaturen erledigen lokale Partner, die wir koordinieren und kontrollieren. Sie haben nur einen Ansprechpartner – uns – und erhalten jeden Beleg und jedes Protokoll auf Deutsch oder Englisch.",
        },
        {
          q: "Was kann ich mit meiner Wohnung in Nendaz verdienen?",
          a: "Das hängt von Grösse, Lage und Ausstattung ab – die Skisaison und die Sommerferien sind die ertragreichen Zeiten. Nach einer kostenlosen Erstbesichtigung erhalten Sie eine realistische Ertragsschätzung und eine transparente Offerte für die Verwaltung.",
        },
      ],
    },
    en: {
      metaTitle: "Airbnb Concierge Nendaz | Swiss PA Services",
      metaDesc: "Airbnb concierge in Nendaz: guest communication, check-in, cleaning and price optimisation for your holiday flat in Val de Nendaz.",
      h1: "Airbnb concierge in Nendaz",
      h1Accent: "Your holiday flat in the 4 Vallées – fully managed",
      intro: [
        "Nendaz lies at the heart of the 4 Vallées – ski area in winter, hiking paradise in summer. Many owners here live far away: Geneva, Zurich, Britain. A holiday flat on Airbnb brings income, but the work stays on site – and it runs in French.",
        "We take over your short-term rental in Nendaz, Veysonnaz and Siviez completely: guest communication, check-ins, cleaning between stays and pricing for ski and summer season. You only see the statements – and the reviews.",
      ],
      bullets: [
        "Guest communication 7 days a week – FR/DE/EN",
        "Check-in, check-out & key handover on site",
        "Cleaning & laundry between stays",
        "Price & calendar optimisation for ski and summer season",
        "Listing optimisation: texts, photos, reviews",
        "Nendaz municipal rules & registrations checked",
      ],
      faq: [
        {
          q: "You are based in Zug – who is on site in Nendaz?",
          a: "Our vetted network in Val de Nendaz: check-ins, cleaning and small repairs are done by local partners whom we coordinate and supervise. You have only one point of contact – us – and receive every receipt and report in German or English.",
        },
        {
          q: "What can I earn with my flat in Nendaz?",
          a: "That depends on size, location and equipment – ski season and summer holidays are the high-yield periods. After a free initial visit you receive a realistic revenue estimate and a transparent management quote.",
        },
      ],
    },
  },
  {
    slugDe: "luxus-concierge-lausanne",
    slugEn: "luxury-concierge-lausanne",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Luxus Concierge Lausanne | Swiss PA Services",
      metaDesc: "Luxus Concierge in Lausanne: Zugang zu Top-Restaurants, Events und besonderen Arrangements an der Genfersee-Riviera – Lavaux, Béjart Ballet, Privates.",
      h1: "Luxus Concierge in Lausanne",
      h1Accent: "Die diskrete Riviera-Adresse",
      intro: [
        "Lausanne ist die stille Luxus-Adresse der Schweiz: Olympische Hauptstadt, Lausanne Palace, die Weinterrassen von Lavaux vor der Tür. Ein Luxus Concierge in Lausanne öffnet die Türen, die nicht im Reiseführer stehen – auf Französisch vor Ort, mit Ihnen auf Deutsch oder Englisch.",
        "Wir betreuen internationale Kunden zwischen Lausanne, Ouchy und Lavaux: Reservationen in den besten Restaurants, Zugang zu Kultur und Events, private Arrangements auf dem Genfersee und Anlässe, die niemand sieht – orchestriert von einer festen Ansprechperson, ohne Mitgliedschaft.",
      ],
      bullets: [
        "Reservationen: Top-Restaurants & Hotel-Adressen",
        "Kultur & Events: Béjart Ballet, Plateforme 10 & mehr",
        "Genfersee-Arrangements: Boot, Lavaux, Riviera",
        "Personal Shopping in der Rue de Bourg",
        "Private Anlässe – unsichtbar organisiert",
        "NDA-Standard, ohne Mitgliedschaft – FR/DE/EN",
      ],
      faq: [
        {
          q: "Was unterscheidet einen Luxus Concierge vom klassischen Concierge?",
          a: "Der klassische Concierge erledigt Wünsche effizient – der Luxus Concierge beschafft Zugang: der Tisch, der seit Wochen voll ist, das Arrangement, das es offiziell nicht gibt. In Lausanne zählt dabei die Zweisprachigkeit: vor Ort Französisch, mit Ihnen Deutsch oder Englisch.",
        },
        {
          q: "Ich spreche kein Französisch – funktioniert das in Lausanne?",
          a: "Vollständig: Wir führen die gesamte Koordination mit Restaurants, Veranstaltern und Dienstleistern auf Französisch und berichten Ihnen auf Deutsch oder Englisch. Sie erleben Lausanne wie ein Local – ohne die Sprachbarriere.",
        },
      ],
    },
    en: {
      metaTitle: "Luxury Concierge Lausanne | Swiss PA Services",
      metaDesc: "Luxury concierge in Lausanne: access to top restaurants, events and special arrangements on the Lake Geneva Riviera.",
      h1: "Luxury concierge in Lausanne",
      h1Accent: "The discreet Riviera address",
      intro: [
        "Lausanne is Switzerland's quiet luxury address: Olympic capital, Lausanne Palace, the Lavaux wine terraces at the doorstep. A luxury concierge in Lausanne opens the doors that are not in the guidebook – in French on site, in German or English with you.",
        "We support international clients between Lausanne, Ouchy and Lavaux: reservations at the best restaurants, access to culture and events, private arrangements on Lake Geneva and occasions nobody sees – orchestrated by one dedicated contact, without membership.",
      ],
      bullets: [
        "Reservations: top restaurants & hotel addresses",
        "Culture & events: Béjart Ballet, Plateforme 10 & more",
        "Lake Geneva arrangements: boat, Lavaux, Riviera",
        "Personal shopping on Rue de Bourg",
        "Private occasions – invisibly organised",
        "NDA standard, no membership – FR/DE/EN",
      ],
      faq: [
        {
          q: "What distinguishes a luxury concierge from a classic concierge?",
          a: "A classic concierge handles wishes efficiently – a luxury concierge procures access: the table fully booked for weeks, the arrangement that officially does not exist. In Lausanne, bilingualism is key: French on site, German or English with you.",
        },
        {
          q: "I don't speak French – does it work in Lausanne?",
          a: "Completely: we handle all coordination with restaurants, organisers and service providers in French and report to you in German or English. You experience Lausanne like a local – without the language barrier.",
        },
      ],
    },
  },
  {
    slugDe: "persoenliche-assistentin-lugano",
    slugEn: "personal-assistant-lugano",
    service: "persoenliche-assistenz",
    de: {
      metaTitle: "Persönliche Assistentin Lugano | Swiss PA Services",
      metaDesc: "Persönliche Assistentin in Lugano: Termine, Behörden, Haushalt und Familie organisiert – auf Italienisch vor Ort, mit Ihnen auf Deutsch oder Englisch.",
      h1: "Persönliche Assistentin in Lugano",
      h1Accent: "Ihr Tessiner Alltag – einfach organisiert",
      intro: [
        "Lugano zieht Unternehmer, Familien und Grenzgänger an – und stellt sie vor eine Besonderheit: Der Alltag läuft auf Italienisch. Behörden, Dienstleister, Schulen, Handwerker. Eine persönliche Assistentin in Lugano übernimmt genau das – und Sie behalten den Überblick in Ihrer Sprache.",
        "Ob wenige Stunden pro Woche oder ein laufendes Mandat: Wir organisieren Termine, Reisen und Korrespondenz, koordinieren Haushalt und Dienstleister und erledigen Behördengänge im Kanton Tessin – diskret, ohne Festanstellung, ohne Grundgebühr.",
      ],
      bullets: [
        "Termin-, Reise- & Korrespondenzmanagement",
        "Behördengänge & Erledigungen auf Italienisch",
        "Haushalt & Dienstleister koordiniert",
        "Familienlogistik: Schule, Ärzte, Anlässe",
        "Beschaffungen & Reservationen im Tessin",
        "Mit Ihnen auf Deutsch oder Englisch",
      ],
      faq: [
        {
          q: "Festanstellung oder externe Assistentin – was lohnt sich in Lugano?",
          a: "Eine Festanstellung kostet mit Lohnnebenkosten schnell sechsstellig – bei Vollzeitpräsenz, die die wenigsten brauchen. Unsere Assistentinnen arbeiten ohne Anstellung: Sie zahlen nur die tatsächlich geleisteten Stunden, flexibel skalierbar, nach kostenlosem Erstgespräch mit transparenter Offerte.",
        },
        {
          q: "Übernehmen Sie die Kommunikation auf Italienisch?",
          a: "Ja, komplett: Gemeinde, Migrationsamt, Versicherungen, Schule und Handwerker – alles, was im Tessin auf Italienisch läuft, koordinieren wir für Sie. Sie erhalten jeden Stand auf Deutsch oder Englisch und unterschreiben erst, wenn alles erklärt ist.",
        },
      ],
    },
    en: {
      metaTitle: "Personal Assistant Lugano | Swiss PA Services",
      metaDesc: "Personal assistant in Lugano: diary, authorities, household and family organised – in Italian on site, in German or English with you. No permanent hire.",
      h1: "Personal assistant in Lugano",
      h1Accent: "Your Ticino daily life – simply organised",
      intro: [
        "Lugano attracts entrepreneurs, families and cross-border commuters – and confronts them with a particularity: daily life runs in Italian. Authorities, service providers, schools, craftsmen. A personal assistant in Lugano takes over exactly that – and you keep track in your own language.",
        "Whether a few hours per week or an ongoing mandate: we organise appointments, travel and correspondence, coordinate household and service providers and handle authority errands in the canton of Ticino – discreet, no permanent hire, no base fee.",
      ],
      bullets: [
        "Diary, travel & correspondence management",
        "Authority errands & tasks in Italian",
        "Household & service providers coordinated",
        "Family logistics: school, doctors, occasions",
        "Sourcing & reservations in Ticino",
        "With you in German or English",
      ],
      faq: [
        {
          q: "Permanent hire or external assistant – what pays off in Lugano?",
          a: "A permanent hire quickly costs six figures including payroll costs – for full-time presence that very few need. Our assistants work without employment: you pay only for hours actually worked, flexibly scalable, with a transparent quote after a free initial consultation.",
        },
        {
          q: "Do you handle the communication in Italian?",
          a: "Yes, completely: municipality, migration office, insurance, school and craftsmen – everything that runs in Italian in Ticino, we coordinate for you. You receive every status in German or English and sign only once everything is explained.",
        },
      ],
    },
  },
  {
    slugDe: "privater-chauffeur-zuerich",
    slugEn: "private-chauffeur-zurich",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Privater Chauffeur Zürich | Swiss PA Services",
      metaDesc: "Privater Chauffeur in Zürich: Flughafentransfer ZRH, Geschäftsfahrten, Tagesfahrten & Event-Transfers – von uns komplett organisiert, diskret, auf DE/EN.",
      h1: "Privater Chauffeur in Zürich",
      h1Accent: "Ihre Fahrten – persönlich organisiert",
      intro: [
        "Flughafen Zürich um 6 Uhr morgens, Roadshow mit sechs Terminen, Abholung der Gäste zum Anlass: Fahrten in Zürich wollen organisiert sein – nicht nur bestellt. Wir übernehmen das komplett: geprüfte Fahrer, passende Fahrzeuge, Timing, Routen und Wartezeiten.",
        "Eine Nachricht genügt – wir organisieren den Rest: Flugüberwachung bei Abholungen, Meet & Greet in der Ankunftshalle, Kindersitze auf Wunsch, diskrete Fahrten für anspruchsvolle Kunden. Abgerechnet wird über uns, Sie haben eine einzige Ansprechperson – auf Deutsch und Englisch.",
      ],
      bullets: [
        "Flughafentransfer Zürich (ZRH) mit Flugüberwachung",
        "Geschäfts- & Roadshow-Fahrten in ganz Zürich",
        "Tages- & Stundendisposition mit Fahrer",
        "Event-, Hochzeits- & Gäste-Transfers",
        "Diskrete Fahrten für UHNW- & Family-Office-Kunden",
        "Fahrer & Fahrzeug nach Anlass organisiert",
      ],
      faq: [
        {
          q: "Wie läuft die Organisation meiner Fahrt ab?",
          a: "Sie schreiben uns, wer wann wo hin muss – wir organisieren Fahrer, Fahrzeug, Timing und Wartezeiten. Abgerechnet wird über uns: eine Ansprechperson, eine Rechnung, volle Verantwortung bei der Ausführung.",
        },
        {
          q: "Flughafen Zürich: Was passiert bei Flugverspätung?",
          a: "Nichts, was Sie betrifft: Wir überwachen Ihren Flug, der Fahrer wartet entsprechend – Meet & Greet mit Namensschild in der Ankunftshalle, Hilfe mit dem Gepäck, auf Wunsch Wasser im Auto. Verspätungen sind unser Problem, nicht Ihres.",
        },
      ],
    },
    en: {
      metaTitle: "Private Chauffeur Zurich | Swiss PA Services",
      metaDesc: "Private chauffeur in Zurich: ZRH airport transfers, business rides, day hire & event transfers – fully organised by us, discreet, in German & English.",
      h1: "Private chauffeur in Zurich",
      h1Accent: "Your rides – personally organised",
      intro: [
        "Zurich airport at 6 a.m., a roadshow with six appointments, picking up guests for an occasion: rides in Zurich need to be organised – not just booked. We take over completely: vetted drivers, suitable vehicles, timing, routes and waiting times.",
        "One message is enough – we organise the rest: flight tracking for pickups, meet & greet in the arrivals hall, child seats on request, discreet rides for demanding clients. Billing runs through us, you have one single contact – in German and English.",
      ],
      bullets: [
        "Zurich airport (ZRH) transfers with flight tracking",
        "Business & roadshow rides across Zurich",
        "Daily & hourly hire with driver",
        "Event, wedding & guest transfers",
        "Discreet rides for UHNW & family office clients",
        "Driver & vehicle organised for the occasion",
      ],
      faq: [
        {
          q: "How does the organisation of my ride work?",
          a: "You tell us who needs to be where and when – we organise driver, vehicle, timing and waiting times. Billing runs through us: one contact, one invoice, full responsibility for execution.",
        },
        {
          q: "Zurich airport: what happens if my flight is delayed?",
          a: "Nothing that concerns you: we track your flight, the driver waits accordingly – meet & greet with a name sign in the arrivals hall, help with luggage, water in the car on request. Delays are our problem, not yours.",
        },
      ],
    },
  },
  {
    slugDe: "privater-chauffeur-zug",
    slugEn: "private-chauffeur-zug",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Privater Chauffeur Zug | Swiss PA Services",
      metaDesc: "Privater Chauffeur in Zug: Flughafentransfers Zug–ZRH, Geschäftsfahrten und Tagesfahrten – von der Baarerstrasse 43 komplett organisiert, diskret, DE/EN.",
      h1: "Privater Chauffeur in Zug",
      h1Accent: "Von der Baarerstrasse 43 organisiert",
      intro: [
        "Von Zug zum Flughafen Zürich in 35 Minuten, zu Meetings nach Zürich, Basel oder Bern: Wer im Kanton Zug arbeitet, fährt viel – und will dabei arbeiten oder abschalten, nicht navigieren. Wir organisieren Ihre Fahrten komplett: geprüfte Fahrer, saubere Fahrzeuge, exaktes Timing.",
        "Und weil wir an der Baarerstrasse 43 sitzen, sind wir nah: kurzfristige Fahrten, Abholung Ihrer Gäste, Familien- und Schulfahrten oder der diskrete Transfer zu Ihrem Chalet in den Alpen. Eine Nachricht genügt – Sie steigen ein, den Rest organisieren wir.",
      ],
      bullets: [
        "Flughafentransfer Zug ↔ Zürich (ZRH) mit Flugüberwachung",
        "Geschäftsfahrten nach Zürich, Basel & Bern",
        "Tagesfahrten & Ausflüge mit Fahrer",
        "Gäste-Abholung & Event-Transfers",
        "Diskrete Transfers in die Bergregionen",
        "Eine Ansprechperson, Abrechnung über uns",
      ],
      faq: [
        {
          q: "Was kostet ein Transfer von Zug zum Flughafen Zürich?",
          a: "Je nach Fahrzeugklasse und Uhrzeit – nach Ihrer Anfrage erhalten Sie innert 24 Stunden einen transparenten Festpreis, inklusive Wartezeit und Gepäckservice. Keine versteckten Kosten, keine Taxameter-Überraschungen.",
        },
        {
          q: "Wie kurzfristig kann ich eine Fahrt anfragen?",
          a: "Von der Baarerstrasse 43 aus sehr kurzfristig: Standard-Transfers organisieren wir oft noch am selben Tag, für besondere Anlässe empfehlen wir ein bis zwei Tage Vorlauf. Sie schreiben uns – wir organisieren Fahrer, Fahrzeug und Timing.",
        },
      ],
    },
    en: {
      metaTitle: "Private Chauffeur Zug | Swiss PA Services",
      metaDesc: "Private chauffeur in Zug: airport transfers Zug–ZRH, business rides and day hire – fully organised from Baarerstrasse 43, discreet, DE/EN.",
      h1: "Private chauffeur in Zug",
      h1Accent: "Organised from Baarerstrasse 43",
      intro: [
        "From Zug to Zurich airport in 35 minutes, to meetings in Zurich, Basel or Bern: those who work in the canton of Zug travel a lot – and want to work or switch off along the way, not navigate. We organise your rides completely: vetted drivers, clean vehicles, exact timing.",
        "And because we are based at Baarerstrasse 43, we are close: last-minute rides, picking up your guests, family and school runs or the discreet transfer to your chalet in the Alps. One message is enough – you step in, we organise the rest.",
      ],
      bullets: [
        "Airport transfer Zug ↔ Zurich (ZRH) with flight tracking",
        "Business rides to Zurich, Basel & Bern",
        "Day trips & excursions with driver",
        "Guest pickup & event transfers",
        "Discreet transfers to the Alpine regions",
        "One contact, billing through us",
      ],
      faq: [
        {
          q: "What does a transfer from Zug to Zurich airport cost?",
          a: "Depending on vehicle class and time – after your enquiry you receive a transparent fixed price within 24 hours, including waiting time and luggage service. No hidden costs, no taximeter surprises.",
        },
        {
          q: "How short notice can I request a ride?",
          a: "From Baarerstrasse 43 very quickly: we often organise standard transfers the same day; for special occasions we recommend one to two days' notice. You write to us – we organise driver, vehicle and timing.",
        },
      ],
    },
  },
  {
    slugDe: "privater-chauffeur-luzern",
    slugEn: "private-chauffeur-lucerne",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Privater Chauffeur Luzern | Swiss PA Services",
      metaDesc: "Privater Chauffeur in Luzern: Flughafentransfer ZRH, Fahrten zu KKL-Events, Ausflüge und Tagesdisposition – persönlich organisiert, diskret, DE/EN.",
      h1: "Privater Chauffeur in Luzern",
      h1Accent: "Ihre Fahrten am See – persönlich organisiert",
      intro: [
        "Konzertabend im KKL, Gäste am Flughafen, der Ausflug auf Rigi oder Pilatus: In Luzern wollen Fahrten zur Lebensqualität passen. Wir organisieren sie komplett – geprüfte Fahrer, passende Fahrzeuge, exaktes Timing, diskrete Abwicklung.",
        "Für Bewohner und Zweitwohnsitz-Eigentümer gleichermassen: Wir holen Ihre Gäste ab, fahren Sie zu Terminen und Anlässen und organisieren Tagesausflüge mit Fahrer. Eine Nachricht genügt – den Rest organisieren wir, auf Deutsch und Englisch.",
      ],
      bullets: [
        "Flughafentransfer Luzern ↔ Zürich (ZRH) mit Flugüberwachung",
        "Fahrten zu KKL-Events, Konzerten & Anlässen",
        "Tagesfahrten & Ausflüge: Rigi, Pilatus, Vierwaldstättersee",
        "Gäste-Abholung & Hochzeitstransfers",
        "Geschäftsfahrten in der Zentralschweiz",
        "Eine Ansprechperson, Abrechnung über uns",
      ],
      faq: [
        {
          q: "Wie lange dauert der Transfer von Luzern zum Flughafen Zürich?",
          a: "Je nach Verkehr rund 50 bis 70 Minuten. Wir planen mit Puffer, überwachen Ihren Flug bei der Abholung und holen Sie mit Namensschild in der Ankunftshalle ab – inklusive Gepäckhilfe und auf Wunsch Kindersitzen.",
        },
        {
          q: "Organisieren Sie auch Ausflüge mit Fahrer für unsere Gäste?",
          a: "Ja, das ist ein beliebter Service in Luzern: Tagesausflüge auf Rigi und Pilatus, Seerundfahrten mit Anschlussfahrt oder die Tour ins Berner Oberland – mit Fahrer, Zeitplan und Reservationen komplett von uns organisiert.",
        },
      ],
    },
    en: {
      metaTitle: "Private Chauffeur Lucerne | Swiss PA Services",
      metaDesc: "Private chauffeur in Lucerne: ZRH airport transfers, rides to KKL events, excursions and day hire – personally organised, discreet, DE/EN.",
      h1: "Private chauffeur in Lucerne",
      h1Accent: "Your rides at the lake – personally organised",
      intro: [
        "A concert evening at the KKL, guests at the airport, the excursion to Rigi or Pilatus: in Lucerne, rides should match the quality of life. We organise them completely – vetted drivers, suitable vehicles, exact timing, discreet handling.",
        "For residents and second home owners alike: we pick up your guests, drive you to appointments and occasions and organise day trips with a driver. One message is enough – we organise the rest, in German and English.",
      ],
      bullets: [
        "Airport transfer Lucerne ↔ Zurich (ZRH) with flight tracking",
        "Rides to KKL events, concerts & occasions",
        "Day trips & excursions: Rigi, Pilatus, Lake Lucerne",
        "Guest pickup & wedding transfers",
        "Business rides in Central Switzerland",
        "One contact, billing through us",
      ],
      faq: [
        {
          q: "How long is the transfer from Lucerne to Zurich airport?",
          a: "Depending on traffic, roughly 50 to 70 minutes. We plan with a buffer, track your flight for pickups and meet you with a name sign in the arrivals hall – including luggage help and child seats on request.",
        },
        {
          q: "Do you also organise driver excursions for our guests?",
          a: "Yes, a popular service in Lucerne: day trips to Rigi and Pilatus, lake cruises with connecting rides or the tour to the Bernese Oberland – with driver, schedule and reservations completely organised by us.",
        },
      ],
    },
  },
  {
    slugDe: "privater-chauffeur-genf",
    slugEn: "private-chauffeur-geneva",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Privater Chauffeur Genf | Swiss PA Services",
      metaDesc: "Privater Chauffeur in Genf: Flughafentransfer GVA, Fahrten für internationale Gäste, Events und Geschäftstermine – vor Ort französisch koordiniert, EN/FR.",
      h1: "Privater Chauffeur in Genf",
      h1Accent: "Ihre Fahrten in Genf – persönlich organisiert",
      intro: [
        "Genf ist eine Stadt der Termine: UNO, CERN, internationale Konferenzen, Anlässe in Cologny und Vandoeuvres. Wer hier Gäste empfängt oder selbst zwischen Terminen pendelt, braucht Fahrten, die funktionieren – wir organisieren sie komplett, vor Ort auf Französisch koordiniert.",
        "Vom Flughafentransfer Genf (GVA) mit Flugüberwachung über Geschäftsfahrten und Roadshows bis zum diskreten Event-Transfer: Eine Nachricht genügt, wir organisieren Fahrer, Fahrzeuge, Timing und Routen – mit Ihnen auf Englisch oder Französisch.",
      ],
      bullets: [
        "Flughafentransfer Genf (GVA) mit Flugüberwachung",
        "Fahrten für Diplomaten & internationale Gäste",
        "Geschäftsfahrten & Roadshows in Genf",
        "Event- & Anlass-Transfers, auch mehrere Fahrzeuge",
        "Tagesfahrten: Genfersee, Lavaux, Alpen",
        "Vor Ort FR koordiniert – mit Ihnen EN oder FR",
      ],
      faq: [
        {
          q: "Ich spreche kein Französisch – wie läuft die Abstimmung?",
          a: "Vollständig über uns: Wir koordinieren Fahrer, Zeiten und Adressen vor Ort auf Französisch und halten Sie auf Englisch oder Französisch auf dem Laufenden. Sie bekommen Fahrer-Details, Kennzeichen und Kontakt vor jeder Fahrt.",
        },
        {
          q: "Können Sie mehrere Fahrzeuge für einen Anlass organisieren?",
          a: "Ja, für Hochzeiten, Konferenzen und private Anlässe organisieren wir ganze Fahrzeug-Konvois inklusive Zeitplan und Abstimmung mit der Location – von zwei Limousinen bis zum Shuttle-Betrieb für Ihre Gäste.",
        },
      ],
    },
    en: {
      metaTitle: "Private Chauffeur Geneva | Swiss PA Services",
      metaDesc: "Private chauffeur in Geneva: GVA airport transfers, rides for international guests, events & business appointments – coordinated in French, EN & FR.",
      h1: "Private chauffeur in Geneva",
      h1Accent: "Your rides in Geneva – personally organised",
      intro: [
        "Geneva is a city of appointments: the UN, CERN, international conferences, occasions in Cologny and Vandoeuvres. Whether you receive guests here or commute between meetings yourself, you need rides that work – we organise them completely, coordinated in French on site.",
        "From the Geneva airport (GVA) transfer with flight tracking to business rides and roadshows to the discreet event transfer: one message is enough, we organise drivers, vehicles, timing and routes – with you in German or English.",
      ],
      bullets: [
        "Geneva airport (GVA) transfers with flight tracking",
        "Rides for diplomats & international guests",
        "Business rides & roadshows in Geneva",
        "Event & occasion transfers, multiple vehicles too",
        "Day trips: Lake Geneva, Lavaux, the Alps",
        "Coordinated in FR on site – with you EN or FR",
      ],
      faq: [
        {
          q: "I don't speak French – how does coordination work?",
          a: "Completely through us: we coordinate drivers, times and addresses in French on site and keep you updated in German or English. You receive driver details, licence plate and contact before every ride.",
        },
        {
          q: "Can you organise several vehicles for an occasion?",
          a: "Yes, for weddings, conferences and private occasions we organise entire vehicle convoys including schedule and coordination with the venue – from two limousines to shuttle service for your guests.",
        },
      ],
    },
  },
  {
    slugDe: "privater-chauffeur-lugano",
    slugEn: "private-chauffeur-lugano",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Privater Chauffeur Lugano | Swiss PA Services",
      metaDesc: "Privater Chauffeur in Lugano: Flughafentransfers ab Mailand Malpensa & Lugano, Geschäftsfahrten und See-Ausflüge – persönlich organisiert, diskret.",
      h1: "Privater Chauffeur in Lugano",
      h1Accent: "Ihre Fahrten im Tessin – persönlich organisiert",
      intro: [
        "Nach Lugano fliegt man über Mailand: Der Transfer ab Malpensa über die Grenze ist für Gäste oft die erste Hürde. Wir organisieren ihn komplett – und alle weiteren Fahrten im Tessin: geprüfte Fahrer, passende Fahrzeuge, Timing und Grenzformalitäten inklusive.",
        "Ob Geschäftsfahrt nach Lugano, Gäste-Abholung zur Ferienresidenz oder der Ausflug ans Ufer von Morcote: Eine Nachricht genügt – wir organisieren den Rest, vor Ort auf Italienisch koordiniert, mit Ihnen auf Deutsch oder Englisch.",
      ],
      bullets: [
        "Flughafentransfer Lugano (LUG) & Mailand Malpensa (MXP)",
        "Grenzüberschreitende Fahrten Italien ↔ Tessin",
        "Geschäftsfahrten & Event-Transfers in Lugano",
        "See-Ausflüge & Gästefahrten mit Fahrer",
        "Tagesdisposition im Tessin",
        "Vor Ort IT koordiniert – mit Ihnen DE/EN",
      ],
      faq: [
        {
          q: "Transfer ab Mailand Malpensa – organisieren Sie das?",
          a: "Ja, das ist unsere meistgebuchte Fahrt für Lugano: Abholung mit Namensschild in Malpensa, Fahrt über die Grenze bis vor Ihre Tür – Flugüberwachung, Wartezeiten und alle Formalitäten inklusive. Auch umgekehrt für Ihre Abreise.",
        },
        {
          q: "Sprechen die Fahrer Englisch?",
          a: "Ja, wir organisieren Fahrer mit Englischkenntnissen – auf Wunsch auch deutsch- oder italienischsprachig. Die komplette Abstimmung läuft ohnehin über uns: Sie bekommen vor jeder Fahrt Fahrer-Details, Kennzeichen und Kontakt.",
        },
      ],
    },
    en: {
      metaTitle: "Private Chauffeur Lugano | Swiss PA Services",
      metaDesc: "Private chauffeur in Lugano: airport transfers from Milan Malpensa & Lugano, business rides and lake excursions – personally organised, discreet, DE/EN/IT.",
      h1: "Private chauffeur in Lugano",
      h1Accent: "Your rides in Ticino – personally organised",
      intro: [
        "Getting to Lugano usually means flying into Milan: the transfer from Malpensa across the border is often the first hurdle for guests. We organise it completely – and all further rides in Ticino: vetted drivers, suitable vehicles, timing and border formalities included.",
        "Whether a business ride to Lugano, guest pickup at your holiday residence or the excursion to the shores of Morcote: one message is enough – we organise the rest, coordinated in Italian on site, in German or English with you.",
      ],
      bullets: [
        "Airport transfers Lugano (LUG) & Milan Malpensa (MXP)",
        "Cross-border rides Italy ↔ Ticino",
        "Business rides & event transfers in Lugano",
        "Lake excursions & guest rides with driver",
        "Day hire in Ticino",
        "Coordinated in IT on site – with you DE/EN",
      ],
      faq: [
        {
          q: "Transfer from Milan Malpensa – do you organise that?",
          a: "Yes, it is our most-booked ride for Lugano: pickup with a name sign at Malpensa, the drive across the border to your door – flight tracking, waiting times and all formalities included. Also in reverse for your departure.",
        },
        {
          q: "Do the drivers speak English?",
          a: "Yes, we organise drivers with English skills – German or Italian speaking on request. All coordination runs through us anyway: before every ride you receive driver details, licence plate and contact.",
        },
      ],
    },
  },
  {
    slugDe: "privater-chauffeur-schweiz",
    slugEn: "private-chauffeur-switzerland",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Privater Chauffeur Schweiz | Swiss PA Services",
      metaDesc: "Privater Chauffeur in der Schweiz: Flughafentransfers, Geschäftsfahrten & Tagesfahrten in Zürich, Zug, Luzern, Genf & Lugano – persönlich organisiert.",
      h1: "Privater Chauffeur in der Schweiz",
      h1Accent: "Ein Ansprechpartner – von Zürich bis ins Tessin",
      intro: [
        "Ob Flughafen Zürich um 6 Uhr morgens, die Roadshow durch drei Städte oder der Transfer ins Chalet in den Alpen: Wir organisieren Ihre Fahrten in der ganzen Schweiz – mit geprüften Fahrern, passenden Fahrzeugen und einer festen Ansprechperson für alles.",
        "Aktiv sind wir vor allem in Zürich, Zug, Luzern, Genf und Lugano – inklusive der Flughäfen Zürich (ZRH), Genf (GVA) und Mailand Malpensa (MXP) für das Tessin. Auf Anfrage organisieren wir Fahrten schweizweit, auch in die Bergregionen Gstaad, St. Moritz, Verbier, Zermatt und Andermatt.",
      ],
      bullets: [
        "Flughafentransfers: ZRH, GVA & Malpensa (MXP)",
        "Privater Chauffeur in Zürich, Zug, Luzern, Genf & Lugano",
        "Geschäftsfahrten & Roadshows schweizweit",
        "Transfers in die Bergregionen der Alpen",
        "Tages-, Event- & Gäste-Disposition",
        "Eine Ansprechperson, Abrechnung über uns",
      ],
      faq: [
        {
          q: "In welchen Städten organisieren Sie Fahrten?",
          a: "Regelmässig in Zürich, Zug, Luzern, Genf und Lugano – inklusive der zugehörigen Flughäfen Zürich, Genf und Mailand Malpensa. Darüber hinaus organisieren wir auf Anfrage Fahrten in der ganzen Schweiz, etwa Transfers in die Bergregionen oder mehrtägige Dispositionen.",
        },
        {
          q: "Wie früh muss ich eine Fahrt anfragen?",
          a: "Standard-Transfers organisieren wir oft noch am selben Tag – für Anlässe, Roadshows oder mehrtägige Dispositionen empfehlen wir ein bis zwei Tage Vorlauf. Sie schreiben uns, wer wann wo hin muss – wir organisieren Fahrer, Fahrzeug und Timing.",
        },
      ],
    },
    en: {
      metaTitle: "Private Chauffeur Switzerland | Swiss PA Services",
      metaDesc: "Private chauffeur across Switzerland: airport transfers, business rides and day hire in Zurich, Zug, Lucerne, Geneva & Lugano – personally organised.",
      h1: "Private chauffeur in Switzerland",
      h1Accent: "One contact – from Zurich to Ticino",
      intro: [
        "Whether Zurich airport at 6 a.m., a roadshow through three cities or the transfer to a chalet in the Alps: we organise your rides across Switzerland – with vetted drivers, suitable vehicles and one dedicated contact for everything.",
        "We are mainly active in Zurich, Zug, Lucerne, Geneva and Lugano – including the airports Zurich (ZRH), Geneva (GVA) and Milan Malpensa (MXP) for Ticino. On request we organise rides Switzerland-wide, including to the Alpine regions of Gstaad, St. Moritz, Verbier, Zermatt and Andermatt.",
      ],
      bullets: [
        "Airport transfers: ZRH, GVA & Malpensa (MXP)",
        "Private chauffeur in Zurich, Zug, Lucerne, Geneva & Lugano",
        "Business rides & roadshows Switzerland-wide",
        "Transfers to the Alpine regions",
        "Day, event & guest hire",
        "One contact, billing through us",
      ],
      faq: [
        {
          q: "In which cities do you organise rides?",
          a: "Regularly in Zurich, Zug, Lucerne, Geneva and Lugano – including the associated airports Zurich, Geneva and Milan Malpensa. On request we organise rides across Switzerland, such as transfers to the Alpine regions or multi-day hire.",
        },
        {
          q: "How early do I need to request a ride?",
          a: "We often organise standard transfers the same day – for occasions, roadshows or multi-day hire we recommend one to two days' notice. You tell us who needs to be where and when – we organise driver, vehicle and timing.",
        },
      ],
    },
  },
  {
    slugDe: "persoenliche-assistentin-genf",
    slugEn: "personal-assistant-geneva",
    service: "persoenliche-assistenz",
    de: {
      metaTitle: "Persönliche Assistentin Genf gesucht? | Swiss PA Services",
      metaDesc: "Persönliche Assistentin in Genf gesucht? Diskrete Unterstützung für Führungskräfte & Familien: Termine, Reisen, Korrespondenz – auch im FR-Umfeld.",
      h1: "Persönliche Assistentin in Genf gesucht?",
      h1Accent: "International erfahren, diskret, ohne Festanstellung",
      intro: [
        "Genf ist die internationalste Stadt der Schweiz – und verlangt internationalen Lebensläufen einiges ab: Termine zwischen Quai du Mont-Blanc und Cologny, Reisen ab Genève Aéroport, Korrespondenz auf Französisch, Englisch und Deutsch. Genau hier setzt Ihre persönliche Assistentin von Swiss PA Services an.",
        "Sie erhalten keine Zeitarbeitskraft, sondern eine feste Ansprechsperson, die Ihre Gewohnheiten kennt: Sie kommunizieren mit uns auf Englisch oder Französisch – wir koordinieren Ihre Anliegen im französischsprachigen Umfeld. Vor Ort in Genf oder remote, stundenweise oder im monatlichen Mandat.",
      ],
      bullets: [
        "Termin- & Kalendermanagement auf Englisch & Französisch",
        "Reiseplanung ab Genève Aéroport (GVA) inkl. Flug- & Hotelbuchungen",
        "Korrespondenz & Erledigungen im französischsprachigen Umfeld",
        "Koordination von Haushalt, Hauspersonal & Dienstleistern",
        "Reservationen: Restaurants, Kultur & Arzttermine in Genf",
        "Absolute Diskretion – auf Wunsch mit NDA",
      ],
      faq: [
        {
          q: "Arbeiten Sie auch im französischsprachigen Genf?",
          a: "Ja. Mit Ihnen kommunizieren wir auf Englisch oder Französisch – nach aussen koordinieren wir Ihre Anliegen im französischsprachigen Umfeld: Behörden, Dienstleister, Hauspersonal oder Arztpraxen. Sie müssen selbst kein Französisch sprechen.",
        },
        {
          q: "Kommt die Assistentin nach Genf oder arbeitet sie remote?",
          a: "Beides ist möglich. Viele Aufgaben – Kalender, Reisen, Korrespondenz, Research – erledigen wir remote. Für Erledigungen vor Ort in Genf, Cologny, Vandœuvres oder entlang des Seeufers sind wir persönlich für Sie da.",
        },
      ],
    },
    en: {
      metaTitle: "Personal Assistant Geneva | Swiss PA Services",
      metaDesc: "Personal assistant in Geneva: discreet support for international executives & families – diary management, travel, correspondence, on site or remote.",
      h1: "Personal assistant in Geneva",
      h1Accent: "Internationally experienced, discreet, no employment",
      intro: [
        "Geneva is Switzerland's most international city – and demanding for international lifestyles: appointments between Quai du Mont-Blanc and Cologny, travel from Geneva Airport, correspondence in French, English and German. This is exactly where your personal assistant from Swiss PA Services steps in.",
        "You get not a temp worker, but a dedicated contact who knows your habits: you communicate with us in English or French – we coordinate your affairs in the French-speaking environment. On site in Geneva or remote, by the hour or as a monthly mandate.",
      ],
      bullets: [
        "Diary & calendar management in English & French",
        "Travel planning from Geneva Airport (GVA) incl. flights & hotels",
        "Correspondence & errands in the French-speaking environment",
        "Coordination of household, staff & service providers",
        "Reservations: restaurants, culture & medical appointments in Geneva",
        "Absolute discretion – NDA on request",
      ],
      faq: [
        {
          q: "Do you also work in French-speaking Geneva?",
          a: "Yes. We communicate with you in English or French – externally we coordinate your affairs in the French-speaking environment: authorities, service providers, household staff or medical practices. You do not need to speak any French yourself.",
        },
        {
          q: "Does the assistant come to Geneva or work remotely?",
          a: "Both are possible. Many tasks – calendar, travel, correspondence, research – are handled remotely. For errands on site in Geneva, Cologny, Vandœuvres or along the lakeshore, we are personally at your service.",
        },
      ],
    },
  },
  {
    slugDe: "persoenliche-assistentin-luzern",
    slugEn: "personal-assistant-lucerne",
    service: "persoenliche-assistenz",
    de: {
      metaTitle: "Persönliche Assistentin Luzern gesucht? | Swiss PA Services",
      metaDesc: "Persönliche Assistentin in Luzern gesucht? Entlastung für Unternehmer & Familien in der Zentralschweiz: Termine, Reisen, Haushalt – diskret, flexibel.",
      h1: "Persönliche Assistentin in Luzern gesucht?",
      h1Accent: "Ihre rechte Hand in der Zentralschweiz",
      intro: [
        "Zwischen KKL, Altstadt und Vierwaldstättersee füllt sich der Kalender schnell: Geschäftstermine, Familienlogistik, kulturelle Anlässe, Handwerkertermine. Ihre persönliche Assistentin in Luzern nimmt Ihnen genau das ab – damit Ihr Alltag läuft, auch wenn Sie gerade keine Zeit haben.",
        "Von unserem Sitz in Zug aus sind wir in 25 Minuten in Luzern: nah genug für kurzfristige Erledigungen vor Ort, erfahren genug für diskrete Mandate. Eine feste Ansprechsperson, auf Deutsch und Englisch – ohne Festanstellung, ohne Lohnnebenkosten.",
      ],
      bullets: [
        "Termin- & Kalendermanagement für Beruf & Familie",
        "Reiseplanung mit Flug-, Hotel- & Zugbuchungen",
        "Persönliche Erledigungen von der Altstadt bis Meggen",
        "Koordination von Haushalt, Handwerkern & Dienstleistern",
        "Reservationen: KKL, Restaurants, Events & Arzttermine",
        "Eine feste Ansprechsperson – diskret, auf Wunsch mit NDA",
      ],
      faq: [
        {
          q: "Sind Sie auch kurzfristig in Luzern vor Ort?",
          a: "Ja. Von Zug aus erreichen wir Luzern in rund 25 Minuten – kurzfristige Termine, Abholungen oder die Koordination von Handwerkern vor Ort gehören zu unserem Alltag. Planbare Aufgaben erledigen wir remote, damit Sie Stunden sparen.",
        },
        {
          q: "Was unterscheidet Sie von einer Zeitarbeitsfirma?",
          a: "Sie erhalten keine wechselnden Einsatzkräfte, sondern eine feste Ansprechsperson, die Ihre Prioritäten, Vorlieben und Abläufe kennt. Abgerechnet wird flexibel nach Stunden oder im monatlichen Mandat – ohne Anstellung Ihrerseits.",
        },
      ],
    },
    en: {
      metaTitle: "Personal Assistant Lucerne | Swiss PA Services",
      metaDesc: "Personal assistant in Lucerne: support for entrepreneurs & families in Central Switzerland – diary, travel, household coordination. Discreet, flexible.",
      h1: "Personal assistant in Lucerne",
      h1Accent: "Your right hand in Central Switzerland",
      intro: [
        "Between the KKL, the old town and Lake Lucerne, calendars fill up fast: business appointments, family logistics, cultural events, tradespeople visits. Your personal assistant in Lucerne takes exactly that off your plate – so your life runs smoothly even when you have no time.",
        "From our base in Zug we are in Lucerne in 25 minutes: close enough for last-minute errands on site, experienced enough for discreet mandates. One dedicated contact, in German and English – no employment, no payroll costs.",
      ],
      bullets: [
        "Diary & calendar management for business & family",
        "Travel planning incl. flight, hotel & rail bookings",
        "Personal errands from the old town to Meggen",
        "Coordination of household, tradespeople & providers",
        "Reservations: KKL, restaurants, events & medical appointments",
        "One dedicated contact – discreet, NDA on request",
      ],
      faq: [
        {
          q: "Can you be on site in Lucerne at short notice?",
          a: "Yes. From Zug we reach Lucerne in about 25 minutes – last-minute appointments, pickups or coordinating tradespeople on site are part of our daily work. Plannable tasks are handled remotely to save you hours.",
        },
        {
          q: "How do you differ from a temp agency?",
          a: "You do not get rotating staff, but one dedicated contact who knows your priorities, preferences and routines. Billing is flexible by the hour or as a monthly mandate – without employing anyone yourself.",
        },
      ],
    },
  },
  {
    slugDe: "familienassistenz-zug",
    slugEn: "family-assistant-zug",
    service: "persoenliche-assistenz",
    de: {
      metaTitle: "Familienassistenz Zug | Swiss PA Services",
      metaDesc: "Familienassistenz in Zug: Entlastung für berufstätige Eltern & Expat-Familien – Schullogistik, Termine, Haushalt, Erledigungen. Diskret & zuverlässig.",
      h1: "Familienassistenz in Zug",
      h1Accent: "Mehr Zeit für Ihre Familie",
      intro: [
        "Zug ist eine Familienstadt mit hohem Tempo: beide Elternteile berufstätig, internationale Schule, Vereine, Arzttermine – und oft fehlt das Grosseltern-Netzwerk um die Ecke. Unsere Familienassistenz in Zug fängt genau diese Lücke ab: organisiert, verlässlich und diskret.",
        "Von der Baarerstrasse 43 aus sind wir mitten in Zug: Wir koordinieren Schullogistik und Fahrdienste, planen Arzt- und Elterntermine, organisieren Haushalt und Ferien – auf Deutsch oder Englisch, auch für Familien, die gerade erst in die Schweiz gezogen sind.",
      ],
      bullets: [
        "Schullogistik & Fahrdienste organisieren (u. a. ISZL, Montana)",
        "Arzt-, Zahnarzt- & Elterntermine planen und koordinieren",
        "Haushalts-Organisation: Reinigung, Handwerker, Lieferungen",
        "Ferien- & Kinderbetreuungs-Organisation",
        "Erledigungen, Reservationen & Geschenke-Beschaffung",
        "Diskrete, feste Ansprechperson für die ganze Familie",
      ],
      faq: [
        {
          q: "Unterstützen Sie auch Expat-Familien auf Englisch?",
          a: "Ja, selbstverständlich. Viele unserer Familien in Zug sind international – wir kommunizieren mit Ihnen auf Deutsch oder Englisch und übernehmen auf Wunsch auch den Kontakt mit Behörden, Schulen und Dienstleistern.",
        },
        {
          q: "Übernehmen Sie auch die Kinderbetreuung selbst?",
          a: "Unsere Stärke ist die Organisation: Wir finden und koordinieren passende Betreuungslösungen, planen Fahrdienste und Termine rund um Schule und Freizeit. So bleibt alles in einer Hand – und Sie behalten den Überblick.",
        },
      ],
    },
    en: {
      metaTitle: "Family Assistant Zug | Swiss PA Services",
      metaDesc: "Family assistant in Zug: relief for working parents & expat families – school logistics, appointments, household, errands. Discreet & reliable.",
      h1: "Family assistant in Zug",
      h1Accent: "More time for your family",
      intro: [
        "Zug is a family city at high speed: both parents working, international school, clubs, doctor's appointments – and often the grandparent network around the corner is missing. Our family assistant in Zug closes exactly that gap: organised, reliable and discreet.",
        "From Baarerstrasse 43 we are right in the heart of Zug: we coordinate school logistics and rides, schedule doctor and parent appointments, organise household and holidays – in German or English, also for families who have just moved to Switzerland.",
      ],
      bullets: [
        "Organising school logistics & rides (incl. ISZL, Montana)",
        "Scheduling doctor, dentist & parent appointments",
        "Household organisation: cleaning, tradespeople, deliveries",
        "Holiday & childcare organisation",
        "Errands, reservations & gift sourcing",
        "Discreet, dedicated contact for the whole family",
      ],
      faq: [
        {
          q: "Do you also support expat families in English?",
          a: "Yes, of course. Many of our families in Zug are international – we communicate in German or English and also handle contact with authorities, schools and service providers if Swiss German is (still) unfamiliar to you.",
        },
        {
          q: "Do you provide the childcare yourselves?",
          a: "Our strength is organisation: we find and coordinate suitable childcare solutions, schedule rides and appointments around school and leisure. This keeps everything in one hand – and you stay in control.",
        },
      ],
    },
  },
  {
    slugDe: "executive-assistant-genf",
    slugEn: "executive-assistant-geneva",
    service: "persoenliche-assistenz",
    de: {
      metaTitle: "Executive Assistant Genf gesucht? | Swiss PA Services",
      metaDesc: "Executive Assistant in Genf gesucht? C-Level-Entlastung ohne Festanstellung: Kalender, Reisen, Board-Logistik, Korrespondenz. Diskret & startklar.",
      h1: "Executive Assistant in Genf gesucht?",
      h1Accent: "C-Level-Support ohne Festanstellung",
      intro: [
        "Genf ist eine Stadt der Entscheider: internationale Organisationen, Banken, Uhrenhäuser, Family Offices. Zwischen Board-Meetings, Roadshows und Terminen am Genfersee bleibt wenig Luft. Ihr externer Executive Assistant hält Ihnen den Rücken frei – mit der Präzision einer Inhouse-Kraft, ohne Festanstellung.",
        "Wir übernehmen komplexes Kalender- und Reisemanagement über Zeitzonen hinweg, die Logistik für Boards und Roadshows ab Genève Aéroport sowie vertrauliche Korrespondenz. Mehrsprachig, diskret und innert Tagen einsatzbereit – auch interimistisch bei Vakanzen.",
      ],
      bullets: [
        "Komplexes Kalender- & Reisemanagement über Zeitzonen",
        "Board-, Meeting- & Roadshow-Logistik ab GVA",
        "Vertrauliche Korrespondenz auf Englisch & Französisch",
        "Vorbereitung von Unterlagen, Präsentationen & Reports",
        "Expense-Management & administrative Prozesse",
        "Interim-Vertretung bei Vakanz oder Elternzeit",
      ],
      faq: [
        {
          q: "Eignet sich das auch als Interim-Lösung?",
          a: "Ja. Gerade bei Vakanzen, Elternzeit oder Reorganisationen springen wir innert Tagen ein: Wir übernehmen Kalender, Reisen und Korrespondenz nahtlos – ohne Rekrutierungsprozess, ohne Kündigungsfristen.",
        },
        {
          q: "Wie stellen Sie Vertraulichkeit auf C-Level sicher?",
          a: "Diskretion ist unser Kerngeschäft: eine feste Ansprechsperson, klar definierte Zugriffe, keine Weitergabe von Daten. Auf Wunsch arbeiten wir von Anfang an mit einer Verschwiegenheitserklärung (NDA).",
        },
      ],
    },
    en: {
      metaTitle: "Find an Executive Assistant in Geneva | Swiss PA",
      metaDesc: "Looking for an executive assistant in Geneva? C-level relief without employment: diary, travel, board logistics, correspondence. Discreet.",
      h1: "Looking for an executive assistant in Geneva?",
      h1Accent: "C-level support without employment",
      intro: [
        "Geneva is a city of decision-makers: international organisations, banks, watch houses, family offices. Between board meetings, roadshows and appointments along the lakeshore, there is little room to breathe. Your external executive assistant keeps your back free – with the precision of an in-house hire, without employment.",
        "We handle complex diary and travel management across time zones, logistics for boards and roadshows from Geneva Airport, and confidential correspondence. Multilingual, discreet and ready within days – also as interim cover during vacancies.",
      ],
      bullets: [
        "Complex diary & travel management across time zones",
        "Board, meeting & roadshow logistics from GVA",
        "Confidential correspondence in English & French",
        "Preparation of documents, presentations & reports",
        "Expense management & administrative processes",
        "Interim cover during vacancy or parental leave",
      ],
      faq: [
        {
          q: "Does this also work as an interim solution?",
          a: "Yes. Especially during vacancies, parental leave or reorganisations we step in within days: we take over diary, travel and correspondence seamlessly – no recruiting process, no notice periods.",
        },
        {
          q: "How do you ensure confidentiality at C-level?",
          a: "Discretion is our core business: one dedicated contact, clearly defined access, no sharing of data. On request we work under a non-disclosure agreement (NDA) from day one.",
        },
      ],
    },
  },
  {
    slugDe: "lifestyle-management-zuerich",
    slugEn: "lifestyle-management-zurich",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Lifestyle Management Zürich | Swiss PA Services",
      metaDesc: "Lifestyle Management in Zürich: Ihr Alltag, vollständig orchestriert – Reservationen, Reisen, Events, Haushalt & Erledigungen aus einer Hand.",
      h1: "Lifestyle Management in Zürich",
      h1Accent: "Ihr Alltag, vollständig orchestriert",
      intro: [
        "Zürich lebt schnell: gefragte Restaurants, ausverkaufte Events, Termine zwischen Paradeplatz und Zürichberg. Lifestyle Management bedeutet bei uns nicht einzelne Concierge-Aufträge, sondern die laufende Orchestrierung Ihres Alltags – mit einer festen Ansprechsperson, die weiss, wie Sie leben.",
        "Wir planen Ihre Woche, bevor sie beginnt: Tische im Kronenhallen-Quartier oder an der Bahnhofstrasse, Tickets für Opernhaus und Kunsthaus, die Reise am Wochenende, der Handwerker am Dienstag. Eine Nachricht genügt – der Rest läuft.",
      ],
      bullets: [
        "Laufende Wochen- & Monatsplanung mit fester Ansprechperson",
        "Restaurant-, Event- & Kultur-Reservationen in ganz Zürich",
        "Reiseplanung: Wochenend-Fluchten bis Weltreisen",
        "Haushalts- & Dienstleister-Koordination",
        "Geschenke, Besorgungen & persönliche Erledigungen",
        "Diskretes Mandat – monatlich oder auf Abruf",
      ],
      faq: [
        {
          q: "Was ist der Unterschied zwischen Lifestyle Management und einem Concierge Service?",
          a: "Der Concierge erledigt einzelne Wünsche auf Anfrage. Lifestyle Management ist die laufende Betreuung Ihres Alltags: Wir planen voraus, kennen Ihre Vorlieben und halten Ihnen den Alltag frei – ohne dass Sie jede Woche neu briefen müssen.",
        },
        {
          q: "Was kostet Lifestyle Management in Zürich?",
          a: "Die meisten Kunden wählen ein monatliches Mandat, das Betreuung, Planung und Erledigungen abdeckt – der Umfang richtet sich nach Ihrem Lebensstil. Nach einem unverbindlichen Erstgespräch erhalten Sie eine transparente Offerte.",
        },
      ],
    },
    en: {
      metaTitle: "Lifestyle Management Zurich | Swiss PA Services",
      metaDesc: "Lifestyle management in Zurich: your daily life, fully orchestrated – reservations, travel, events, household & errands from one source.",
      h1: "Lifestyle management in Zurich",
      h1Accent: "Your daily life, fully orchestrated",
      intro: [
        "Zurich lives fast: in-demand restaurants, sold-out events, appointments between Paradeplatz and Zürichberg. For us, lifestyle management does not mean individual concierge jobs, but the ongoing orchestration of your everyday life – with a dedicated contact who knows how you live.",
        "We plan your week before it begins: tables near Kronenhalle or on Bahnhofstrasse, tickets for the opera house and Kunsthaus, the weekend getaway, the tradesperson on Tuesday. One message is enough – the rest runs itself.",
      ],
      bullets: [
        "Ongoing weekly & monthly planning with a dedicated contact",
        "Restaurant, event & culture reservations across Zurich",
        "Travel planning: weekend escapes to world trips",
        "Household & service provider coordination",
        "Gifts, shopping & personal errands",
        "Discreet mandate – monthly or on demand",
      ],
      faq: [
        {
          q: "What is the difference between lifestyle management and a concierge service?",
          a: "A concierge handles individual requests on demand. Lifestyle management is the ongoing care of your everyday life: we plan ahead, know your preferences and keep your schedule free – without you having to brief us every week.",
        },
        {
          q: "What does lifestyle management in Zurich cost?",
          a: "Most clients choose a monthly mandate covering care, planning and errands – the scope depends on your lifestyle. After a non-binding first conversation you receive a transparent proposal.",
        },
      ],
    },
  },
  {
    slugDe: "lifestyle-management-genf",
    slugEn: "lifestyle-management-geneva",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Lifestyle Management Genf | Swiss PA Services",
      metaDesc: "Lifestyle Management in Genf: Laufende Betreuung für internationale Residents – Reservationen, Reisen ab GVA, Events & Alltag aus einer Hand, EN & FR.",
      h1: "Lifestyle Management in Genf",
      h1Accent: "La dolce vita, perfekt organisiert",
      intro: [
        "Genf verbindet internationale Diplomatie mit savoir-vivre: Uhrensalons und Watches-and-Wonders, Dinner am Quai, Wochenenden am Lac Léman oder in Megève. Unser Lifestyle Management in Genf hält all diese Fäden zusammen – mit einer festen Ansprechsperson, die Ihre Welt kennt.",
        "Wir kommunizieren mit Ihnen auf Englisch oder Französisch und organisieren im französischsprachigen Umfeld: vom Tisch im gefragtesten Restaurant der Stadt über die Reise ab Genève Aéroport bis zum privaten Event am See. Diskret, verlässlich, aus einer Hand.",
      ],
      bullets: [
        "Laufende Lebensplanung mit fester Ansprechperson",
        "Reservationen: Restaurants, Uhrensalons & Kultur in Genf",
        "Reiseplanung ab GVA – von Megève bis Mailand",
        "Private Events & Anlässe am Lac Léman",
        "Koordination von Haushalt & Dienstleistern (FR-Umfeld)",
        "Diskretes Mandat – monatlich oder auf Abruf",
      ],
      faq: [
        {
          q: "Funktioniert das im französischsprachigen Genf?",
          a: "Vollständig. Sie sprechen mit uns Englisch oder Französisch – wir organisieren nach aussen auf Französisch: Restaurants, Dienstleister, Behörden, Hauspersonal. Sie geniessen Genf, ohne sich um Sprachbarrieren zu kümmern.",
        },
        {
          q: "Was kostet Lifestyle Management in Genf?",
          a: "Typisch ist ein monatliches Mandat, abgestimmt auf Ihren Lebensstil – von der Wochenplanung bis zu Reisen und Events. Nach einem unverbindlichen Erstgespräch erhalten Sie eine transparente Offerte.",
        },
      ],
    },
    en: {
      metaTitle: "Lifestyle Management Geneva | Swiss PA Services",
      metaDesc: "Lifestyle management in Geneva: ongoing care for international residents – reservations, travel from GVA, events & daily life from one source, EN & FR.",
      h1: "Lifestyle management in Geneva",
      h1Accent: "La dolce vita, perfectly organised",
      intro: [
        "Geneva combines international diplomacy with savoir-vivre: watch salons and Watches and Wonders, dinners on the quay, weekends on Lac Léman or in Megève. Our lifestyle management in Geneva holds all these threads together – with a dedicated contact who knows your world.",
        "We communicate with you in English or French and organise in the French-speaking environment: from the table at the city's most sought-after restaurant to travel from Geneva Airport to the private event by the lake. Discreet, reliable, from one source.",
      ],
      bullets: [
        "Ongoing life planning with a dedicated contact",
        "Reservations: restaurants, watch salons & culture in Geneva",
        "Travel planning from GVA – from Megève to Milan",
        "Private events & occasions on Lac Léman",
        "Coordination of household & providers (French-speaking)",
        "Discreet mandate – monthly or on demand",
      ],
      faq: [
        {
          q: "Does this work in French-speaking Geneva?",
          a: "Completely. You speak with us in English or French – we organise externally in French: restaurants, service providers, authorities, household staff. You enjoy Geneva without worrying about language barriers.",
        },
        {
          q: "What does lifestyle management in Geneva cost?",
          a: "Typically a monthly mandate tailored to your lifestyle – from weekly planning to travel and events. After a non-binding first conversation you receive a transparent proposal.",
        },
      ],
    },
  },
  {
    slugDe: "lifestyle-management-luzern",
    slugEn: "lifestyle-management-lucerne",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Lifestyle Management Luzern | Swiss PA Services",
      metaDesc: "Lifestyle Management in Luzern: Ihr Alltag zwischen KKL, See & Bergen – laufend organisiert. Reservationen, Reisen, Events & Erledigungen.",
      h1: "Lifestyle Management in Luzern",
      h1Accent: "Leben am See, ohne Organisationsaufwand",
      intro: [
        "Luzern verbindet Kultur und Natur wie kaum eine Stadt: Lucerne Festival im KKL, Sommerabende am Vierwaldstättersee, Wochenenden auf Rigi oder Pilatus. Damit daraus Genuss wird und nicht Organisation, gibt es unser Lifestyle Management in Luzern.",
        "Von Zug aus sind wir in 25 Minuten bei Ihnen: Wir planen Ihren Kalender, reservieren Tische und Tickets, organisieren Ausflüge auf See und Berg und halten Ihren Haushalt im Laufen. Eine feste Ansprechsperson, die Luzern kennt – von der Altstadt bis Kastanienbaum.",
      ],
      bullets: [
        "Laufende Wochen- & Saisonplanung mit fester Ansprechperson",
        "Tickets & Reservationen: KKL, Lucerne Festival, Restaurants",
        "Ausflüge & Erlebnisse auf See und Berg organisiert",
        "Reiseplanung ab Luzern – inkl. Transfers nach ZRH",
        "Haushalts- & Dienstleister-Koordination",
        "Diskretes Mandat – monatlich oder auf Abruf",
      ],
      faq: [
        {
          q: "Was genau übernehmen Sie im Lifestyle Management?",
          a: "Alles, was Ihren Alltag organisatorisch belastet: Planung, Reservationen, Reisen, Erledigungen, Koordination von Dienstleistern. Sie äussern den Wunsch – wir kümmern uns um Termine, Buchungen und Details, bis alles steht.",
        },
        {
          q: "Sind Sie in Luzern auch vor Ort verfügbar?",
          a: "Ja. Von unserem Sitz in Zug erreichen wir Luzern in rund 25 Minuten. Persönliche Erledigungen, die Koordination von Terminen vor Ort oder die Vorbereitung Ihrer Wohnung vor Ihrer Rückkehr gehören zu unserem Alltag.",
        },
      ],
    },
    en: {
      metaTitle: "Lifestyle Management Lucerne | Swiss PA Services",
      metaDesc: "Lifestyle management in Lucerne: your life between KKL, lake & mountains – continuously organised. Reservations, travel, events & errands.",
      h1: "Lifestyle management in Lucerne",
      h1Accent: "Lakeside living, without the organising",
      intro: [
        "Lucerne combines culture and nature like few cities: Lucerne Festival at the KKL, summer evenings on Lake Lucerne, weekends on Rigi or Pilatus. To make this a pleasure rather than an organisational effort, there is our lifestyle management in Lucerne.",
        "From Zug we are with you in 25 minutes: we plan your calendar, reserve tables and tickets, organise excursions on lake and mountain and keep your household running. One dedicated contact who knows Lucerne – from the old town to Kastanienbaum.",
      ],
      bullets: [
        "Ongoing weekly & seasonal planning with a dedicated contact",
        "Tickets & reservations: KKL, Lucerne Festival, restaurants",
        "Excursions & experiences on lake and mountain, organised",
        "Travel planning from Lucerne – incl. transfers to ZRH",
        "Household & service provider coordination",
        "Discreet mandate – monthly or on demand",
      ],
      faq: [
        {
          q: "What exactly do you take over in lifestyle management?",
          a: "Everything that organisationally burdens your daily life: planning, reservations, travel, errands, coordination of service providers. You express the wish – we take care of appointments, bookings and details until everything is set.",
        },
        {
          q: "Are you also available on site in Lucerne?",
          a: "Yes. From our base in Zug we reach Lucerne in about 25 minutes. Personal errands, coordinating appointments on site or preparing your home before your return are part of our daily work.",
        },
      ],
    },
  },
  {
    slugDe: "lifestyle-management-lugano",
    slugEn: "lifestyle-management-lugano",
    service: "lifestyle-concierge-schweiz",
    de: {
      metaTitle: "Lifestyle Management Lugano | Swiss PA Services",
      metaDesc: "Lifestyle Management in Lugano: Dolce Vita im Tessin, perfekt organisiert – Reservationen, Reisen ab Lugano/Malpensa, Events & Alltag.",
      h1: "Lifestyle Management in Lugano",
      h1Accent: "Dolce Vita, perfekt orchestriert",
      intro: [
        "Lugano lebt italienisch und tickt schweizerisch: Aperitivo an der Piazza della Riforma, Bootstage auf dem Lago di Lugano, Shopping in Mailand, An- und Abreisen über Agno oder Malpensa. Unser Lifestyle Management in Lugano orchestriert genau dieses Leben.",
        "Mit einer festen Ansprechsperson planen wir Ihren Alltag und Ihre Highlights: vom Tisch mit Seeblick über die private Bootsfahrt bis zur Reiseplanung ab Mailand Malpensa. Auf Deutsch, Englisch oder für Ihre Erledigungen im Tessin – diskret und aus einer Hand.",
      ],
      bullets: [
        "Laufende Lebensplanung mit fester Ansprechperson",
        "Reservationen: Ristoranti, Lidos & Kultur in Lugano",
        "Boots- & See-Erlebnisse auf dem Lago di Lugano",
        "Reiseplanung ab Lugano-Agno & Mailand Malpensa (MXP)",
        "Koordination von Haushalt, Zweitwohnsitz & Dienstleistern",
        "Diskretes Mandat – monatlich oder auf Abruf",
      ],
      faq: [
        {
          q: "Betreuen Sie auch Kunden mit Zweitwohnsitz in Lugano?",
          a: "Ja, das ist ein Schwerpunkt: Wir bereiten Ihre Residenz vor Ihrer Ankunft vor, koordinieren Haushalt und Dienstleister während Ihrer Abwesenheit und stellen sicher, dass Ihr Aufenthalt vom ersten Tag an Erholung ist.",
        },
        {
          q: "Was kostet Lifestyle Management in Lugano?",
          a: "Meist als monatliches Mandat, abgestimmt auf Ihren Rhythmus im Tessin – von der Saisonbetreuung bis zur ganzjährigen Unterstützung. Nach einem unverbindlichen Gespräch erhalten Sie eine transparente Offerte.",
        },
      ],
    },
    en: {
      metaTitle: "Lifestyle Management Lugano | Swiss PA Services",
      metaDesc: "Lifestyle management in Lugano: dolce vita in Ticino, perfectly organised – reservations, travel via Lugano/Malpensa, events & daily life.",
      h1: "Lifestyle management in Lugano",
      h1Accent: "Dolce vita, perfectly orchestrated",
      intro: [
        "Lugano lives Italian and ticks Swiss: aperitivo on Piazza della Riforma, boat days on Lake Lugano, shopping in Milan, arrivals and departures via Agno or Malpensa. Our lifestyle management in Lugano orchestrates exactly this life.",
        "With a dedicated contact we plan your daily life and your highlights: from the table with a lake view to the private boat trip to travel planning from Milan Malpensa. In English or German – discreet and from one source.",
      ],
      bullets: [
        "Ongoing life planning with a dedicated contact",
        "Reservations: ristoranti, lidos & culture in Lugano",
        "Boat & lake experiences on Lake Lugano",
        "Travel planning from Lugano-Agno & Milan Malpensa (MXP)",
        "Coordination of household, second home & providers",
        "Discreet mandate – monthly or on demand",
      ],
      faq: [
        {
          q: "Do you also look after clients with a second home in Lugano?",
          a: "Yes, that is a focus: we prepare your residence before your arrival, coordinate household and service providers during your absence and make sure your stay is relaxation from day one.",
        },
        {
          q: "What does lifestyle management in Lugano cost?",
          a: "Usually as a monthly mandate, tailored to your rhythm in Ticino – from seasonal care to year-round support. After a non-binding conversation you receive a transparent proposal.",
        },
      ],
    },
  },
  {
    slugDe: "home-watch-zuerich",
    slugEn: "home-watch-zurich",
    service: "home-property-management",
    de: {
      metaTitle: "Home Watch Zürich | Swiss PA Services",
      metaDesc: "Home Watch in Zürich: Regelmässige Kontrollgänge für Ihre Wohnung oder Ihr Haus während Ihrer Abwesenheit – mit Foto-Protokoll & Sofort-Meldung.",
      h1: "Home Watch in Zürich",
      h1Accent: "Ihr Zuhause, bewacht wie unser eigenes",
      intro: [
        "Sie reisen wochenlang, leben zwischen zwei Wohnsitzen oder halten in Zürich ein Pied-à-terre? Dann wissen Sie: Eine leerstehende Wohnung braucht Aufmerksamkeit – Briefkasten, Heizung, Wasseranschlüsse, Blumen, Sicherheit. Unser Home-Watch-Service in Zürich übernimmt genau das.",
        "In regelmässigen Kontrollgängen prüfen wir Ihre Wohnung oder Ihr Haus in der Stadt Zürich – vom Seefeld über Enge bis Oerlikon. Nach jedem Gang erhalten Sie ein Foto-Protokoll; bei Auffälligkeiten melden wir uns sofort und organisieren auf Wunsch direkt die Behebung.",
      ],
      bullets: [
        "Regelmässige Kontrollgänge nach Ihrem Rhythmus",
        "Prüfung von Heizung, Wasser, Strom & Fenstern",
        "Briefkasten-Leerung, Post-Weiterleitung nach Absprache",
        "Pflanzen- & Lüftungs-Service, Kühlschrank-Check",
        "Foto-Protokoll nach jedem Kontrollgang",
        "Sofort-Meldung & Schaden-Koordination bei Auffälligkeiten",
      ],
      faq: [
        {
          q: "Was prüfen Sie bei einem Home-Watch-Kontrollgang?",
          a: "Wir gehen eine feste Checkliste durch: Fenster und Türen, Heizung und Wasseranschlüsse, Geräte, Feuchtigkeit, Pflanzen, Post. Dazu hören und sehen wir, was nicht in Checklisten passt – und dokumentieren alles mit Fotos für Sie.",
        },
        {
          q: "Wie oft empfehlen Sie Kontrollgänge?",
          a: "Das hängt von Objekt und Versicherung ab – manche Police verlangt wöchentliche Kontrollen bei leerstehenden Objekten. Üblich sind wöchentliche oder vierzehntägige Gänge; wir stimmen den Rhythmus auf Ihre Abwesenheit ab.",
        },
      ],
    },
    en: {
      metaTitle: "Home Watch Zurich | Swiss PA Services",
      metaDesc: "Home watch in Zurich: regular inspection visits for your apartment or house while you are away – with photo report & immediate alerts.",
      h1: "Home watch in Zurich",
      h1Accent: "Your home, watched like our own",
      intro: [
        "Travelling for weeks, living between two residences or keeping a pied-à-terre in Zurich? Then you know: an empty home needs attention – mailbox, heating, water connections, plants, security. Our home watch service in Zurich takes care of exactly that.",
        "In regular inspection visits we check your apartment or house in the city of Zurich – from Seefeld and Enge to Oerlikon. After every visit you receive a photo report; if we spot anything unusual, we alert you immediately and organise the fix on request.",
      ],
      bullets: [
        "Regular inspection visits at your rhythm",
        "Checking heating, water, electricity & windows",
        "Mailbox emptying, mail forwarding as agreed",
        "Plant & airing service, fridge check",
        "Photo report after every visit",
        "Immediate alerts & damage coordination if needed",
      ],
      faq: [
        {
          q: "What do you check during a home watch visit?",
          a: "We work through a fixed checklist: windows and doors, heating and water connections, appliances, humidity, plants, mail. On top of that we notice what does not fit into checklists – and document everything with photos for you.",
        },
        {
          q: "How often do you recommend inspection visits?",
          a: "That depends on the property and your insurance – some policies require weekly checks for unoccupied homes. Weekly or fortnightly visits are common; we align the rhythm with your absence.",
        },
      ],
    },
  },
  {
    slugDe: "home-watch-luzern",
    slugEn: "home-watch-lucerne",
    service: "home-property-management",
    de: {
      metaTitle: "Home Watch Luzern | Swiss PA Services",
      metaDesc: "Home Watch in Luzern & Zentralschweiz: Kontrollgänge für Wohnung, Haus & Zweitwohnsitz während Ihrer Abwesenheit – mit Foto-Protokoll.",
      h1: "Home Watch in Luzern",
      h1Accent: "Sorglos abwesend in der Zentralschweiz",
      intro: [
        "Ob Altstadt-Wohnung in Luzern, Haus am Hang in Kriens oder Zweitwohnsitz Richtung Vierwaldstättersee: Wer länger abwesend ist, braucht jemanden vor Ort, der regelmässig nach dem Rechten sieht. Unser Home-Watch-Service in Luzern ist genau diese ruhige, verlässliche Präsenz.",
        "Von Zug aus sind wir schnell in der ganzen Zentralschweiz: Wir kontrollieren Ihre Liegenschaft nach festem Rhythmus, dokumentieren jeden Gang mit Fotos und kümmern uns auf Wunsch direkt um alles, was Aufmerksamkeit braucht – vom Handwerker bis zur Heizung.",
      ],
      bullets: [
        "Kontrollgänge in Luzern & der ganzen Zentralschweiz",
        "Checkliste: Fenster, Türen, Heizung, Wasser, Strom",
        "Briefkasten, Post & Lieferungen im Griff",
        "Pflanzen-Service & Lüftung während Ihrer Abwesenheit",
        "Foto-Protokoll nach jedem Besuch",
        "Direkte Koordination von Handwerkern bei Bedarf",
      ],
      faq: [
        {
          q: "Welche Regionen um Luzern decken Sie ab?",
          a: "Neben der Stadt Luzern betreuen wir Objekte in der ganzen Zentralschweiz – etwa Kriens, Emmen, Horw, Meggen oder entlang des Vierwaldstättersees. Von Zug aus sind wir überall schnell vor Ort.",
        },
        {
          q: "Was passiert, wenn Sie einen Schaden entdecken?",
          a: "Sie erhalten sofort eine Meldung mit Fotos und unserer Einschätzung. Auf Ihre Freigabe hin organisieren wir Handwerker, begleiten die Reparatur und dokumentieren die Behebung – Sie bleiben informiert, ohne selbst handeln zu müssen.",
        },
      ],
    },
    en: {
      metaTitle: "Home Watch Lucerne | Swiss PA Services",
      metaDesc: "Home watch in Lucerne & Central Switzerland: inspection visits for apartment, house & second home while you are away – with photo report.",
      h1: "Home watch in Lucerne",
      h1Accent: "Carefree absence in Central Switzerland",
      intro: [
        "Whether an old town apartment in Lucerne, a hillside house in Kriens or a second home towards Lake Lucerne: anyone away for longer needs someone on site who regularly checks on things. Our home watch service in Lucerne is exactly that calm, reliable presence.",
        "From Zug we are quickly anywhere in Central Switzerland: we inspect your property on a fixed rhythm, document every visit with photos and take care of whatever needs attention on request – from tradespeople to the heating.",
      ],
      bullets: [
        "Inspection visits in Lucerne & across Central Switzerland",
        "Checklist: windows, doors, heating, water, electricity",
        "Mailbox, mail & deliveries under control",
        "Plant care & airing during your absence",
        "Photo report after every visit",
        "Direct coordination of tradespeople when needed",
      ],
      faq: [
        {
          q: "Which areas around Lucerne do you cover?",
          a: "Besides the city of Lucerne we look after properties across Central Switzerland – for example Kriens, Emmen, Horw, Meggen or along Lake Lucerne. From Zug we are quickly on site everywhere.",
        },
        {
          q: "What happens if you discover damage?",
          a: "You receive an immediate alert with photos and our assessment. Upon your approval we organise tradespeople, supervise the repair and document the resolution – you stay informed without having to act yourself.",
        },
      ],
    },
  },
  {
    slugDe: "key-holding-service-schweiz",
    slugEn: "key-holding-service-switzerland",
    service: "home-property-management",
    de: {
      metaTitle: "Key Holding Service Schweiz | Swiss PA Services",
      metaDesc: "Key Holding Service in der Schweiz: Sichere Schlüsselverwaltung, Zutritt für Handwerker & Behörden, Reaktion im Alarmfall – diskret & dokumentiert.",
      h1: "Key Holding Service in der Schweiz",
      h1Accent: "Ihre Schlüssel in sicheren Händen",
      intro: [
        "Wer eine Liegenschaft in der Schweiz besitzt, aber nicht dauerhaft hier lebt, kennt das Problem: Der Handwerker braucht Zutritt, die Behörde will ablesen, das Paket muss rein – und niemand hat einen Schlüssel. Unser Key Holding Service löst genau das.",
        "Wir verwahren Ihre Schlüssel sicher, organisieren Zutritte mit dokumentierten Protokollen und reagieren im Alarm- oder Notfall, wenn Sie es nicht können. Für Eigentümer in Zürich, Zug, Luzern, Genf, Lugano und den Bergregionen – diskret und in einer Hand.",
      ],
      bullets: [
        "Sichere, dokumentierte Schlüsselverwahrung",
        "Zutrittsorganisation für Handwerker & Lieferungen",
        "Begleitung von Behörden- & Ableseterminen",
        "Reaktion bei Alarm, Wasserschaden & Notfällen",
        "Protokoll zu jedem Zutritt – transparent für Sie",
        "Kombinierbar mit Home Watch & Property Management",
      ],
      faq: [
        {
          q: "Wie sind meine Schlüssel bei Ihnen gesichert?",
          a: "Schlüssel werden codiert und verschlossen verwahrt – ohne Adressanhänger. Jeder Zugriff wird protokolliert: wer, wann, wofür. Nur Ihre feste Ansprechsperson und deren Stellvertretung haben Zugriff.",
        },
        {
          q: "Was passiert im Alarm- oder Notfall?",
          a: "Sie hinterlegen uns einen Notfallplan mit Ihren Prioritäten. Im Ernstfall fahren wir vor Ort, verschaffen uns Lagebild, koordinieren Handwerker oder Behörden und halten Sie in Echtzeit auf dem Laufenden – mit Foto-Dokumentation.",
        },
        {
          q: "In welchen Regionen bieten Sie Key Holding an?",
          a: "Schwerpunkt sind Zürich, Zug, Luzern, Genf, Lugano sowie die Bergdestinationen Gstaad, St. Moritz, Verbier, Zermatt und Andermatt. Weitere Regionen auf Anfrage – sprechen Sie uns einfach an.",
        },
      ],
    },
    en: {
      metaTitle: "Key Holding Service Switzerland | Swiss PA Services",
      metaDesc: "Key holding service in Switzerland: secure key management, access for tradespeople & authorities, alarm response – discreet & documented.",
      h1: "Key holding service in Switzerland",
      h1Accent: "Your keys in safe hands",
      intro: [
        "Anyone who owns property in Switzerland but does not live here permanently knows the problem: the tradesperson needs access, the authority wants a meter reading, the parcel needs to go inside – and nobody has a key. Our key holding service solves exactly that.",
        "We store your keys securely, organise access with documented protocols and respond to alarms or emergencies when you cannot. For owners in Zurich, Zug, Lucerne, Geneva, Lugano and the Alpine regions – discreet and from one source.",
      ],
      bullets: [
        "Secure, documented key storage",
        "Access organisation for tradespeople & deliveries",
        "Accompanying authority & meter reading appointments",
        "Response to alarms, water damage & emergencies",
        "Protocol for every access – transparent for you",
        "Combinable with home watch & property management",
      ],
      faq: [
        {
          q: "How are my keys secured with you?",
          a: "Keys are stored coded and locked – with no address tags attached. Every access is logged: who, when, for what. Only your dedicated contact and their deputy have access.",
        },
        {
          q: "What happens in an alarm or emergency?",
          a: "You deposit an emergency plan with your priorities with us. In an emergency we go on site, assess the situation, coordinate tradespeople or authorities and keep you updated in real time – with photo documentation.",
        },
        {
          q: "In which regions do you offer key holding?",
          a: "Our focus is Zurich, Zug, Lucerne, Geneva, Lugano as well as the Alpine destinations Gstaad, St. Moritz, Verbier, Zermatt and Andermatt. Other regions on request – simply get in touch.",
        },
      ],
    },
  },
  {
    slugDe: "private-family-office-schweiz",
    slugEn: "private-family-office-switzerland",
    service: "executive-family-assistance",
    de: {
      metaTitle: "Private Family Office Schweiz | Swiss PA Services",
      metaDesc: "Ihr Private Family Office in der Schweiz: Private Affairs, Lifestyle & Family Management aus einer Hand – diskret, persönlich, langfristig.",
      h1: "Ihr Private Family Office in der Schweiz",
      h1Accent: "Private Affairs. Lifestyle. Family Management.",
      intro: [
        "Es gibt einen Punkt, an dem ein Kalender nicht mehr reicht: Residenzen an mehreren Orten, Hauspersonal, Schulfragen, Reisen, Anlässe, Dokumente – und niemand, der alles zusammenhält. Genau dafür ist unser Private Family Office in der Schweiz da: die zentrale Anlaufstelle für sämtliche privaten und familiären Organisationsaufgaben.",
        "Wir sind bewusst kein gewöhnlicher Concierge-Service: Als Private Family Office betreuen wir Ihr Privatleben mit höchstem Qualitätsanspruch – persönlich, diskret und langfristig. Eine feste Ansprechsperson, die Ihre Familie kennt, fünf Leistungsbereiche unter einem Dach, auf Wunsch mit Verschwiegenheitserklärung.",
      ],
      bullets: [
        "Private Family Management – Administration, Termine & laufende Koordination",
        "Property & Residence Management – Wohnsitze, Hauspersonal & Dienstleister",
        "Lifestyle & Concierge – Reisen, Erlebnisse, Events & persönliche Wünsche",
        "Family & Next Generation – Schulen, Wohnsitz, Relocation & Projekte",
        "Private Office Administration – Dokumente, Abläufe & externe Fachpersonen",
        "Eine feste Ansprechperson – diskret, langfristig, mit NDA-Standard",
      ],
      faq: [
        {
          q: "Für wen ist ein Private Family Office gedacht?",
          a: "Für Unternehmer, vermögende Familien und internationale Privatpersonen, deren Privatleben komplexer wird: mehrere Wohnsitze, Hauspersonal, Reisen, Kinder, Projekte. Überall dort, wo eine verlässliche zentrale Ansprechsperson mehr schafft als zwanzig einzelne Kontakte.",
        },
        {
          q: "Nehmen Sie auch einzelne Aufträge an oder nur langfristige Mandate?",
          a: "Beides ist möglich. Im Zentrum steht die langfristige Family-Office-Betreuung mit fester Ansprechperson. Einzelne Aufträge – etwa eine Relocation, eine Reise oder ein Anlass – sind ebenso willkommen und oft der Anfang einer längeren Zusammenarbeit.",
        },
      ],
    },
    en: {
      metaTitle: "Private Family Office Switzerland | Swiss PA Services",
      metaDesc: "Your private family office in Switzerland: private affairs, lifestyle & family management from one source – discreet, personal, long-term.",
      h1: "Your private family office in Switzerland",
      h1Accent: "Private Affairs. Lifestyle. Family Management.",
      intro: [
        "There comes a point when a calendar is no longer enough: residences in several locations, household staff, school questions, travel, occasions, documents – and nobody holding it all together. That is exactly what our private family office in Switzerland is for: the single point of contact for all private and family organisation.",
        "We are deliberately not an ordinary concierge service: as your private family office we look after your private life to the highest standard – personally, discreetly and for the long term. One dedicated contact who knows your family, five areas of service under one roof, NDA on request.",
      ],
      bullets: [
        "Private Family Management – administration, diaries & coordination",
        "Property & Residence Management – homes, staff & providers",
        "Lifestyle & Concierge – travel, experiences, events & personal wishes",
        "Family & Next Generation – schools, residence, relocation & projects",
        "Private Office Administration – documents, processes & external advisers",
        "One dedicated contact – discreet, long-term, NDA standard",
      ],
      faq: [
        {
          q: "Who is a private family office for?",
          a: "For entrepreneurs, wealthy families and international private individuals whose private lives are becoming more complex: several residences, household staff, travel, children, projects. Wherever one reliable central contact achieves more than twenty individual ones.",
        },
        {
          q: "Do you take single assignments or only long-term mandates?",
          a: "Both are possible. Our focus is long-term family office care with a dedicated contact. Single assignments – a relocation, a trip or an occasion – are equally welcome and often the beginning of a longer collaboration.",
        },
      ],
    },
  },
  {
    slugDe: "private-family-office-zug",
    slugEn: "private-family-office-zug",
    service: "executive-family-assistance",
    de: {
      metaTitle: "Private Family Office Zug | Swiss PA Services",
      metaDesc: "Ihr Private Family Office in Zug: Betreuung für Unternehmer & Familien im steuerattraktivsten Kanton – diskret, persönlich, von der Baarerstrasse 43.",
      h1: "Ihr Private Family Office in Zug",
      h1Accent: "Persönlich, diskret – mitten in Zug",
      intro: [
        "Zug zieht seit Jahren Unternehmer, Investoren und internationale Familien an: attraktive Steuern, höchste Lebensqualität, internationale Schulen – und eine Diskretion, die man anderswo suchen muss. Genau hier, an der Baarerstrasse 43, sitzt Swiss PA Services. Ihr Private Family Office ist bei uns nicht ein Konzept aus der Ferne, sondern Nachbarschaft.",
        "Wir betreuen Ihre privaten und familiären Angelegenheiten aus einer Hand: Residenzen, Hauspersonal, Reisen, Schulorganisation, Administration. Eine feste Ansprechsperson, die Zug kennt – von der Altstadt bis zum Zugerberg – und bei Bedarf innert Minuten bei Ihnen ist.",
      ],
      bullets: [
        "Private Family Management – Administration, Termine & Koordination",
        "Property & Residence Management – Wohnsitze, Hauspersonal & Dienstleister",
        "Lifestyle & Concierge – Reisen, Erlebnisse & persönliche Wünsche",
        "Family & Next Generation – Schulen, Wohnsitz & Relocation in Zug",
        "Private Office Administration – Dokumente, Abläufe & Fachpersonen",
        "Persönliche Nähe: vor Ort in Zug, innert Minuten bei Ihnen",
      ],
      faq: [
        {
          q: "Warum ziehen so viele vermögende Familien nach Zug?",
          a: "Zug verbindet steuerliche Attraktivität mit Sicherheit, exzellenten internationalen Schulen und zentraler Lage zwischen Zürich und Luzern. Viele unserer Kunden sind genau deshalb hier – und schätzen, dass ihre Ansprechsperson denselben Alltag kennt.",
        },
        {
          q: "Was kostet ein Private Family Office in Zug?",
          a: "Das richtet sich individuell nach Ihren Bedürfnissen: danach, welche Bereiche Ihres Privatlebens wir für Sie übernehmen und in welchem Umfang. Nach einem unverbindlichen Erstgespräch erhalten Sie eine klare, transparente Offerte – ohne versteckte Kosten.",
        },
      ],
    },
    en: {
      metaTitle: "Private Family Office Zug | Swiss PA Services",
      metaDesc: "Your private family office in Zug: care for entrepreneurs & families in Switzerland's most tax-friendly canton – discreet, personal, Baarerstrasse 43.",
      h1: "Your private family office in Zug",
      h1Accent: "Personal, discreet – right in Zug",
      intro: [
        "Zug has attracted entrepreneurs, investors and international families for years: attractive taxes, highest quality of life, international schools – and a discretion hard to find elsewhere. This is exactly where Swiss PA Services is based, at Baarerstrasse 43. With us, your private family office is not a remote concept, but a neighbour.",
        "We look after your private and family affairs from one source: residences, household staff, travel, school organisation, administration. One dedicated contact who knows Zug – from the old town to the Zugerberg – and can be with you within minutes when needed.",
      ],
      bullets: [
        "Private Family Management – administration, diaries & coordination",
        "Property & Residence Management – homes, staff & providers",
        "Lifestyle & Concierge – travel, experiences & personal wishes",
        "Family & Next Generation – schools, residence & relocation in Zug",
        "Private Office Administration – documents, processes & advisers",
        "Personal proximity: on site in Zug, with you within minutes",
      ],
      faq: [
        {
          q: "Why do so many wealthy families move to Zug?",
          a: "Zug combines tax attractiveness with safety, excellent international schools and a central location between Zurich and Lucerne. Many of our clients are here for exactly that reason – and appreciate that their contact knows the same everyday life.",
        },
        {
          q: "What does a private family office in Zug cost?",
          a: "That depends individually on your needs: on which areas of your private life we take over for you and to what extent. After a non-binding first conversation you receive a clear, transparent proposal – with no hidden costs.",
        },
      ],
    },
  },
  {
    slugDe: "private-family-office-zuerich",
    slugEn: "private-family-office-zurich",
    service: "executive-family-assistance",
    de: {
      metaTitle: "Private Family Office Zürich | Swiss PA Services",
      metaDesc: "Private Family Office in Zürich: diskrete Betreuung für Unternehmer & Familien – Residenzen, Personal, Lifestyle & Administration aus einer Hand.",
      h1: "Ihr Private Family Office in Zürich",
      h1Accent: "Persönlich, diskret – von der City bis zur Goldküste",
      intro: [
        "Zürich ist das wirtschaftliche Herz der Schweiz – und eine Stadt, in der private Komplexität schnell wächst: die Residenz am Zürichberg, das Pied-à-terre im Seefeld, Hauspersonal, Schulen, Reisen, Anlässe. Ihr Private Family Office in Zürich hält all das zusammen, während Sie sich auf Ihr Geschäft konzentrieren.",
        "Von Zug aus sind wir in 25 Minuten in der City: Wir betreuen Familien in Zürich und entlang der Goldküste – von Küsnacht bis Zollikon – mit einer festen Ansprechsperson, die Ihre Abläufe kennt und Ihre Privatsphäre schützt. Auf Deutsch und Englisch, auf Wunsch mit Verschwiegenheitserklärung.",
      ],
      bullets: [
        "Private Family Management – Administration, Termine & Koordination",
        "Property & Residence Management – Wohnsitze am Zürichsee & Personal",
        "Lifestyle & Concierge – Reservationen, Reisen & Events in Zürich",
        "Family & Next Generation – Schulen, Wohnsitz & Projekte",
        "Private Office Administration – Dokumente, Abläufe & Fachpersonen",
        "Schnittstelle zu Ihren bestehenden Strukturen & Beratern",
      ],
      faq: [
        {
          q: "In welchen Zürcher Quartieren sind Sie tätig?",
          a: "Überall dort, wo unsere Kunden leben: Zürichberg, Seefeld, Enge, die Altstadt – und entlang der Goldküste von Küsnacht über Herrliberg bis Zollikon. Auch linksufrig, etwa in Thalwil oder Horgen, sind wir regelmässig vor Ort.",
        },
        {
          q: "Wie arbeiten Sie mit unseren bestehenden Beratern zusammen?",
          a: "Nahtlos: Wir übernehmen die private Seite Ihres Alltags und koordinieren auf Wunsch die Termine und Übergaben mit Ihren bestehenden Fachpersonen – vom Treuhänder bis zum Anwalt. Sie haben eine Ansprechperson, wir halten die Fäden zusammen.",
        },
      ],
    },
    en: {
      metaTitle: "Private Family Office Zurich | Swiss PA Services",
      metaDesc: "Private family office in Zurich: discreet care for entrepreneurs & families – residences, staff, lifestyle & administration from one source.",
      h1: "Your private family office in Zurich",
      h1Accent: "Personal, discreet – from the city to the Gold Coast",
      intro: [
        "Zurich is the economic heart of Switzerland – and a city where private complexity grows fast: the residence on Zürichberg, the pied-à-terre in Seefeld, household staff, schools, travel, occasions. Your private family office in Zurich holds all of this together while you focus on your business.",
        "From Zug we are in the city in 25 minutes: we look after families in Zurich and along the Gold Coast – from Küsnacht to Zollikon – with a dedicated contact who knows your routines and protects your privacy. In German and English, NDA on request.",
      ],
      bullets: [
        "Private Family Management – administration, diaries & coordination",
        "Property & Residence Management – Lake Zurich homes & staff",
        "Lifestyle & Concierge – reservations, travel & events in Zurich",
        "Family & Next Generation – schools, residence & projects",
        "Private Office Administration – documents, processes & advisers",
        "Interface to your existing structures & advisers",
      ],
      faq: [
        {
          q: "Which Zurich neighbourhoods do you work in?",
          a: "Wherever our clients live: Zürichberg, Seefeld, Enge, the old town – and along the Gold Coast from Küsnacht via Herrliberg to Zollikon. We are also regularly on site on the left shore, for example in Thalwil or Horgen.",
        },
        {
          q: "How do you cooperate with our existing advisers?",
          a: "Seamlessly: we take over the private side of your daily life and, on request, coordinate appointments and handovers with your existing professionals – from the trustee to the lawyer. You have one contact; we hold the threads together.",
        },
      ],
    },
  },
  {
    slugDe: "private-family-office-genf",
    slugEn: "private-family-office-geneva",
    service: "executive-family-assistance",
    de: {
      metaTitle: "Private Family Office Genf | Swiss PA Services",
      metaDesc: "Private Family Office in Genf: Betreuung internationaler Familien – Residenzen, Schulen, Lifestyle & Administration. auf Englisch & Französisch.",
      h1: "Ihr Private Family Office in Genf",
      h1Accent: "International wie die Stadt selbst",
      intro: [
        "Genf ist die Heimat internationaler Organisationen, Banken und Familien aus aller Welt. Wer hier lebt, bewegt sich zwischen Sprachen, Kulturen und Zeitzonen – vom Anwesen in Cologny bis zum Apartment am Quai du Mont-Blanc. Ihr Private Family Office in Genf bringt Ordnung in genau dieses Leben.",
        "Sie kommunizieren mit uns auf Englisch oder Französisch – wir koordinieren Ihre Anliegen im französischsprachigen Umfeld: Behörden, Schulen, Hauspersonal, Dienstleister. Eine feste Ansprechsperson, die internationale Lebensläufe versteht und Genf kennt.",
      ],
      bullets: [
        "Private Family Management – Administration, Termine & Koordination",
        "Property & Residence Management – Anwesen & Hauspersonal in Genf",
        "Lifestyle & Concierge – Reisen ab GVA, Events & Kultur",
        "Family & Next Generation – internationale Schulen & Wohnsitz",
        "Private Office Administration – Dokumente, Abläufe & Fachpersonen",
        "Koordination im französischsprachigen Umfeld inklusive",
      ],
      faq: [
        {
          q: "Betreuen Sie auch Familien, die nur zeitweise in Genf leben?",
          a: "Ja, das ist in Genf der Normalfall: Viele unserer Kunden leben zwischen mehreren Ländern. Wir halten Residenz, Personal und Administration bereit – egal ob Sie drei oder dreihundert Tage im Jahr in Genf sind.",
        },
        {
          q: "Funktioniert die Betreuung im französischsprachigen Umfeld?",
          a: "Vollständig. Wir sprechen mit Ihnen Englisch oder Französisch und koordinieren alles Weitere direkt auf Französisch: von der Präfektur über die Schule bis zum Hauspersonal. Sprachbarrieren bleiben aussen vor.",
        },
      ],
    },
    en: {
      metaTitle: "Private Family Office Geneva | Swiss PA Services",
      metaDesc: "Private family office in Geneva: care for international families & diplomats – residences, schools, lifestyle & administration. in English & French.",
      h1: "Your private family office in Geneva",
      h1Accent: "As international as the city itself",
      intro: [
        "Geneva is home to international organisations, banks and families from all over the world. Living here means moving between languages, cultures and time zones – from the estate in Cologny to the apartment on Quai du Mont-Blanc. Your private family office in Geneva brings order to exactly this life.",
        "You communicate with us in English or French – we coordinate your affairs in the French-speaking environment: authorities, schools, household staff, service providers. One dedicated contact who understands international careers and knows Geneva.",
      ],
      bullets: [
        "Private Family Management – administration, diaries & coordination",
        "Property & Residence Management – estates & staff in Geneva",
        "Lifestyle & Concierge – travel from GVA, events & culture",
        "Family & Next Generation – international schools & residence",
        "Private Office Administration – documents, processes & advisers",
        "Coordination in the French-speaking environment included",
      ],
      faq: [
        {
          q: "Do you also look after families who only live in Geneva part-time?",
          a: "Yes, that is the norm in Geneva: many of our clients live between several countries. We keep residence, staff and administration ready – whether you spend three or three hundred days a year in Geneva.",
        },
        {
          q: "Does the care work in the French-speaking environment?",
          a: "Completely. We speak with you in English or French and coordinate everything else in French: from the prefecture to the school to the household staff. Language barriers stay outside.",
        },
      ],
    },
  },
  {
    slugDe: "private-family-office-lugano",
    slugEn: "private-family-office-lugano",
    service: "executive-family-assistance",
    de: {
      metaTitle: "Private Family Office Lugano | Swiss PA Services",
      metaDesc: "Private Family Office in Lugano: Betreuung für Familien & Zweitwohnsitz-Besitzer im Tessin – Residenzen, Personal, Lifestyle & Administration.",
      h1: "Ihr Private Family Office in Lugano",
      h1Accent: "Dolce Vita, schweizerisch organisiert",
      intro: [
        "Lugano verbindet wie kaum ein Ort mediterrane Lebensart mit schweizerischer Verlässlichkeit: die Villa am Collina d'Oro, das Boot auf dem Lago, Mailand vor der Haustür. Viele unserer Kunden leben hier saisonal oder im Wechsel mit einem anderen Wohnsitz – genau dafür ist Ihr Private Family Office in Lugano gebaut.",
        "Wir betreuen Residenz, Personal und Ihren Alltag im Tessin aus einer Hand: von der Vorbereitung Ihrer Ankunft über die laufende Administration bis zu Reisen ab Agno oder Mailand Malpensa. Eine feste Ansprechsperson auf Deutsch oder Englisch – die Erledigungen vor Ort koordinieren wir auf Italienisch.",
      ],
      bullets: [
        "Private Family Management – Administration, Termine & Koordination",
        "Property & Residence Management – Villa, Personal & Dienstleister",
        "Lifestyle & Concierge – See, Ristoranti & Reisen ab MXP/Agno",
        "Family & Next Generation – Schulen, Wohnsitz & Projekte im Tessin",
        "Private Office Administration – Dokumente, Abläufe & Fachpersonen",
        "Zweitwohnsitz-Betreuung während Ihrer Abwesenheit",
      ],
      faq: [
        {
          q: "Betreuen Sie auch Zweitwohnsitze im Tessin?",
          a: "Ja, das ist ein Schwerpunkt in Lugano: Wir bereiten Ihre Residenz vor jeder Ankunft vor, koordinieren Personal und Dienstleister während Ihrer Abwesenheit und sorgen dafür, dass Ihr Aufenthalt vom ersten Tag an Erholung ist.",
        },
        {
          q: "In welchen Sprachen arbeiten Sie in Lugano?",
          a: "Mit Ihnen kommunizieren wir auf Deutsch oder Englisch. Für alles Vor-Ortliche – Gemeinde, Handwerker, Personal, Lieferanten – koordinieren wir auf Italienisch. Sie bekommen davon nur das Ergebnis mit, nicht die Übersetzungsarbeit.",
        },
      ],
    },
    en: {
      metaTitle: "Private Family Office Lugano | Swiss PA Services",
      metaDesc: "Private family office in Lugano: care for families & second home owners in Ticino – residences, staff, lifestyle & administration.",
      h1: "Your private family office in Lugano",
      h1Accent: "Dolce vita, organised the Swiss way",
      intro: [
        "Lugano combines Mediterranean lifestyle with Swiss reliability like few places: the villa on Collina d'Oro, the boat on the lake, Milan on your doorstep. Many of our clients live here seasonally or alternating with another residence – your private family office in Lugano is built for exactly that.",
        "We look after residence, staff and your daily life in Ticino from one source: from preparing your arrival to ongoing administration to travel from Agno or Milan Malpensa. One dedicated contact in English or German – we coordinate local errands in Italian.",
      ],
      bullets: [
        "Private Family Management – administration, diaries & coordination",
        "Property & Residence Management – villa, staff & providers",
        "Lifestyle & Concierge – lake, ristoranti & travel from MXP/Agno",
        "Family & Next Generation – schools, residence & projects in Ticino",
        "Private Office Administration – documents, processes & advisers",
        "Second home care during your absence",
      ],
      faq: [
        {
          q: "Do you also look after second homes in Ticino?",
          a: "Yes, that is a focus in Lugano: we prepare your residence before every arrival, coordinate staff and service providers during your absence and make sure your stay is relaxation from day one.",
        },
        {
          q: "In which languages do you work in Lugano?",
          a: "We communicate with you in English or German. For everything local – municipality, tradespeople, staff, suppliers – we coordinate in Italian. You only see the result, not the translation work.",
        },
      ],
    },
  },
  {
    slugDe: "private-family-office-luzern",
    slugEn: "private-family-office-lucerne",
    service: "executive-family-assistance",
    de: {
      metaTitle: "Private Family Office Luzern | Swiss PA Services",
      metaDesc: "Ihr Private Family Office in Luzern: Betreuung für Familien & Unternehmer in der Zentralschweiz – Residenzen, Personal, Lifestyle & Administration.",
      h1: "Ihr Private Family Office in Luzern",
      h1Accent: "Persönlich, diskret – am Vierwaldstättersee",
      intro: [
        "Luzern lebt ruhiger als Zürich und Genf – und genau das schätzen die Familien, die hier leben: die Residenz am See, der Blick auf Rigi und Pilatus, kurze Wege, hohe Privatsphäre. Ihr Private Family Office in Luzern sorgt dafür, dass dieses Leben mühelos bleibt – vom Haushalt über die Reiseplanung bis zur Schulorganisation.",
        "Von unserem Sitz in Zug aus sind wir in 25 Minuten bei Ihnen: nah genug für den persönlichen Besuch, erfahren genug für diskrete Mandate. Eine feste Ansprechsperson, die die Zentralschweiz kennt – von der Altstadt bis Kastanienbaum, von Meggen bis ins Entlebuch.",
      ],
      bullets: [
        "Private Family Management – Administration, Termine & Koordination",
        "Property & Residence Management – Wohnsitze, Hauspersonal & Dienstleister",
        "Lifestyle & Concierge – KKL, Festivals, Reisen & persönliche Wünsche",
        "Family & Next Generation – Schulen, Wohnsitz & Projekte",
        "Private Office Administration – Dokumente, Abläufe & Fachpersonen",
        "Persönliche Nähe: von Zug aus in 25 Minuten bei Ihnen",
      ],
      faq: [
        {
          q: "Sind Sie auch kurzfristig in Luzern vor Ort?",
          a: "Ja. Von Zug aus erreichen wir Luzern in rund 25 Minuten – ob die Koordination von Hauspersonal, die Vorbereitung Ihrer Residenz vor Ihrer Ankunft oder ein kurzfristiger Termin: Nähe ist bei uns kein Versprechen, sondern Alltag.",
        },
        {
          q: "Was kostet ein Private Family Office in Luzern?",
          a: "Das richtet sich individuell nach Ihren Bedürfnissen: danach, welche Bereiche Ihres Privatlebens wir für Sie übernehmen und in welchem Umfang. Nach einem unverbindlichen Erstgespräch erhalten Sie eine klare, transparente Offerte – ohne versteckte Kosten.",
        },
      ],
    },
    en: {
      metaTitle: "Private Family Office Lucerne | Swiss PA Services",
      metaDesc: "Your private family office in Lucerne: care for families & entrepreneurs in Central Switzerland – residences, staff, lifestyle & administration.",
      h1: "Your private family office in Lucerne",
      h1Accent: "Personal, discreet – on Lake Lucerne",
      intro: [
        "Lucerne lives more quietly than Zurich and Geneva – and that is exactly what the families who live here appreciate: the residence by the lake, the view of Rigi and Pilatus, short distances, high privacy. Your private family office in Lucerne makes sure this life stays effortless – from the household to travel planning to school organisation.",
        "From our base in Zug we are with you in 25 minutes: close enough for a personal visit, experienced enough for discreet mandates. One dedicated contact who knows Central Switzerland – from the old town to Kastanienbaum, from Meggen to the Entlebuch.",
      ],
      bullets: [
        "Private Family Management – administration, diaries & coordination",
        "Property & Residence Management – homes, staff & providers",
        "Lifestyle & Concierge – KKL, festivals, travel & personal wishes",
        "Family & Next Generation – schools, residence & projects",
        "Private Office Administration – documents, processes & advisers",
        "Personal proximity: with you in 25 minutes from Zug",
      ],
      faq: [
        {
          q: "Can you be on site in Lucerne at short notice?",
          a: "Yes. From Zug we reach Lucerne in about 25 minutes – whether coordinating household staff, preparing your residence before your arrival or a last-minute appointment: proximity is not a promise for us, but everyday life.",
        },
        {
          q: "What does a private family office in Lucerne cost?",
          a: "That depends individually on your needs: on which areas of your private life we take over for you and to what extent. After a non-binding first conversation you receive a clear, transparent proposal – with no hidden costs.",
        },
      ],
    },
  },
];

export const findKeywordPage = (slug) =>
  keywordPages.find((p) => p.slugDe === slug || p.slugEn === slug);

export default keywordPages;
